// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --background: 255, 255, 255;
  --foreground: 28, 28, 35;
  --icon: 221, 0%, 10%;
  --icon-dark: 221, 0%, 10%;
  --icon-gray: 221, 0%, 90%;
  --black-7: 0, 0, 0;
  --black-6: 16, 16, 16;
  --black-5: 54, 61, 77;
  --black-4: 102, 102, 104;
  --black-3: 149, 149, 151;
  --black-2: 173, 173, 175;
  --black-1: 220, 220, 222;
  --white-6: 209, 209, 211;
  --white-5: 219, 219, 220;
  --white-4: 228, 228, 230;
  --white-3: 238, 238, 239;
  --white-2: 248, 248, 248;
  --white-1: 255, 255, 255;
  --coze-fg-revert: 255, 255, 255;
  --coze-fg-white: 255, 255, 255;
  --coze-fg-7: 255, 255, 255;
  --coze-fg-6: 255, 255, 255;
  --coze-fg-5: 255, 255, 255;
  --coze-fg-4: 8, 13, 30;
  --coze-fg-3: 15, 21, 40;
  --coze-fg-2: 32, 41, 69;
  --coze-fg-1: 55, 67, 106;
  --coze-bg-9: 6, 7, 9;
  --coze-bg-8: 68, 83, 130;
  --coze-bg-7: 75, 90, 140;
  --coze-bg-6: 82, 100, 154;
  --coze-bg-5: 87, 104, 161;
  --coze-bg-4: 90, 108, 167;
  --coze-bg-3: 255, 255, 255;
  --coze-bg-2: 252, 252, 255;
  --coze-bg-1: 247, 247, 252;
  --coze-bg-0: 240, 240, 247;
  --coze-stroke-5: 82, 100, 154;
  --coze-stroke-6: 68, 83, 130;
  --coze-stroke-7: 55, 67, 106;
  --coze-stroke-opaque: 226, 228, 239;
  --coze-mask-5: 0, 0, 0;
  --coze-shadow-0: 0, 0, 0;
  --coze-brand-50: 102, 108, 255;
  --coze-brand-30: 163, 166, 255;
  --coze-brand-7: 65, 43, 255;
  --coze-brand-6: 69, 56, 255;
  --coze-brand-5: 81, 71, 255;
  --coze-brand-3: 150, 159, 255;
  --coze-brand-2: 161, 170, 255;
  --coze-brand-1: 171, 181, 255;
  --coze-brand-0: 181, 191, 255;
  --coze-red-7: 222, 22, 39;
  --coze-red-6: 227, 36, 52;
  --coze-red-5: 229, 50, 65;
  --coze-red-3: 250, 138, 148;
  --coze-red-2: 252, 149, 157;
  --coze-red-1: 255, 163, 171;
  --coze-red-0: 255, 173, 180;
  --coze-yellow-50: 242, 182, 0;
  --coze-yellow-30: 245, 184, 0;
  --coze-yellow-7: 229, 104, 0;
  --coze-yellow-6: 242, 109, 0;
  --coze-yellow-5: 255, 115, 0;
  --coze-yellow-3: 242, 161, 94;
  --coze-yellow-2: 242, 169, 109;
  --coze-yellow-1: 240, 174, 120;
  --coze-yellow-0: 239, 179, 130;
  --coze-green-7: 0, 161, 54;
  --coze-green-6: 0, 168, 56;
  --coze-green-5: 0, 178, 60;
  --coze-green-3: 79, 201, 120;
  --coze-green-2: 93, 207, 131;
  --coze-green-1: 105, 209, 140;
  --coze-green-0: 116, 212, 149;
  --coze-orange-5: 199, 66, 0;
  --coze-orange-3: 242, 148, 65;
  --coze-emerald-5: 0, 128, 74;
  --coze-emerald-3: 41, 204, 114;
  --coze-emerald-50: 0, 184, 122;
  --coze-emerald-30: 54, 209, 158;
  --coze-emerald-20: 66, 214, 165;
  --coze-emerald-10: 103, 229, 188;
  --coze-cyan-5: 0, 124, 135;
  --coze-cyan-3: 47, 196, 189;
  --coze-cyan-50: 0, 163, 163;
  --coze-cyan-30: 62, 199, 199;
  --coze-cyan-20: 73, 204, 204;
  --coze-cyan-10: 84, 209, 209;
  --coze-blue-5: 43, 87, 217;
  --coze-blue-3: 120, 170, 250;
  --coze-blue-50: 61, 121, 242;
  --coze-blue-30: 131, 172, 252;
  --coze-blue-20: 141, 178, 252;
  --coze-blue-10: 153, 187, 255;
  --coze-purple-7: 148, 0, 222;
  --coze-purple-6: 157, 0, 235;
  --coze-purple-5: 167, 0, 250;
  --coze-purple-3: 213, 128, 255;
  --coze-purple-2: 218, 145, 255;
  --coze-purple-1: 224, 163, 255;
  --coze-purple-50: 192, 66, 255;
  --coze-purple-30: 217, 143, 255;
  --coze-purple-20: 221, 153, 255;
  --coze-purple-10: 224, 163, 255;
  --coze-magenta-5: 209, 0, 157;
  --coze-magenta-3: 245, 120, 197;
  --coze-magenta-50: 242, 48, 177;
  --coze-magenta-30: 252, 134, 213;
  --coze-magenta-20: 252, 144, 216;
  --coze-magenta-10: 255, 158, 222;
  --coze-alternative-50: 191, 229, 0;
  --coze-alternative-30: 175, 209, 0;
  --coze-1080: 1080px;
  --coze-800: 800px;
  --coze-640: 640px;
  --coze-480: 480px;
  --coze-320: 320px;
  --coze-240: 240px;
  --coze-200: 200px;
  --coze-160: 160px;
  --coze-120: 120px;
  --coze-96: 96px;
  --coze-80: 80px;
  --coze-64: 64px;
  --coze-48: 48px;
  --coze-40: 40px;
  --coze-38: 38px;
  --coze-36: 36px;
  --coze-32: 32px;
  --coze-30: 30px;
  --coze-28: 28px;
  --coze-26: 26px;
  --coze-24: 24px;
  --coze-22: 22px;
  --coze-20: 20px;
  --coze-18: 18px;
  --coze-16: 16px;
  --coze-15: 15px;
  --coze-14: 14px;
  --coze-12: 12px;
  --coze-10: 10px;
  --coze-9: 9px;
  --coze-8: 8px;
  --coze-6: 6px;
  --coze-5: 5px;
  --coze-4: 4px;
  --coze-3: 3px;
  --coze-2: 2px;
  --coze-1: 1px;
  --coze-0-5: .5px;
  --coze-fg-1-alpha: .38;
  --coze-fg-2-alpha: .62;
  --coze-fg-3-alpha: .82;
  --coze-fg-4-alpha: .9;
  --coze-fg-5-alpha: 1;
  --coze-fg-6-alpha: 1;
  --coze-fg-7-alpha: 1;
  --coze-fg-revert-alpha: 1;
  --coze-fg-white-alpha: 1;
  --coze-bg-0-alpha: 1;
  --coze-bg-1-alpha: 1;
  --coze-bg-2-alpha: 1;
  --coze-bg-3-alpha: 1;
  --coze-bg-4-alpha: .04;
  --coze-bg-5-alpha: .08;
  --coze-bg-6-alpha: .13;
  --coze-bg-7-alpha: .19;
  --coze-bg-8-alpha: .25;
  --coze-bg-9-alpha: .16;
  --coze-stroke-5-alpha: .13;
  --coze-stroke-6-alpha: .25;
  --coze-stroke-7-alpha: .38;
  --coze-brand-0-alpha: .23;
  --coze-brand-1-alpha: .3;
  --coze-brand-2-alpha: .38;
  --coze-brand-3-alpha: .45;
  --coze-brand-5-alpha: 1;
  --coze-brand-6-alpha: 1;
  --coze-brand-7-alpha: 1;
  --coze-brand-30-alpha: .45;
  --coze-brand-50-alpha: 1;
  --coze-red-0-alpha: .23;
  --coze-red-1-alpha: .3;
  --coze-red-2-alpha: .38;
  --coze-red-3-alpha: .45;
  --coze-yellow-50-alpha: 1;
  --coze-yellow-30-alpha: .45;
  --coze-yellow-0-alpha: .23;
  --coze-yellow-1-alpha: .3;
  --coze-yellow-2-alpha: .38;
  --coze-yellow-3-alpha: .45;
  --coze-yellow-5-alpha: 1;
  --coze-yellow-6-alpha: 1;
  --coze-yellow-7-alpha: 1;
  --coze-green-0-alpha: .23;
  --coze-green-1-alpha: .3;
  --coze-green-2-alpha: .38;
  --coze-green-3-alpha: .45;
  --coze-green-5-alpha: 1;
  --coze-green-6-alpha: 1;
  --coze-green-7-alpha: 1;
  --coze-orange-5-alpha: 1;
  --coze-orange-3-alpha: .45;
  --coze-emerald-5-alpha: 1;
  --coze-emerald-3-alpha: .45;
  --coze-emerald-50-alpha: 1;
  --coze-emerald-30-alpha: .55;
  --coze-emerald-20-alpha: .45;
  --coze-emerald-10-alpha: .2;
  --coze-cyan-5-alpha: 1;
  --coze-cyan-3-alpha: .45;
  --coze-cyan-50-alpha: 1;
  --coze-cyan-30-alpha: .45;
  --coze-cyan-20-alpha: .38;
  --coze-cyan-10-alpha: .3;
  --coze-blue-5-alpha: 1;
  --coze-blue-3-alpha: .45;
  --coze-blue-50-alpha: 1;
  --coze-blue-30-alpha: .45;
  --coze-blue-20-alpha: .38;
  --coze-blue-10-alpha: .3;
  --coze-purple-7-alpha: 1;
  --coze-purple-6-alpha: 1;
  --coze-purple-5-alpha: 1;
  --coze-purple-3-alpha: .45;
  --coze-purple-2-alpha: .38;
  --coze-purple-1-alpha: .3;
  --coze-purple-50-alpha: 1;
  --coze-purple-30-alpha: .45;
  --coze-purple-20-alpha: .38;
  --coze-purple-10-alpha: .3;
  --coze-magenta-5-alpha: 1;
  --coze-magenta-3-alpha: .45;
  --coze-magenta-50-alpha: 1;
  --coze-magenta-30-alpha: .45;
  --coze-magenta-20-alpha: .38;
  --coze-magenta-10-alpha: .3;
  --coze-alternative-30-alpha: .45;
  --coze-alternative-50-alpha: 1;
}

.dark {
  --background: 2, 8, 23;
  --foreground: 249, 249, 249;
  --icon: 221, 0%, 90%;
  --icon-dark: 221, 0%, 10%;
  --icon-gray: 221, 0%, 100%;
  --coze-fg-revert: 0, 0, 0;
  --coze-fg-white: 255, 255, 255;
  --coze-fg-7: 255, 255, 255;
  --coze-fg-6: 0, 0, 0;
  --coze-fg-5: 0, 0, 0;
  --coze-fg-4: 255, 255, 255;
  --coze-fg-3: 255, 255, 255;
  --coze-fg-2: 255, 255, 255;
  --coze-fg-1: 255, 255, 255;
  --coze-bg-9: 255, 255, 255;
  --coze-bg-8: 237, 240, 255;
  --coze-bg-7: 237, 240, 255;
  --coze-bg-6: 237, 240, 255;
  --coze-bg-5: 241, 243, 255;
  --coze-bg-4: 241, 243, 255;
  --coze-bg-3: 39, 43, 58;
  --coze-bg-2: 28, 32, 48;
  --coze-bg-1: 24, 28, 43;
  --coze-bg-0: 20, 24, 37;
  --coze-stroke-5: 153, 182, 255;
  --coze-stroke-6: 153, 182, 255;
  --coze-stroke-7: 233, 237, 255;
  --coze-stroke-opaque: 41, 45, 60;
  --coze-mask-5: 0, 0, 0;
  --coze-shadow-0: 0, 0, 0;
  --coze-brand-50: 85, 91, 255;
  --coze-brand-30: 66, 88, 255;
  --coze-brand-7: 194, 194, 255;
  --coze-brand-6: 184, 184, 255;
  --coze-brand-5: 166, 166, 255;
  --coze-brand-3: 94, 94, 255;
  --coze-brand-2: 89, 89, 255;
  --coze-brand-1: 76, 76, 255;
  --coze-brand-0: 76, 76, 255;
  --coze-red-7: 255, 97, 110;
  --coze-red-6: 255, 82, 96;
  --coze-red-5: 255, 38, 56;
  --coze-red-3: 245, 37, 54;
  --coze-red-2: 245, 37, 54;
  --coze-red-1: 242, 36, 53;
  --coze-yellow-50: 255, 191, 0;
  --coze-yellow-30: 156, 117, 0;
  --coze-yellow-7: 255, 161, 84;
  --coze-yellow-6: 255, 148, 61;
  --coze-yellow-5: 255, 122, 13;
  --coze-yellow-3: 194, 88, 2;
  --coze-yellow-2: 191, 87, 2;
  --coze-yellow-1: 178, 80, 0;
  --coze-green-7: 0, 219, 69;
  --coze-green-6: 0, 209, 66;
  --coze-green-5: 0, 191, 64;
  --coze-green-3: 0, 133, 53;
  --coze-green-2: 0, 128, 51;
  --coze-green-1: 0, 122, 41;
  --coze-orange-5: 251, 173, 115;
  --coze-orange-3: 199, 93, 18;
  --coze-emerald-5: 48, 242, 161;
  --coze-emerald-3: 6, 140, 102;
  --coze-emerald-50: 0, 191, 128;
  --coze-emerald-30: 0, 133, 88;
  --coze-emerald-20: 0, 128, 85;
  --coze-emerald-10: 0, 115, 76;
  --coze-cyan-5: 57, 215, 229;
  --coze-cyan-3: 8, 130, 163;
  --coze-cyan-50: 0, 170, 204;
  --coze-cyan-30: 0, 125, 150;
  --coze-cyan-20: 0, 121, 145;
  --coze-cyan-10: 0, 110, 133;
  --coze-blue-5: 120, 176, 255;
  --coze-blue-3: 60, 111, 229;
  --coze-blue-50: 64, 128, 255;
  --coze-blue-30: 23, 100, 255;
  --coze-blue-20: 18, 97, 255;
  --coze-blue-10: 8, 91, 255;
  --coze-purple-7: 233, 189, 255;
  --coze-purple-6: 229, 176, 255;
  --coze-purple-5: 221, 153, 255;
  --coze-purple-3: 189, 56, 255;
  --coze-purple-2: 187, 51, 255;
  --coze-purple-1: 181, 33, 255;
  --coze-purple-50: 202, 97, 255;
  --coze-purple-30: 185, 46, 255;
  --coze-purple-20: 184, 41, 255;
  --coze-purple-10: 180, 31, 255;
  --coze-magenta-5: 255, 148, 210;
  --coze-magenta-3: 250, 30, 188;
  --coze-magenta-50: 255, 77, 195;
  --coze-magenta-30: 255, 15, 175;
  --coze-magenta-20: 255, 10, 173;
  --coze-magenta-10: 255, 0, 169;
  --coze-alternative-50: 202, 242, 0;
  --coze-alternative-30: 111, 133, 0;
  --coze-fg-1-alpha: .22;
  --coze-fg-2-alpha: .39;
  --coze-fg-3-alpha: .79;
  --coze-fg-4-alpha: 1;
  --coze-fg-5-alpha: 1;
  --coze-fg-6-alpha: .22;
  --coze-fg-7-alpha: 1;
  --coze-fg-revert-alpha: 1;
  --coze-fg-white-alpha: .22;
  --coze-bg-0-alpha: 1;
  --coze-bg-1-alpha: 1;
  --coze-bg-2-alpha: 1;
  --coze-bg-3-alpha: 1;
  --coze-bg-4-alpha: .02;
  --coze-bg-5-alpha: .05;
  --coze-bg-6-alpha: .08;
  --coze-bg-7-alpha: .11;
  --coze-bg-8-alpha: .14;
  --coze-bg-9-alpha: .17;
  --coze-stroke-5-alpha: .12;
  --coze-stroke-6-alpha: .17;
  --coze-stroke-7-alpha: .21;
  --coze-brand-0-alpha: .2;
  --coze-brand-1-alpha: .2;
  --coze-brand-2-alpha: .32;
  --coze-brand-3-alpha: .37;
  --coze-brand-30-alpha: .41;
  --coze-brand-50-alpha: 1;
  --coze-red-1-alpha: .2;
  --coze-red-2-alpha: .33;
  --coze-red-3-alpha: .39;
  --coze-yellow-50-alpha: 1;
  --coze-yellow-30-alpha: .36;
  --coze-yellow-1-alpha: .2;
  --coze-yellow-2-alpha: .32;
  --coze-yellow-3-alpha: .37;
  --coze-green-1-alpha: .2;
  --coze-green-2-alpha: .34;
  --coze-green-3-alpha: .39;
  --coze-orange-3-alpha: .36;
  --coze-orange-5-alpha: .36;
  --coze-emerald-5-alpha: 1;
  --coze-emerald-3-alpha: .35;
  --coze-emerald-50-alpha: 1;
  --coze-emerald-30-alpha: .38;
  --coze-emerald-20-alpha: .33;
  --coze-emerald-10-alpha: .2;
  --coze-cyan-5-alpha: 1;
  --coze-cyan-3-alpha: .36;
  --coze-cyan-50-alpha: 1;
  --coze-cyan-30-alpha: .39;
  --coze-cyan-20-alpha: .33;
  --coze-cyan-10-alpha: .2;
  --coze-blue-5-alpha: 1;
  --coze-blue-3-alpha: .37;
  --coze-blue-50-alpha: 1;
  --coze-blue-30-alpha: .4;
  --coze-blue-20-alpha: .34;
  --coze-blue-10-alpha: .2;
  --coze-purple-7-alpha: 1;
  --coze-purple-6-alpha: 1;
  --coze-purple-5-alpha: 1;
  --coze-purple-3-alpha: .36;
  --coze-purple-2-alpha: .31;
  --coze-purple-1-alpha: .2;
  --coze-purple-50-alpha: 1;
  --coze-purple-30-alpha: .38;
  --coze-purple-20-alpha: .33;
  --coze-purple-10-alpha: .2;
  --coze-magenta-5-alpha: 1;
  --coze-magenta-3-alpha: .35;
  --coze-magenta-50-alpha: 1;
  --coze-magenta-30-alpha: .36;
  --coze-magenta-20-alpha: .31;
  --coze-magenta-10-alpha: .2;
  --coze-alternative-30-alpha: .34;
}

:root {
  --coz-fg-hglt-plus: rgba(var(--coze-fg-5), var(--coze-fg-5-alpha));
  --coz-fg-hglt-plus-dim: rgba(var(--coze-fg-5), var(--coze-fg-5-alpha));
  --coz-fg-hglt: rgba(var(--coze-up-brand-9), 1);
  --coz-fg-hglt-dim: rgba(var(--coze-up-brand-5), 1);
  --coz-fg-plus: rgba(var(--coze-fg-4), var(--coze-fg-4-alpha));
  --coz-fg: rgba(var(--coze-fg-3), var(--coze-fg-3-alpha));
  --coz-fg-primary: rgba(var(--coze-fg-3), var(--coze-fg-3-alpha));
  --coz-fg-secondary: rgba(var(--coze-fg-2), var(--coze-fg-2-alpha));
  --coz-fg-dim: rgba(var(--coze-fg-1), var(--coze-fg-1-alpha));
  --coz-fg-white: rgba(var(--coze-fg-7), 1);
  --coz-fg-white-dim: rgba(var(--coze-fg-white), var(--coze-fg-white-alpha));
  --coz-fg-hglt-ai: rgba(var(--coze-purple-5), 1);
  --coz-fg-hglt-ai-dim: rgba(var(--coze-purple-3), var(--coze-purple-3-alpha));
  --coz-fg-hglt-red: rgba(var(--coze-red-5), 1);
  --coz-fg-hglt-red-dim: rgba(var(--coze-red-3), var(--coze-red-3-alpha));
  --coz-fg-hglt-yellow: rgba(var(--coze-yellow-5), 1);
  --coz-fg-hglt-yellow-dim: rgba(var(--coze-yellow-3), var(--coze-yellow-3-alpha));
  --coz-fg-hglt-green: rgba(var(--coze-green-5), 1);
  --coz-fg-hglt-green-dim: rgba(var(--coze-green-3), var(--coze-green-3-alpha));
  --coz-fg-color-orange: rgba(var(--coze-yellow-5), 1);
  --coz-fg-color-orange-dim: rgba(var(--coze-yellow-3), var(--coze-yellow-3-alpha));
  --coz-fg-color-emerald: rgba(var(--coze-green-5), 1);
  --coz-fg-color-emerald-dim: rgba(var(--coze-green-3), var(--coze-green-3-alpha));
  --coz-fg-color-cyan: rgba(var(--coze-cyan-50), var(--coze-cyan-50-alpha));
  --coz-fg-color-cyan-dim: rgba(var(--coze-cyan-30), var(--coze-cyan-30-alpha));
  --coz-fg-color-blue: rgba(var(--coze-blue-50), var(--coze-blue-50-alpha));
  --coz-fg-color-blue-dim: rgba(var(--coze-blue-30), var(--coze-blue-30-alpha));
  --coz-fg-color-purple: rgba(var(--coze-purple-50), var(--coze-purple-50-alpha));
  --coz-fg-color-purple-dim: rgba(var(--coze-purple-30), var(--coze-purple-30-alpha));
  --coz-fg-color-magenta: rgba(var(--coze-magenta-50), var(--coze-magenta-50-alpha));
  --coz-fg-color-magenta-dim: rgba(var(--coze-magenta-3), var(--coze-magenta-3-alpha));
  --coz-fg-color-yellow: rgba(var(--coze-yellow-50), var(--coze-yellow-50-alpha));
  --coz-fg-color-yellow-dim: rgba(var(--coze-yellow-30), var(--coze-yellow-30-alpha));
  --coz-fg-hglt-orange: rgba(var(--coze-orange-5), 1);
  --coz-fg-hglt-orange-dim: rgba(var(--coze-orange-3), var(--coze-orange-3-alpha));
  --coz-fg-hglt-emerald: rgba(var(--coze-emerald-5), 1);
  --coz-fg-hglt-emerald-dim: rgba(var(--coze-emerald-3), var(--coze-emerald-3-alpha));
  --coz-fg-hglt-cyan: rgba(var(--coze-cyan-5), 1);
  --coz-fg-hglt-cyan-dim: rgba(var(--coze-cyan-3), var(--coze-cyan-3-alpha));
  --coz-fg-hglt-blue: rgba(var(--coze-blue-5), var(--coze-blue-5-alpha));
  --coz-fg-hglt-blue-dim: rgba(var(--coze-blue-3), var(--coze-blue-3-alpha));
  --coz-fg-hglt-purple: rgba(var(--coze-purple-5), 1);
  --coz-fg-hglt-purple-dim: rgba(var(--coze-purple-3), var(--coze-purple-3-alpha));
  --coz-fg-hglt-magenta: rgba(var(--coze-magenta-5), 1);
  --coz-fg-hglt-magenta-dim: rgba(var(--coze-magenta-3), var(--coze-magenta-3-alpha));
  --coz-fg-color-brand: rgba(var(--coze-brand-50), var(--coze-brand-50-alpha));
  --coz-fg-color-brand-dim: rgba(var(--coze-brand-30), var(--coze-brand-30-alpha));
  --coz-fg-color-alternative: rgba(var(--coze-alternative-50), 1);
  --coz-fg-color-alternative-dim: rgba(var(--coze-alternative-30), var(--coze-alternative-30-alpha));
  --coz-mg-hglt-plus-pressed: rgba(var(--coze-up-brand-7), 1);
  --coz-mg-hglt-plus-hovered: rgba(var(--coze-up-brand-6), 1);
  --coz-mg-hglt-plus: rgba(var(--coze-up-brand-5), 1);
  --coz-mg-hglt-plus-dim: rgba(var(--coze-up-brand-3), 1);
  --coz-mg-hglt-secondary-pressed: rgba(var(--coze-up-brand-2), 1);
  --coz-mg-hglt-secondary-hovered: rgba(var(--coze-up-brand-1), 1);
  --coz-mg-hglt-secondary: rgba(var(--coze-brand-0), var(--coze-brand-0-alpha));
  --coz-mg-hglt-secondary-red: rgba(var(--coze-red-0), var(--coze-red-0-alpha));
  --coz-mg-hglt-secondary-yellow: rgba(var(--coze-yellow-0), var(--coze-yellow-0-alpha));
  --coz-mg-hglt-secondary-green: rgba(var(--coze-green-0), var(--coze-green-0-alpha));
  --coz-mg-plus-pressed: rgba(var(--coze-bg-8), var(--coze-bg-8-alpha));
  --coz-mg-plus-hovered: rgba(var(--coze-bg-7), var(--coze-bg-7-alpha));
  --coz-mg-plus: rgba(var(--coze-bg-6), var(--coze-bg-6-alpha));
  --coz-mg-hglt-pressed: rgba(var(--coze-up-brand-3), 1);
  --coz-mg-hglt-hovered: rgba(var(--coze-up-brand-2), 1);
  --coz-mg-hglt-plus-ai-pressed: rgba(var(--coze-purple-7), 1);
  --coz-mg-hglt-plus-ai-hovered: rgba(var(--coze-purple-6), 1);
  --coz-mg-hglt-plus-ai: rgba(var(--coze-purple-5), 1);
  --coz-mg-hglt-plus-ai-dim: rgba(var(--coze-purple-3), var(--coze-purple-3-alpha));
  --coz-mg-hglt: rgba(var(--coze-up-brand-1), 1);
  --coz-mg-hglt-ai-pressed: rgba(var(--coze-purple-3), var(--coze-purple-3-alpha));
  --coz-mg-hglt-ai-hovered: rgba(var(--coze-purple-2), var(--coze-purple-2-alpha));
  --coz-mg-hglt-ai: rgba(var(--coze-purple-1), var(--coze-purple-1-alpha));
  --coz-mg-hglt-plus-red-pressed: rgba(var(--coze-red-7), 1);
  --coz-mg-hglt-plus-red-hovered: rgba(var(--coze-red-6), 1);
  --coz-mg-hglt-plus-red: rgba(var(--coze-red-5), 1);
  --coz-mg-hglt-plus-red-dim: rgba(var(--coze-red-3), var(--coze-red-3-alpha));
  --coz-mg-hglt-plus-yellow-pressed: rgba(var(--coze-yellow-7), 1);
  --coz-mg-hglt-plus-yellow-hovered: rgba(var(--coze-yellow-6), 1);
  --coz-mg-hglt-plus-yellow: rgba(var(--coze-yellow-5), 1);
  --coz-mg-hglt-plus-yellow-dim: rgba(var(--coze-yellow-3), var(--coze-yellow-3-alpha));
  --coz-mg-hglt-plus-green-pressed: rgba(var(--coze-green-7), 1);
  --coz-mg-hglt-plus-green-hovered: rgba(var(--coze-green-6), 1);
  --coz-mg-hglt-plus-green: rgba(var(--coze-green-5), 1);
  --coz-mg-hglt-plus-green-dim: rgba(var(--coze-green-3), var(--coze-green-3-alpha));
  --coz-mg-hglt-red-pressed: rgba(var(--coze-red-3), var(--coze-red-3-alpha));
  --coz-mg-hglt-red-hovered: rgba(var(--coze-red-2), var(--coze-red-2-alpha));
  --coz-mg-hglt-red: rgba(var(--coze-red-1), var(--coze-red-1-alpha));
  --coz-mg-hglt-yellow-pressed: rgba(var(--coze-yellow-3), var(--coze-yellow-3-alpha));
  --coz-mg-hglt-yellow-hovered: rgba(var(--coze-yellow-2), var(--coze-yellow-2-alpha));
  --coz-mg-hglt-yellow: rgba(var(--coze-yellow-1), var(--coze-yellow-1-alpha));
  --coz-mg-hglt-green-pressed: rgba(var(--coze-green-3), var(--coze-green-3-alpha));
  --coz-mg-hglt-green-hovered: rgba(var(--coze-green-2), var(--coze-green-2-alpha));
  --coz-mg-hglt-green: rgba(var(--coze-green-1), var(--coze-green-1-alpha));
  --coz-mg-color-plus-orange: rgba(var(--coze-yellow-5), 1);
  --coz-mg-color-plus-emerald: rgba(var(--coze-green-5), 1);
  --coz-mg-color-plus-cyan: rgba(var(--coze-cyan-50), var(--coze-cyan-50-alpha));
  --coz-mg-color-plus-blue: rgba(var(--coze-blue-50), var(--coze-blue-50-alpha));
  --coz-mg-color-plus-purple: rgba(var(--coze-purple-50), var(--coze-purple-50-alpha));
  --coz-mg-color-plus-magenta: rgba(var(--coze-magenta-50), var(--coze-magenta-50-alpha));
  --coz-mg-color-plus-yellow: rgba(var(--coze-yellow-50), var(--coze-yellow-50-alpha));
  --coz-mg-color-orange-pressed: rgba(var(--coze-yellow-3), var(--coze-yellow-3-alpha));
  --coz-mg-color-orange-hovered: rgba(var(--coze-yellow-2), var(--coze-yellow-2-alpha));
  --coz-mg-color-orange: rgba(var(--coze-yellow-1), var(--coze-yellow-1-alpha));
  --coz-mg-color-emerald-pressed: rgba(var(--coze-green-3), var(--coze-green-3-alpha));
  --coz-mg-color-emerald-hovered: rgba(var(--coze-green-2), var(--coze-green-2-alpha));
  --coz-mg-color-emerald: rgba(var(--coze-green-1), var(--coze-green-1-alpha));
  --coz-mg-color-cyan-pressed: rgba(var(--coze-cyan-30), var(--coze-cyan-30-alpha));
  --coz-mg-color-cyan-hovered: rgba(var(--coze-cyan-20), var(--coze-cyan-20-alpha));
  --coz-mg-color-cyan: rgba(var(--coze-cyan-10), var(--coze-cyan-10-alpha));
  --coz-mg-color-blue-pressed: rgba(var(--coze-blue-30), var(--coze-blue-30-alpha));
  --coz-mg-color-blue-hovered: rgba(var(--coze-blue-20), var(--coze-blue-20-alpha));
  --coz-mg-color-blue: rgba(var(--coze-blue-10), var(--coze-blue-10-alpha));
  --coz-mg-color-purple-pressed: rgba(var(--coze-purple-30), var(--coze-purple-30-alpha));
  --coz-mg-color-purple-hovered: rgba(var(--coze-purple-20), var(--coze-purple-20-alpha));
  --coz-mg-color-purple: rgba(var(--coze-purple-10), var(--coze-purple-10-alpha));
  --coz-mg-color-magenta-pressed: rgba(var(--coze-magenta-30), var(--coze-magenta-30-alpha));
  --coz-mg-color-magenta-hovered: rgba(var(--coze-magenta-20), var(--coze-magenta-20-alpha));
  --coz-mg-color-magenta: rgba(var(--coze-magenta-10), var(--coze-magenta-10-alpha));
  --coz-mg-primary-pressed: rgba(var(--coze-bg-7), var(--coze-bg-7-alpha));
  --coz-mg-primary-hovered: rgba(var(--coze-bg-6), var(--coze-bg-6-alpha));
  --coz-mg-primary: rgba(var(--coze-bg-5), var(--coze-bg-5-alpha));
  --coz-mg-secondary-pressed: rgba(var(--coze-bg-6), var(--coze-bg-6-alpha));
  --coz-mg-secondary-hovered: rgba(var(--coze-bg-5), var(--coze-bg-5-alpha));
  --coz-mg-secondary: rgba(var(--coze-bg-4), var(--coze-bg-4-alpha));
  --coz-mg: rgba(var(--coze-bg-4), var(--coze-bg-4-alpha));
  --coz-mg-mask: rgba(var(--coze-mask-5), .4);
  --coz-mg-table-fixed-hovered: rgba(var(--coze-bg-0), 1);
  --coz-mg-card-pressed: rgba(var(--coze-bg-3), var(--coze-bg-3-alpha));
  --coz-mg-card-hovered: rgba(var(--coze-bg-3), var(--coze-bg-3-alpha));
  --coz-mg-card: rgba(var(--coze-bg-3), var(--coze-bg-3-alpha));
  --coz-mg-color-plus-brand: rgba(var(--coze-brand-50), var(--coze-brand-50-alpha));
  --coz-bg-max: rgba(var(--coze-bg-3), var(--coze-bg-3-alpha));
  --coz-bg-plus: rgba(var(--coze-bg-2), var(--coze-bg-2-alpha));
  --coz-bg-primary: rgba(var(--coze-bg-1), var(--coze-bg-1-alpha));
  --coz-bg: rgba(var(--coze-bg-1), var(--coze-bg-1-alpha));
  --coz-bg-secondary: rgba(var(--coze-bg-0), 1);
  --coz-stroke-hglt: rgba(var(--coze-up-brand-9), 1);
  --coz-stroke-plus: rgba(var(--coze-stroke-6), var(--coze-stroke-6-alpha));
  --coz-stroke-primary: rgba(var(--coze-stroke-5), var(--coze-stroke-5-alpha));
  --coz-stroke-hglt-red: rgba(var(--coze-red-5), 1);
  --coz-stroke-hglt-yellow: rgba(var(--coze-yellow-5), 1);
  --coz-stroke-hglt-green: rgba(var(--coze-green-5), 1);
  --coz-stroke-color-orange: rgba(var(--coze-yellow-5), 1);
  --coz-stroke-color-emerald: rgba(var(--coze-green-5), 1);
  --coz-stroke-color-cyan: rgba(var(--coze-cyan-50), var(--coze-cyan-50-alpha));
  --coz-stroke-color-blue: rgba(var(--coze-blue-50), var(--coze-blue-50-alpha));
  --coz-stroke-color-purple: rgba(var(--coze-purple-50), var(--coze-purple-50-alpha));
  --coz-stroke-color-magenta: rgba(var(--coze-magenta-50), var(--coze-magenta-50-alpha));
  --coz-stroke-color-yellow: rgba(var(--coze-yellow-50), var(--coze-yellow-50-alpha));
  --coz-stroke-color-brand: rgba(var(--coze-brand-50), var(--coze-brand-50-alpha));
  --coz-stroke-opaque: rgb(var(--coze-stroke-opaque));
  --coz-stroke-max: rgba(var(--coze-stroke-7), var(--coze-stroke-7-alpha));
  --coz-shadow: 0 8px 28px 0px rgba(var(--coze-up-brand-12), .08);
  --coz-shadow-default: 0 8px 28px 0px rgba(var(--coze-up-brand-12), .08);
  --coz-btn-rounded-large: var(--coze-6);
  --coz-btn-rounded-normal: var(--coze-6);
  --coz-btn-rounded-small: var(--coze-5);
  --coz-btn-rounded-mini: var(--coze-4);
  --coz-input-rounded-large: var(--coze-6);
  --coz-input-rounded-normal: var(--coze-6);
  --coz-input-rounded-small: var(--coze-5);
  --coz-input-height-large: var(--coze-36);
  --coz-input-height-normal: var(--coze-32);
  --coz-input-height-small: var(--coze-28);
  --coze-up-brand-1: 253, 253, 255;
  --coze-up-brand-2: 247, 248, 255;
  --coze-up-brand-3: 239, 241, 255;
  --coze-up-brand-4: 227, 231, 255;
  --coze-up-brand-5: 213, 220, 255;
  --coze-up-brand-6: 197, 205, 255;
  --coze-up-brand-7: 176, 185, 255;
  --coze-up-brand-8: 148, 156, 255;
  --coze-up-brand-9: 90, 77, 237;
  --coze-up-brand-10: 58, 58, 181;
  --coze-up-brand-11: 40, 36, 109;
  --coze-up-brand-12: 25, 23, 64;
  --coze-up-stroke-primary: 82, 100, 154;
  --coz-border-primary: rgba(var(--coze-up-stroke-primary), .12);
  --coz-shadow-large: 0 8px 48px 0px rgba(var(--coze-up-brand-12), .12);
  --coz-shadow-normal: 0 8px 28px 0px rgba(var(--coze-up-brand-12), .08);
  --coz-shadow-small: 0 8px 16px 0 rgba(var(--coze-up-brand-12), .06);
}

*, :before, :after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x: ;
  --tw-pan-y: ;
  --tw-pinch-zoom: ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position: ;
  --tw-gradient-via-position: ;
  --tw-gradient-to-position: ;
  --tw-ordinal: ;
  --tw-slashed-zero: ;
  --tw-numeric-figure: ;
  --tw-numeric-spacing: ;
  --tw-numeric-fraction: ;
  --tw-ring-inset: ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59, 130, 246, .5);
  --tw-ring-offset-shadow: 0 0 rgba(0, 0, 0, 0);
  --tw-ring-shadow: 0 0 rgba(0, 0, 0, 0);
  --tw-shadow: 0 0 rgba(0, 0, 0, 0);
  --tw-shadow-colored: 0 0 rgba(0, 0, 0, 0);
  --tw-blur: ;
  --tw-brightness: ;
  --tw-contrast: ;
  --tw-grayscale: ;
  --tw-hue-rotate: ;
  --tw-invert: ;
  --tw-saturate: ;
  --tw-sepia: ;
  --tw-drop-shadow: ;
  --tw-backdrop-blur: ;
  --tw-backdrop-brightness: ;
  --tw-backdrop-contrast: ;
  --tw-backdrop-grayscale: ;
  --tw-backdrop-hue-rotate: ;
  --tw-backdrop-invert: ;
  --tw-backdrop-opacity: ;
  --tw-backdrop-saturate: ;
  --tw-backdrop-sepia: ;
}

::-ms-backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x: ;
  --tw-pan-y: ;
  --tw-pinch-zoom: ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position: ;
  --tw-gradient-via-position: ;
  --tw-gradient-to-position: ;
  --tw-ordinal: ;
  --tw-slashed-zero: ;
  --tw-numeric-figure: ;
  --tw-numeric-spacing: ;
  --tw-numeric-fraction: ;
  --tw-ring-inset: ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59, 130, 246, .5);
  --tw-ring-offset-shadow: 0 0 rgba(0, 0, 0, 0);
  --tw-ring-shadow: 0 0 rgba(0, 0, 0, 0);
  --tw-shadow: 0 0 rgba(0, 0, 0, 0);
  --tw-shadow-colored: 0 0 rgba(0, 0, 0, 0);
  --tw-blur: ;
  --tw-brightness: ;
  --tw-contrast: ;
  --tw-grayscale: ;
  --tw-hue-rotate: ;
  --tw-invert: ;
  --tw-saturate: ;
  --tw-sepia: ;
  --tw-drop-shadow: ;
  --tw-backdrop-blur: ;
  --tw-backdrop-brightness: ;
  --tw-backdrop-contrast: ;
  --tw-backdrop-grayscale: ;
  --tw-backdrop-hue-rotate: ;
  --tw-backdrop-invert: ;
  --tw-backdrop-opacity: ;
  --tw-backdrop-saturate: ;
  --tw-backdrop-sepia: ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x: ;
  --tw-pan-y: ;
  --tw-pinch-zoom: ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position: ;
  --tw-gradient-via-position: ;
  --tw-gradient-to-position: ;
  --tw-ordinal: ;
  --tw-slashed-zero: ;
  --tw-numeric-figure: ;
  --tw-numeric-spacing: ;
  --tw-numeric-fraction: ;
  --tw-ring-inset: ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59, 130, 246, .5);
  --tw-ring-offset-shadow: 0 0 rgba(0, 0, 0, 0);
  --tw-ring-shadow: 0 0 rgba(0, 0, 0, 0);
  --tw-shadow: 0 0 rgba(0, 0, 0, 0);
  --tw-shadow-colored: 0 0 rgba(0, 0, 0, 0);
  --tw-blur: ;
  --tw-brightness: ;
  --tw-contrast: ;
  --tw-grayscale: ;
  --tw-hue-rotate: ;
  --tw-invert: ;
  --tw-saturate: ;
  --tw-sepia: ;
  --tw-drop-shadow: ;
  --tw-backdrop-blur: ;
  --tw-backdrop-brightness: ;
  --tw-backdrop-contrast: ;
  --tw-backdrop-grayscale: ;
  --tw-backdrop-hue-rotate: ;
  --tw-backdrop-invert: ;
  --tw-backdrop-opacity: ;
  --tw-backdrop-saturate: ;
  --tw-backdrop-sepia: ;
}

.\\!container {
  width: 100% !important;
}

.container {
  width: 100%;
}

@media (min-width: 640px) {
  .\\!container {
    max-width: 640px !important;
  }

  .container {
    max-width: 640px;
  }
}

@media (min-width: 768px) {
  .\\!container {
    max-width: 768px !important;
  }

  .container {
    max-width: 768px;
  }
}

@media (min-width: 1200px) {
  .\\!container {
    max-width: 1200px !important;
  }

  .container {
    max-width: 1200px;
  }
}

@media (min-width: 1600px) {
  .\\!container {
    max-width: 1600px !important;
  }

  .container {
    max-width: 1600px;
  }
}

@media (min-width: 1680px) {
  .\\!container {
    max-width: 1680px !important;
  }

  .container {
    max-width: 1680px;
  }
}

@media (min-width: 1920px) {
  .\\!container {
    max-width: 1920px !important;
  }

  .container {
    max-width: 1920px;
  }
}

.pointer-events-none {
  pointer-events: none;
}

.\\!pointer-events-auto {
  pointer-events: auto !important;
}

.pointer-events-auto {
  pointer-events: auto;
}

.\\!visible {
  visibility: visible !important;
}

.visible {
  visibility: visible;
}

.\\!invisible {
  visibility: hidden !important;
}

.invisible {
  visibility: hidden;
}

.\\!collapse {
  visibility: collapse !important;
}

.collapse {
  visibility: collapse;
}

.static {
  position: static;
}

.\\!fixed {
  position: fixed !important;
}

.fixed {
  position: fixed;
}

.absolute {
  position: absolute;
}

.relative {
  position: relative;
}

.sticky {
  position: -webkit-sticky;
  position: sticky;
}

.inset {
  inset: var(--coze-8);
}

.inset-0 {
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.inset-y-0 {
  top: 0;
  bottom: 0;
}

.\\!bottom-\\[8px\\] {
  bottom: 8px !important;
}

.\\!left {
  left: var(--coze-8) !important;
}

.\\!left-\\[12px\\] {
  left: 12px !important;
}

.\\!right {
  right: var(--coze-8) !important;
}

.\\!top-0 {
  top: 0 !important;
}

.\\!top-\\[16px\\] {
  top: 16px !important;
}

.-bottom-\\[1px\\] {
  bottom: -1px;
}

.-right-\\[1px\\] {
  right: -1px;
}

.-top-8 {
  top: -2rem;
}

.-top-\\[30px\\] {
  top: -30px;
}

.-top-\\[48px\\] {
  top: -48px;
}

.bottom {
  bottom: var(--coze-8);
}

.bottom-0 {
  bottom: 0;
}

.bottom-1 {
  bottom: .25rem;
}

.bottom-2 {
  bottom: .5rem;
}

.bottom-2\\.5 {
  bottom: .625rem;
}

.bottom-\\[-10px\\] {
  bottom: -10px;
}

.bottom-\\[-20px\\] {
  bottom: -20px;
}

.bottom-\\[0\\] {
  bottom: 0;
}

.bottom-\\[12px\\] {
  bottom: 12px;
}

.bottom-\\[16px\\] {
  bottom: 16px;
}

.bottom-\\[1px\\] {
  bottom: 1px;
}

.bottom-\\[2px\\] {
  bottom: 2px;
}

.bottom-\\[30px\\] {
  bottom: 30px;
}

.bottom-\\[8px\\] {
  bottom: 8px;
}

.end:not(:-webkit-any(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi))) {
  right: var(--coze-8);
}

.end:not(:-moz-any(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi))) {
  right: var(--coze-8);
}

.end:not(:is(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi))) {
  right: var(--coze-8);
}

.end:-webkit-any(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi)) {
  left: var(--coze-8);
}

.end:-moz-any(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi)) {
  left: var(--coze-8);
}

.end:is(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi)) {
  left: var(--coze-8);
}

.left {
  left: var(--coze-8);
}

.left-0 {
  left: 0;
}

.left-1 {
  left: .25rem;
}

.left-1\\/2 {
  left: 50%;
}

.left-8px {
  left: var(--coze-8);
}

.left-\\[-10px\\] {
  left: -10px;
}

.left-\\[-140px\\] {
  left: -140px;
}

.left-\\[-999px\\] {
  left: -999px;
}

.left-\\[0\\] {
  left: 0;
}

.left-\\[10px\\] {
  left: 10px;
}

.left-\\[12px\\] {
  left: 12px;
}

.left-\\[1px\\] {
  left: 1px;
}

.left-\\[2px\\] {
  left: 2px;
}

.left-\\[4px\\] {
  left: 4px;
}

.left-\\[50\\%\\] {
  left: 50%;
}

.left-\\[8px\\] {
  left: 8px;
}

.right {
  right: var(--coze-8);
}

.right-0 {
  right: 0;
}

.right-1 {
  right: .25rem;
}

.right-3 {
  right: .75rem;
}

.right-4 {
  right: 1rem;
}

.right-5 {
  right: 1.25rem;
}

.right-8px {
  right: var(--coze-8);
}

.right-\\[-10px\\] {
  right: -10px;
}

.right-\\[-12px\\] {
  right: -12px;
}

.right-\\[-4px\\] {
  right: -4px;
}

.right-\\[0\\], .right-\\[0px\\] {
  right: 0;
}

.right-\\[10px\\] {
  right: 10px;
}

.right-\\[12px\\] {
  right: 12px;
}

.right-\\[16px\\] {
  right: 16px;
}

.right-\\[1px\\] {
  right: 1px;
}

.right-\\[2px\\] {
  right: 2px;
}

.right-\\[30px\\] {
  right: 30px;
}

.right-\\[4px\\] {
  right: 4px;
}

.right-\\[5px\\] {
  right: 5px;
}

.right-\\[8px\\] {
  right: 8px;
}

.start:not(:-webkit-any(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi))) {
  left: var(--coze-8);
}

.start:not(:-moz-any(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi))) {
  left: var(--coze-8);
}

.start:not(:is(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi))) {
  left: var(--coze-8);
}

.start:-webkit-any(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi)) {
  right: var(--coze-8);
}

.start:-moz-any(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi)) {
  right: var(--coze-8);
}

.start:is(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi)) {
  right: var(--coze-8);
}

.top {
  top: var(--coze-8);
}

.top-0 {
  top: 0;
}

.top-0\\.5 {
  top: .125rem;
}

.top-1 {
  top: .25rem;
}

.top-1\\/2 {
  top: 50%;
}

.top-2 {
  top: .5rem;
}

.top-2\\.5 {
  top: .625rem;
}

.top-3 {
  top: .75rem;
}

.top-4 {
  top: 1rem;
}

.top-5 {
  top: 1.25rem;
}

.top-8px {
  top: var(--coze-8);
}

.top-9 {
  top: 2.25rem;
}

.top-\\[-10px\\] {
  top: -10px;
}

.top-\\[-14px\\] {
  top: -14px;
}

.top-\\[-1px\\] {
  top: -1px;
}

.top-\\[-28px\\] {
  top: -28px;
}

.top-\\[-2px\\] {
  top: -2px;
}

.top-\\[-32px\\] {
  top: -32px;
}

.top-\\[-48px\\] {
  top: -48px;
}

.top-\\[-4px\\] {
  top: -4px;
}

.top-\\[-8px\\] {
  top: -8px;
}

.top-\\[0\\] {
  top: 0;
}

.top-\\[10px\\] {
  top: 10px;
}

.top-\\[12px\\] {
  top: 12px;
}

.top-\\[16px\\] {
  top: 16px;
}

.top-\\[2px\\] {
  top: 2px;
}

.top-\\[34px\\] {
  top: 34px;
}

.top-\\[3px\\] {
  top: 3px;
}

.top-\\[4px\\] {
  top: 4px;
}

.top-\\[50\\%\\] {
  top: 50%;
}

.top-\\[6px\\] {
  top: 6px;
}

.top-\\[8px\\] {
  top: 8px;
}

.top-\\[9px\\] {
  top: 9px;
}

.top-full {
  top: 100%;
}

.isolate {
  isolation: isolate;
}

.-z-10 {
  z-index: -10;
}

.z-10 {
  z-index: 10;
}

.z-20 {
  z-index: 20;
}

.z-50 {
  z-index: 50;
}

.z-\\[1000\\] {
  z-index: 1000;
}

.z-\\[1001\\] {
  z-index: 1001;
}

.z-\\[100\\] {
  z-index: 100;
}

.z-\\[1060\\] {
  z-index: 1060;
}

.z-\\[1\\] {
  z-index: 1;
}

.z-\\[20000\\] {
  z-index: 20000;
}

.z-\\[200\\] {
  z-index: 200;
}

.z-\\[2\\] {
  z-index: 2;
}

.z-\\[300\\] {
  z-index: 300;
}

.z-\\[99999\\] {
  z-index: 99999;
}

.z-\\[999\\] {
  z-index: 999;
}

.col-span-2 {
  grid-column: span 2 / span 2;
}

.\\!m {
  margin: var(--coze-8) !important;
}

.\\!m-0 {
  margin: 0 !important;
}

.m {
  margin: var(--coze-8);
}

.m-0 {
  margin: 0;
}

.m-0\\.5 {
  margin: .125rem;
}

.m-1 {
  margin: .25rem;
}

.m-2 {
  margin: .5rem;
}

.m-2\\.5 {
  margin: .625rem;
}

.m-4 {
  margin: 1rem;
}

.m-40 {
  margin: 10rem;
}

.m-5 {
  margin: 1.25rem;
}

.m-6 {
  margin: 1.5rem;
}

.m-\\[0\\] {
  margin: 0;
}

.m-\\[24px\\] {
  margin: 24px;
}

.m-\\[4px\\] {
  margin: 4px;
}

.m-\\[8px\\] {
  margin: 8px;
}

.m-auto {
  margin: auto;
}

.\\!mx-2 {
  margin-left: .5rem !important;
  margin-right: .5rem !important;
}

.\\!my-4 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.mx-0 {
  margin-left: 0;
  margin-right: 0;
}

.mx-0\\.5 {
  margin-left: .125rem;
  margin-right: .125rem;
}

.mx-1 {
  margin-left: .25rem;
  margin-right: .25rem;
}

.mx-12px {
  margin-left: var(--coze-12);
  margin-right: var(--coze-12);
}

.mx-2 {
  margin-left: .5rem;
  margin-right: .5rem;
}

.mx-2\\.5 {
  margin-left: .625rem;
  margin-right: .625rem;
}

.mx-3 {
  margin-left: .75rem;
  margin-right: .75rem;
}

.mx-6 {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}

.mx-8px {
  margin-left: var(--coze-8);
  margin-right: var(--coze-8);
}

.mx-\\[-12px\\] {
  margin-left: -12px;
  margin-right: -12px;
}

.mx-\\[-16px\\] {
  margin-left: -16px;
  margin-right: -16px;
}

.mx-\\[-24px\\] {
  margin-left: -24px;
  margin-right: -24px;
}

.mx-\\[-28px\\] {
  margin-left: -28px;
  margin-right: -28px;
}

.mx-\\[-3\\.5px\\] {
  margin-left: -3.5px;
  margin-right: -3.5px;
}

.mx-\\[10px\\] {
  margin-left: 10px;
  margin-right: 10px;
}

.mx-\\[12px\\] {
  margin-left: 12px;
  margin-right: 12px;
}

.mx-\\[16px\\] {
  margin-left: 16px;
  margin-right: 16px;
}

.mx-\\[24px\\] {
  margin-left: 24px;
  margin-right: 24px;
}

.mx-\\[2px\\] {
  margin-left: 2px;
  margin-right: 2px;
}

.mx-\\[3px\\] {
  margin-left: 3px;
  margin-right: 3px;
}

.mx-\\[4px\\] {
  margin-left: 4px;
  margin-right: 4px;
}

.mx-\\[6px\\] {
  margin-left: 6px;
  margin-right: 6px;
}

.mx-\\[8px\\] {
  margin-left: 8px;
  margin-right: 8px;
}

.mx-\\[9px\\] {
  margin-left: 9px;
  margin-right: 9px;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.my {
  margin-top: var(--coze-8);
  margin-bottom: var(--coze-8);
}

.my-0 {
  margin-top: 0;
  margin-bottom: 0;
}

.my-1 {
  margin-top: .25rem;
  margin-bottom: .25rem;
}

.my-10 {
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}

.my-2 {
  margin-top: .5rem;
  margin-bottom: .5rem;
}

.my-2\\.5 {
  margin-top: .625rem;
  margin-bottom: .625rem;
}

.my-24px {
  margin-top: var(--coze-24);
  margin-bottom: var(--coze-24);
}

.my-3 {
  margin-top: .75rem;
  margin-bottom: .75rem;
}

.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.my-4px {
  margin-top: var(--coze-4);
  margin-bottom: var(--coze-4);
}

.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}

.my-\\[0\\] {
  margin-top: 0;
  margin-bottom: 0;
}

.my-\\[10px\\] {
  margin-top: 10px;
  margin-bottom: 10px;
}

.my-\\[16px\\] {
  margin-top: 16px;
  margin-bottom: 16px;
}

.my-\\[20px\\] {
  margin-top: 20px;
  margin-bottom: 20px;
}

.my-\\[24px\\] {
  margin-top: 24px;
  margin-bottom: 24px;
}

.my-\\[25px\\] {
  margin-top: 25px;
  margin-bottom: 25px;
}

.my-\\[32px\\] {
  margin-top: 32px;
  margin-bottom: 32px;
}

.my-\\[3px\\] {
  margin-top: 3px;
  margin-bottom: 3px;
}

.my-\\[6px\\] {
  margin-top: 6px;
  margin-bottom: 6px;
}

.my-\\[80px\\] {
  margin-top: 80px;
  margin-bottom: 80px;
}

.my-\\[8px\\] {
  margin-top: 8px;
  margin-bottom: 8px;
}

.\\!mb-0 {
  margin-bottom: 0 !important;
}

.\\!mb-0\\.5 {
  margin-bottom: .125rem !important;
}

.\\!mb-1 {
  margin-bottom: .25rem !important;
}

.\\!mb-4 {
  margin-bottom: 1rem !important;
}

.\\!mb-\\[-28px\\] {
  margin-bottom: -28px !important;
}

.\\!mb-\\[14px\\] {
  margin-bottom: 14px !important;
}

.\\!mb-\\[24px\\] {
  margin-bottom: 24px !important;
}

.\\!mb-\\[4px\\] {
  margin-bottom: 4px !important;
}

.\\!ml-0 {
  margin-left: 0 !important;
}

.\\!ml-3 {
  margin-left: .75rem !important;
}

.\\!ml-\\[8px\\] {
  margin-left: 8px !important;
}

.\\!mr-0 {
  margin-right: 0 !important;
}

.\\!mr-2 {
  margin-right: .5rem !important;
}

.\\!mr-3 {
  margin-right: .75rem !important;
}

.\\!mt-2 {
  margin-top: .5rem !important;
}

.\\!mt-2\\.5 {
  margin-top: .625rem !important;
}

.\\!mt-6 {
  margin-top: 1.5rem !important;
}

.\\!mt-\\[8px\\] {
  margin-top: 8px !important;
}

.-mb-\\[6px\\] {
  margin-bottom: -6px;
}

.-ml-\\[0\\.5px\\] {
  margin-left: -.5px;
}

.-mr-1 {
  margin-right: -.25rem;
}

.-mr-1\\.5 {
  margin-right: -.375rem;
}

.-mt-1 {
  margin-top: -.25rem;
}

.-mt-\\[1px\\] {
  margin-top: -1px;
}

.-mt-\\[3px\\] {
  margin-top: -3px;
}

.mb {
  margin-bottom: var(--coze-8);
}

.mb-0 {
  margin-bottom: 0;
}

.mb-0\\.5 {
  margin-bottom: .125rem;
}

.mb-1 {
  margin-bottom: .25rem;
}

.mb-12 {
  margin-bottom: 3rem;
}

.mb-12px {
  margin-bottom: var(--coze-12);
}

.mb-16px {
  margin-bottom: var(--coze-16);
}

.mb-2 {
  margin-bottom: .5rem;
}

.mb-24px {
  margin-bottom: var(--coze-24);
}

.mb-2px {
  margin-bottom: var(--coze-2);
}

.mb-3 {
  margin-bottom: .75rem;
}

.mb-4 {
  margin-bottom: 1rem;
}

.mb-4px {
  margin-bottom: var(--coze-4);
}

.mb-5 {
  margin-bottom: 1.25rem;
}

.mb-6 {
  margin-bottom: 1.5rem;
}

.mb-7 {
  margin-bottom: 1.75rem;
}

.mb-8 {
  margin-bottom: 2rem;
}

.mb-8px {
  margin-bottom: var(--coze-8);
}

.mb-\\[10px\\] {
  margin-bottom: 10px;
}

.mb-\\[12px\\] {
  margin-bottom: 12px;
}

.mb-\\[14px\\] {
  margin-bottom: 14px;
}

.mb-\\[16px\\] {
  margin-bottom: 16px;
}

.mb-\\[20px\\] {
  margin-bottom: 20px;
}

.mb-\\[24px\\] {
  margin-bottom: 24px;
}

.mb-\\[25px\\] {
  margin-bottom: 25px;
}

.mb-\\[2px\\] {
  margin-bottom: 2px;
}

.mb-\\[30px\\] {
  margin-bottom: 30px;
}

.mb-\\[32px\\] {
  margin-bottom: 32px;
}

.mb-\\[48px\\] {
  margin-bottom: 48px;
}

.mb-\\[4px\\] {
  margin-bottom: 4px;
}

.mb-\\[6px\\] {
  margin-bottom: 6px;
}

.mb-\\[7px\\] {
  margin-bottom: 7px;
}

.mb-\\[8px\\] {
  margin-bottom: 8px;
}

.me:not(:-webkit-any(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi))) {
  margin-right: var(--coze-8);
}

.me:not(:-moz-any(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi))) {
  margin-right: var(--coze-8);
}

.me:not(:is(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi))) {
  margin-right: var(--coze-8);
}

.me:-webkit-any(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi)) {
  margin-left: var(--coze-8);
}

.me:-moz-any(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi)) {
  margin-left: var(--coze-8);
}

.me:is(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi)) {
  margin-left: var(--coze-8);
}

.ml {
  margin-left: var(--coze-8);
}

.ml-0 {
  margin-left: 0;
}

.ml-0\\.5 {
  margin-left: .125rem;
}

.ml-1 {
  margin-left: .25rem;
}

.ml-1\\.5 {
  margin-left: .375rem;
}

.ml-10 {
  margin-left: 2.5rem;
}

.ml-12px {
  margin-left: var(--coze-12);
}

.ml-2 {
  margin-left: .5rem;
}

.ml-2px {
  margin-left: var(--coze-2);
}

.ml-3 {
  margin-left: .75rem;
}

.ml-4 {
  margin-left: 1rem;
}

.ml-4px {
  margin-left: var(--coze-4);
}

.ml-5px {
  margin-left: var(--coze-5);
}

.ml-6 {
  margin-left: 1.5rem;
}

.ml-6px {
  margin-left: var(--coze-6);
}

.ml-8 {
  margin-left: 2rem;
}

.ml-8px {
  margin-left: var(--coze-8);
}

.ml-9 {
  margin-left: 2.25rem;
}

.ml-9px {
  margin-left: var(--coze-9);
}

.ml-\\[-12px\\] {
  margin-left: -12px;
}

.ml-\\[-20px\\] {
  margin-left: -20px;
}

.ml-\\[-6px\\] {
  margin-left: -6px;
}

.ml-\\[10px\\] {
  margin-left: 10px;
}

.ml-\\[12px\\] {
  margin-left: 12px;
}

.ml-\\[14px\\] {
  margin-left: 14px;
}

.ml-\\[16px\\] {
  margin-left: 16px;
}

.ml-\\[1px\\] {
  margin-left: 1px;
}

.ml-\\[20px\\] {
  margin-left: 20px;
}

.ml-\\[21px\\] {
  margin-left: 21px;
}

.ml-\\[24px\\] {
  margin-left: 24px;
}

.ml-\\[26px\\] {
  margin-left: 26px;
}

.ml-\\[28px\\] {
  margin-left: 28px;
}

.ml-\\[2px\\] {
  margin-left: 2px;
}

.ml-\\[32px\\] {
  margin-left: 32px;
}

.ml-\\[3px\\] {
  margin-left: 3px;
}

.ml-\\[48px\\] {
  margin-left: 48px;
}

.ml-\\[4px\\] {
  margin-left: 4px;
}

.ml-\\[5px\\] {
  margin-left: 5px;
}

.ml-\\[6px\\] {
  margin-left: 6px;
}

.ml-\\[8px\\] {
  margin-left: 8px;
}

.ml-auto {
  margin-left: auto;
}

.mr {
  margin-right: var(--coze-8);
}

.mr-1 {
  margin-right: .25rem;
}

.mr-1\\.5 {
  margin-right: .375rem;
}

.mr-12px {
  margin-right: var(--coze-12);
}

.mr-16px {
  margin-right: var(--coze-16);
}

.mr-2 {
  margin-right: .5rem;
}

.mr-2px {
  margin-right: var(--coze-2);
}

.mr-3 {
  margin-right: .75rem;
}

.mr-4 {
  margin-right: 1rem;
}

.mr-4px {
  margin-right: var(--coze-4);
}

.mr-6 {
  margin-right: 1.5rem;
}

.mr-7 {
  margin-right: 1.75rem;
}

.mr-8px {
  margin-right: var(--coze-8);
}

.mr-\\[-24px\\] {
  margin-right: -24px;
}

.mr-\\[108px\\] {
  margin-right: 108px;
}

.mr-\\[10px\\] {
  margin-right: 10px;
}

.mr-\\[12px\\] {
  margin-right: 12px;
}

.mr-\\[16px\\] {
  margin-right: 16px;
}

.mr-\\[1px\\] {
  margin-right: 1px;
}

.mr-\\[24px\\] {
  margin-right: 24px;
}

.mr-\\[2px\\] {
  margin-right: 2px;
}

.mr-\\[3px\\] {
  margin-right: 3px;
}

.mr-\\[4px\\] {
  margin-right: 4px;
}

.mr-\\[5px\\] {
  margin-right: 5px;
}

.mr-\\[6px\\] {
  margin-right: 6px;
}

.mr-\\[7px\\] {
  margin-right: 7px;
}

.mr-\\[8px\\] {
  margin-right: 8px;
}

.mr-\\[9px\\] {
  margin-right: 9px;
}

.mr-auto {
  margin-right: auto;
}

.ms:not(:-webkit-any(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi))) {
  margin-left: var(--coze-8);
}

.ms:not(:-moz-any(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi))) {
  margin-left: var(--coze-8);
}

.ms:not(:is(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi))) {
  margin-left: var(--coze-8);
}

.ms:-webkit-any(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi)) {
  margin-right: var(--coze-8);
}

.ms:-moz-any(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi)) {
  margin-right: var(--coze-8);
}

.ms:is(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi)) {
  margin-right: var(--coze-8);
}

.ms-\\[8px\\]:not(:-webkit-any(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi))) {
  margin-left: 8px;
}

.ms-\\[8px\\]:not(:-moz-any(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi))) {
  margin-left: 8px;
}

.ms-\\[8px\\]:not(:is(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi))) {
  margin-left: 8px;
}

.ms-\\[8px\\]:-webkit-any(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi)) {
  margin-right: 8px;
}

.ms-\\[8px\\]:-moz-any(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi)) {
  margin-right: 8px;
}

.ms-\\[8px\\]:is(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi)) {
  margin-right: 8px;
}

.mt {
  margin-top: var(--coze-8);
}

.mt-0 {
  margin-top: 0;
}

.mt-1 {
  margin-top: .25rem;
}

.mt-1\\.5 {
  margin-top: .375rem;
}

.mt-12px {
  margin-top: var(--coze-12);
}

.mt-16px {
  margin-top: var(--coze-16);
}

.mt-2 {
  margin-top: .5rem;
}

.mt-20 {
  margin-top: 5rem;
}

.mt-2px {
  margin-top: var(--coze-2);
}

.mt-3 {
  margin-top: .75rem;
}

.mt-4 {
  margin-top: 1rem;
}

.mt-4px {
  margin-top: var(--coze-4);
}

.mt-5 {
  margin-top: 1.25rem;
}

.mt-6 {
  margin-top: 1.5rem;
}

.mt-8 {
  margin-top: 2rem;
}

.mt-8px {
  margin-top: var(--coze-8);
}

.mt-\\[-10px\\] {
  margin-top: -10px;
}

.mt-\\[-16px\\] {
  margin-top: -16px;
}

.mt-\\[-1px\\] {
  margin-top: -1px;
}

.mt-\\[-2px\\] {
  margin-top: -2px;
}

.mt-\\[-4px\\] {
  margin-top: -4px;
}

.mt-\\[-8px\\] {
  margin-top: -8px;
}

.mt-\\[120px\\] {
  margin-top: 120px;
}

.mt-\\[128px\\] {
  margin-top: 128px;
}

.mt-\\[12px\\] {
  margin-top: 12px;
}

.mt-\\[14px\\] {
  margin-top: 14px;
}

.mt-\\[150px\\] {
  margin-top: 150px;
}

.mt-\\[16px\\] {
  margin-top: 16px;
}

.mt-\\[183px\\] {
  margin-top: 183px;
}

.mt-\\[1px\\] {
  margin-top: 1px;
}

.mt-\\[20px\\] {
  margin-top: 20px;
}

.mt-\\[24px\\] {
  margin-top: 24px;
}

.mt-\\[25px\\] {
  margin-top: 25px;
}

.mt-\\[28px\\] {
  margin-top: 28px;
}

.mt-\\[2px\\] {
  margin-top: 2px;
}

.mt-\\[32px\\] {
  margin-top: 32px;
}

.mt-\\[36px\\] {
  margin-top: 36px;
}

.mt-\\[3px\\] {
  margin-top: 3px;
}

.mt-\\[42px\\] {
  margin-top: 42px;
}

.mt-\\[46px\\] {
  margin-top: 46px;
}

.mt-\\[4px\\] {
  margin-top: 4px;
}

.mt-\\[5px\\] {
  margin-top: 5px;
}

.mt-\\[64px\\] {
  margin-top: 64px;
}

.mt-\\[6px\\] {
  margin-top: 6px;
}

.mt-\\[7px\\] {
  margin-top: 7px;
}

.mt-\\[80px\\] {
  margin-top: 80px;
}

.mt-\\[8px\\] {
  margin-top: 8px;
}

.mt-auto {
  margin-top: auto;
}

.\\!box-border {
  box-sizing: border-box !important;
}

.box-border {
  box-sizing: border-box;
}

.box-content {
  box-sizing: content-box;
}

.line-clamp-1 {
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
}

.line-clamp-2 {
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
}

.line-clamp-3 {
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
}

.line-clamp-5 {
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
}

.\\!block {
  display: block !important;
}

.block {
  display: block;
}

.inline-block {
  display: inline-block;
}

.\\!inline {
  display: inline !important;
}

.inline {
  display: inline;
}

.\\!flex {
  display: flex !important;
}

.flex {
  display: flex;
}

.\\!inline-flex {
  display: inline-flex !important;
}

.inline-flex {
  display: inline-flex;
}

.table {
  display: table;
}

.table-column {
  display: table-column;
}

.table-row {
  display: table-row;
}

.grid {
  display: grid;
}

.contents {
  display: contents;
}

.list-item {
  display: list-item;
}

.\\!hidden {
  display: none !important;
}

.hidden {
  display: none;
}

.aspect-\\[180\\/120\\] {
  aspect-ratio: 180 / 120;
}

.aspect-\\[3\\/4\\] {
  aspect-ratio: 3 / 4;
}

.\\!h-0 {
  height: 0 !important;
}

.\\!h-12 {
  height: 3rem !important;
}

.\\!h-20px {
  height: var(--coze-20) !important;
}

.\\!h-3 {
  height: .75rem !important;
}

.\\!h-4 {
  height: 1rem !important;
}

.\\!h-5 {
  height: 1.25rem !important;
}

.\\!h-6 {
  height: 1.5rem !important;
}

.\\!h-8 {
  height: 2rem !important;
}

.\\!h-9 {
  height: 2.25rem !important;
}

.\\!h-\\[12px\\] {
  height: 12px !important;
}

.\\!h-\\[14px\\] {
  height: 14px !important;
}

.\\!h-\\[16px\\] {
  height: 16px !important;
}

.\\!h-\\[18px\\] {
  height: 18px !important;
}

.\\!h-\\[200px\\] {
  height: 200px !important;
}

.\\!h-\\[20px\\] {
  height: 20px !important;
}

.\\!h-\\[24px\\] {
  height: 24px !important;
}

.\\!h-\\[30px\\] {
  height: 30px !important;
}

.\\!h-\\[32px\\] {
  height: 32px !important;
}

.\\!h-\\[40px\\] {
  height: 40px !important;
}

.\\!h-\\[42px\\] {
  height: 42px !important;
}

.\\!h-\\[45px\\] {
  height: 45px !important;
}

.\\!h-\\[4px\\] {
  height: 4px !important;
}

.\\!h-\\[56px\\] {
  height: 56px !important;
}

.\\!h-\\[80vh\\] {
  height: 80vh !important;
}

.\\!h-\\[8px\\] {
  height: 8px !important;
}

.\\!h-\\[unset\\] {
  height: unset !important;
}

.\\!h-auto {
  height: auto !important;
}

.\\!h-fit {
  height: -moz-fit-content !important;
  height: fit-content !important;
}

.\\!h-full {
  height: 100% !important;
}

.h {
  height: var(--coze-32);
}

.h-0 {
  height: 0;
}

.h-1 {
  height: .25rem;
}

.h-1\\/2 {
  height: 50%;
}

.h-10 {
  height: 2.5rem;
}

.h-11 {
  height: 2.75rem;
}

.h-12 {
  height: 3rem;
}

.h-12px {
  height: var(--coze-12);
}

.h-14 {
  height: 3.5rem;
}

.h-16 {
  height: 4rem;
}

.h-160px {
  height: var(--coze-160);
}

.h-16px {
  height: var(--coze-16);
}

.h-18px {
  height: var(--coze-18);
}

.h-2 {
  height: .5rem;
}

.h-200px {
  height: var(--coze-200);
}

.h-20px {
  height: var(--coze-20);
}

.h-24px {
  height: var(--coze-24);
}

.h-28 {
  height: 7rem;
}

.h-3 {
  height: .75rem;
}

.h-3\\.5 {
  height: .875rem;
}

.h-32 {
  height: 8rem;
}

.h-32px {
  height: var(--coze-32);
}

.h-3px {
  height: var(--coze-3);
}

.h-4 {
  height: 1rem;
}

.h-40 {
  height: 10rem;
}

.h-40px {
  height: var(--coze-40);
}

.h-48px {
  height: var(--coze-48);
}

.h-5 {
  height: 1.25rem;
}

.h-6 {
  height: 1.5rem;
}

.h-60 {
  height: 15rem;
}

.h-64px {
  height: var(--coze-64);
}

.h-7 {
  height: 1.75rem;
}

.h-8 {
  height: 2rem;
}

.h-80px {
  height: var(--coze-80);
}

.h-9 {
  height: 2.25rem;
}

.h-96 {
  height: 24rem;
}

.h-\\[0px\\] {
  height: 0;
}

.h-\\[100\\%\\] {
  height: 100%;
}

.h-\\[100px\\] {
  height: 100px;
}

.h-\\[10px\\] {
  height: 10px;
}

.h-\\[120px\\] {
  height: 120px;
}

.h-\\[124px\\] {
  height: 124px;
}

.h-\\[12px\\] {
  height: 12px;
}

.h-\\[132px\\] {
  height: 132px;
}

.h-\\[135px\\] {
  height: 135px;
}

.h-\\[140px\\] {
  height: 140px;
}

.h-\\[148px\\] {
  height: 148px;
}

.h-\\[14px\\] {
  height: 14px;
}

.h-\\[150px\\] {
  height: 150px;
}

.h-\\[158px\\] {
  height: 158px;
}

.h-\\[15px\\] {
  height: 15px;
}

.h-\\[160px\\] {
  height: 160px;
}

.h-\\[16px\\] {
  height: 16px;
}

.h-\\[17px\\] {
  height: 17px;
}

.h-\\[180px\\] {
  height: 180px;
}

.h-\\[186px\\] {
  height: 186px;
}

.h-\\[18px\\] {
  height: 18px;
}

.h-\\[1px\\] {
  height: 1px;
}

.h-\\[200px\\] {
  height: 200px;
}

.h-\\[20px\\] {
  height: 20px;
}

.h-\\[211px\\] {
  height: 211px;
}

.h-\\[220px\\] {
  height: 220px;
}

.h-\\[22px\\] {
  height: 22px;
}

.h-\\[240px\\] {
  height: 240px;
}

.h-\\[242px\\] {
  height: 242px;
}

.h-\\[24px\\] {
  height: 24px;
}

.h-\\[25px\\] {
  height: 25px;
}

.h-\\[260px\\] {
  height: 260px;
}

.h-\\[278px\\] {
  height: 278px;
}

.h-\\[288px\\] {
  height: 288px;
}

.h-\\[28px\\] {
  height: 28px;
}

.h-\\[292px\\] {
  height: 292px;
}

.h-\\[2px\\] {
  height: 2px;
}

.h-\\[300px\\] {
  height: 300px;
}

.h-\\[320px\\] {
  height: 320px;
}

.h-\\[32px\\] {
  height: 32px;
}

.h-\\[34px\\] {
  height: 34px;
}

.h-\\[360px\\] {
  height: 360px;
}

.h-\\[368px\\] {
  height: 368px;
}

.h-\\[36px\\] {
  height: 36px;
}

.h-\\[38px\\] {
  height: 38px;
}

.h-\\[400px\\] {
  height: 400px;
}

.h-\\[40px\\] {
  height: 40px;
}

.h-\\[42px\\] {
  height: 42px;
}

.h-\\[44px\\] {
  height: 44px;
}

.h-\\[466px\\] {
  height: 466px;
}

.h-\\[46px\\] {
  height: 46px;
}

.h-\\[470px\\] {
  height: 470px;
}

.h-\\[47px\\] {
  height: 47px;
}

.h-\\[48px\\] {
  height: 48px;
}

.h-\\[4px\\] {
  height: 4px;
}

.h-\\[500px\\] {
  height: 500px;
}

.h-\\[52px\\] {
  height: 52px;
}

.h-\\[547px\\] {
  height: 547px;
}

.h-\\[55px\\] {
  height: 55px;
}

.h-\\[56px\\] {
  height: 56px;
}

.h-\\[572px\\] {
  height: 572px;
}

.h-\\[5px\\] {
  height: 5px;
}

.h-\\[600px\\] {
  height: 600px;
}

.h-\\[60px\\] {
  height: 60px;
}

.h-\\[620px\\] {
  height: 620px;
}

.h-\\[640px\\] {
  height: 640px;
}

.h-\\[64px\\] {
  height: 64px;
}

.h-\\[650px\\] {
  height: 650px;
}

.h-\\[68px\\] {
  height: 68px;
}

.h-\\[70px\\] {
  height: 70px;
}

.h-\\[72px\\] {
  height: 72px;
}

.h-\\[78px\\] {
  height: 78px;
}

.h-\\[80\\%\\] {
  height: 80%;
}

.h-\\[800px\\] {
  height: 800px;
}

.h-\\[80px\\] {
  height: 80px;
}

.h-\\[84px\\] {
  height: 84px;
}

.h-\\[8px\\] {
  height: 8px;
}

.h-\\[92px\\] {
  height: 92px;
}

.h-\\[95px\\] {
  height: 95px;
}

.h-\\[9px\\] {
  height: 9px;
}

.h-\\[calc\\(100\\%-112px\\)\\] {
  height: calc(100% - 112px);
}

.h-\\[calc\\(100\\%-20px\\)\\] {
  height: calc(100% - 20px);
}

.h-\\[calc\\(100\\%-48px\\)\\] {
  height: calc(100% - 48px);
}

.h-\\[calc\\(100\\%-56px\\)\\] {
  height: calc(100% - 56px);
}

.h-\\[calc\\(100\\%-64px\\)\\] {
  height: calc(100% - 64px);
}

.h-\\[calc\\(100\\%_-_30px\\)\\] {
  height: calc(100% - 30px);
}

.h-auto {
  height: auto;
}

.h-fit {
  height: -moz-fit-content;
  height: fit-content;
}

.h-full {
  height: 100%;
}

.h-mini {
  height: var(--coze-16);
}

.h-px {
  height: 1px;
}

.\\!max-h-\\[70vh\\] {
  max-height: 70vh !important;
}

.\\!max-h-\\[inherit\\] {
  max-height: inherit !important;
}

.\\!max-h-\\[none\\], .\\!max-h-none {
  max-height: none !important;
}

.max-h-40 {
  max-height: 10rem;
}

.max-h-44 {
  max-height: 11rem;
}

.max-h-\\[108px\\] {
  max-height: 108px;
}

.max-h-\\[122px\\] {
  max-height: 122px;
}

.max-h-\\[188px\\] {
  max-height: 188px;
}

.max-h-\\[200px\\] {
  max-height: 200px;
}

.max-h-\\[208px\\] {
  max-height: 208px;
}

.max-h-\\[220px\\] {
  max-height: 220px;
}

.max-h-\\[260px\\] {
  max-height: 260px;
}

.max-h-\\[292px\\] {
  max-height: 292px;
}

.max-h-\\[300px\\] {
  max-height: 300px;
}

.max-h-\\[312px\\] {
  max-height: 312px;
}

.max-h-\\[320px\\] {
  max-height: 320px;
}

.max-h-\\[330px\\] {
  max-height: 330px;
}

.max-h-\\[350px\\] {
  max-height: 350px;
}

.max-h-\\[372px\\] {
  max-height: 372px;
}

.max-h-\\[400px\\] {
  max-height: 400px;
}

.max-h-\\[406px\\] {
  max-height: 406px;
}

.max-h-\\[440px\\] {
  max-height: 440px;
}

.max-h-\\[448px\\] {
  max-height: 448px;
}

.max-h-\\[44px\\] {
  max-height: 44px;
}

.max-h-\\[450px\\] {
  max-height: 450px;
}

.max-h-\\[480px\\] {
  max-height: 480px;
}

.max-h-\\[500px\\] {
  max-height: 500px;
}

.max-h-\\[50vh\\] {
  max-height: 50vh;
}

.max-h-\\[560px\\] {
  max-height: 560px;
}

.max-h-\\[600px\\] {
  max-height: 600px;
}

.max-h-\\[620px\\] {
  max-height: 620px;
}

.max-h-\\[640px\\] {
  max-height: 640px;
}

.max-h-\\[68vh\\] {
  max-height: 68vh;
}

.max-h-\\[713px\\] {
  max-height: 713px;
}

.max-h-\\[80\\%\\] {
  max-height: 80%;
}

.max-h-\\[852px\\] {
  max-height: 852px;
}

.max-h-\\[auto\\] {
  max-height: auto;
}

.max-h-\\[inherit\\] {
  max-height: inherit;
}

.max-h-full {
  max-height: 100%;
}

.\\!min-h-\\[100px\\] {
  min-height: 100px !important;
}

.\\!min-h-\\[22px\\] {
  min-height: 22px !important;
}

.\\!min-h-\\[24px\\] {
  min-height: 24px !important;
}

.min-h-0 {
  min-height: 0;
}

.min-h-\\[100\\%\\] {
  min-height: 100%;
}

.min-h-\\[102px\\] {
  min-height: 102px;
}

.min-h-\\[132px\\] {
  min-height: 132px;
}

.min-h-\\[152px\\] {
  min-height: 152px;
}

.min-h-\\[154px\\] {
  min-height: 154px;
}

.min-h-\\[20px\\] {
  min-height: 20px;
}

.min-h-\\[24px\\] {
  min-height: 24px;
}

.min-h-\\[300px\\] {
  min-height: 300px;
}

.min-h-\\[32px\\] {
  min-height: 32px;
}

.min-h-\\[360px\\] {
  min-height: 360px;
}

.min-h-\\[388px\\] {
  min-height: 388px;
}

.min-h-\\[400px\\] {
  min-height: 400px;
}

.min-h-\\[40px\\] {
  min-height: 40px;
}

.min-h-\\[44px\\] {
  min-height: 44px;
}

.min-h-\\[472px\\] {
  min-height: 472px;
}

.min-h-\\[52px\\] {
  min-height: 52px;
}

.min-h-\\[560px\\] {
  min-height: 560px;
}

.min-h-\\[56px\\] {
  min-height: 56px;
}

.min-h-\\[600px\\] {
  min-height: 600px;
}

.min-h-\\[650px\\] {
  min-height: 650px;
}

.min-h-\\[80px\\] {
  min-height: 80px;
}

.min-h-\\[90px\\] {
  min-height: 90px;
}

.min-h-full {
  min-height: 100%;
}

.\\!w-0 {
  width: 0 !important;
}

.\\!w-1\\/2 {
  width: 50% !important;
}

.\\!w-24 {
  width: 6rem !important;
}

.\\!w-3 {
  width: .75rem !important;
}

.\\!w-4 {
  width: 1rem !important;
}

.\\!w-5 {
  width: 1.25rem !important;
}

.\\!w-6 {
  width: 1.5rem !important;
}

.\\!w-8 {
  width: 2rem !important;
}

.\\!w-\\[0px\\] {
  width: 0 !important;
}

.\\!w-\\[12px\\] {
  width: 12px !important;
}

.\\!w-\\[14px\\] {
  width: 14px !important;
}

.\\!w-\\[160px\\] {
  width: 160px !important;
}

.\\!w-\\[165px\\] {
  width: 165px !important;
}

.\\!w-\\[16px\\] {
  width: 16px !important;
}

.\\!w-\\[18px\\] {
  width: 18px !important;
}

.\\!w-\\[1px\\] {
  width: 1px !important;
}

.\\!w-\\[20px\\] {
  width: 20px !important;
}

.\\!w-\\[24px\\] {
  width: 24px !important;
}

.\\!w-\\[276px\\] {
  width: 276px !important;
}

.\\!w-\\[280px\\] {
  width: 280px !important;
}

.\\!w-\\[301px\\] {
  width: 301px !important;
}

.\\!w-\\[310px\\] {
  width: 310px !important;
}

.\\!w-\\[32px\\] {
  width: 32px !important;
}

.\\!w-\\[360px\\] {
  width: 360px !important;
}

.\\!w-\\[45px\\] {
  width: 45px !important;
}

.\\!w-\\[48px\\] {
  width: 48px !important;
}

.\\!w-\\[8px\\] {
  width: 8px !important;
}

.\\!w-fit {
  width: -moz-fit-content !important;
  width: fit-content !important;
}

.\\!w-full {
  width: 100% !important;
}

.w {
  width: var(--coze-32);
}

.w-0 {
  width: 0;
}

.w-0\\.5 {
  width: .125rem;
}

.w-1 {
  width: .25rem;
}

.w-1\\/2 {
  width: 50%;
}

.w-10 {
  width: 2.5rem;
}

.w-120px {
  width: var(--coze-120);
}

.w-12px {
  width: var(--coze-12);
}

.w-14 {
  width: 3.5rem;
}

.w-16 {
  width: 4rem;
}

.w-160px {
  width: var(--coze-160);
}

.w-16px {
  width: var(--coze-16);
}

.w-18px {
  width: var(--coze-18);
}

.w-2 {
  width: .5rem;
}

.w-2\\/3 {
  width: 66.6667%;
}

.w-24 {
  width: 6rem;
}

.w-240px {
  width: var(--coze-240);
}

.w-24px {
  width: var(--coze-24);
}

.w-28 {
  width: 7rem;
}

.w-3 {
  width: .75rem;
}

.w-3\\.5 {
  width: .875rem;
}

.w-32 {
  width: 8rem;
}

.w-32px {
  width: var(--coze-32);
}

.w-3px {
  width: var(--coze-3);
}

.w-4 {
  width: 1rem;
}

.w-40 {
  width: 10rem;
}

.w-48 {
  width: 12rem;
}

.w-48px {
  width: var(--coze-48);
}

.w-5 {
  width: 1.25rem;
}

.w-56 {
  width: 14rem;
}

.w-6 {
  width: 1.5rem;
}

.w-60 {
  width: 15rem;
}

.w-64px {
  width: var(--coze-64);
}

.w-72 {
  width: 18rem;
}

.w-8 {
  width: 2rem;
}

.w-80 {
  width: 20rem;
}

.w-80px {
  width: var(--coze-80);
}

.w-9 {
  width: 2.25rem;
}

.w-96 {
  width: 24rem;
}

.w-\\[100\\%\\] {
  width: 100%;
}

.w-\\[1000px\\] {
  width: 1000px;
}

.w-\\[100px\\] {
  width: 100px;
}

.w-\\[1024px\\] {
  width: 1024px;
}

.w-\\[104px\\] {
  width: 104px;
}

.w-\\[108px\\] {
  width: 108px;
}

.w-\\[10px\\] {
  width: 10px;
}

.w-\\[1105px\\] {
  width: 1105px;
}

.w-\\[110px\\] {
  width: 110px;
}

.w-\\[112px\\] {
  width: 112px;
}

.w-\\[115px\\] {
  width: 115px;
}

.w-\\[120px\\] {
  width: 120px;
}

.w-\\[122px\\] {
  width: 122px;
}

.w-\\[128px\\] {
  width: 128px;
}

.w-\\[12px\\] {
  width: 12px;
}

.w-\\[130px\\] {
  width: 130px;
}

.w-\\[133px\\] {
  width: 133px;
}

.w-\\[138px\\] {
  width: 138px;
}

.w-\\[140px\\] {
  width: 140px;
}

.w-\\[144px\\] {
  width: 144px;
}

.w-\\[145px\\] {
  width: 145px;
}

.w-\\[148px\\] {
  width: 148px;
}

.w-\\[14px\\] {
  width: 14px;
}

.w-\\[150px\\] {
  width: 150px;
}

.w-\\[156px\\] {
  width: 156px;
}

.w-\\[160px\\] {
  width: 160px;
}

.w-\\[162px\\] {
  width: 162px;
}

.w-\\[164px\\] {
  width: 164px;
}

.w-\\[166px\\] {
  width: 166px;
}

.w-\\[168px\\] {
  width: 168px;
}

.w-\\[16px\\] {
  width: 16px;
}

.w-\\[172px\\] {
  width: 172px;
}

.w-\\[174px\\] {
  width: 174px;
}

.w-\\[180px\\] {
  width: 180px;
}

.w-\\[182px\\] {
  width: 182px;
}

.w-\\[18px\\] {
  width: 18px;
}

.w-\\[190px\\] {
  width: 190px;
}

.w-\\[192px\\] {
  width: 192px;
}

.w-\\[196px\\] {
  width: 196px;
}

.w-\\[198px\\] {
  width: 198px;
}

.w-\\[1px\\] {
  width: 1px;
}

.w-\\[200px\\] {
  width: 200px;
}

.w-\\[205px\\] {
  width: 205px;
}

.w-\\[208px\\] {
  width: 208px;
}

.w-\\[20px\\] {
  width: 20px;
}

.w-\\[218px\\] {
  width: 218px;
}

.w-\\[220px\\] {
  width: 220px;
}

.w-\\[228px\\] {
  width: 228px;
}

.w-\\[22px\\] {
  width: 22px;
}

.w-\\[230px\\] {
  width: 230px;
}

.w-\\[240px\\] {
  width: 240px;
}

.w-\\[240xp\\] {
  width: 240xp;
}

.w-\\[244px\\] {
  width: 244px;
}

.w-\\[249px\\] {
  width: 249px;
}

.w-\\[24px\\] {
  width: 24px;
}

.w-\\[250px\\] {
  width: 250px;
}

.w-\\[260px\\] {
  width: 260px;
}

.w-\\[266px\\] {
  width: 266px;
}

.w-\\[26px\\] {
  width: 26px;
}

.w-\\[276px\\] {
  width: 276px;
}

.w-\\[280px\\] {
  width: 280px;
}

.w-\\[288px\\] {
  width: 288px;
}

.w-\\[28px\\] {
  width: 28px;
}

.w-\\[2px\\] {
  width: 2px;
}

.w-\\[300px\\] {
  width: 300px;
}

.w-\\[308px\\] {
  width: 308px;
}

.w-\\[314px\\] {
  width: 314px;
}

.w-\\[320px\\] {
  width: 320px;
}

.w-\\[326px\\] {
  width: 326px;
}

.w-\\[327px\\] {
  width: 327px;
}

.w-\\[32px\\] {
  width: 32px;
}

.w-\\[330px\\] {
  width: 330px;
}

.w-\\[33px\\] {
  width: 33px;
}

.w-\\[340px\\] {
  width: 340px;
}

.w-\\[347px\\] {
  width: 347px;
}

.w-\\[34px\\] {
  width: 34px;
}

.w-\\[350px\\] {
  width: 350px;
}

.w-\\[352px\\] {
  width: 352px;
}

.w-\\[360px\\] {
  width: 360px;
}

.w-\\[36px\\] {
  width: 36px;
}

.w-\\[370px\\] {
  width: 370px;
}

.w-\\[380px\\] {
  width: 380px;
}

.w-\\[3px\\] {
  width: 3px;
}

.w-\\[400px\\] {
  width: 400px;
}

.w-\\[40px\\] {
  width: 40px;
}

.w-\\[410px\\] {
  width: 410px;
}

.w-\\[420px\\] {
  width: 420px;
}

.w-\\[42px\\] {
  width: 42px;
}

.w-\\[46px\\] {
  width: 46px;
}

.w-\\[480px\\] {
  width: 480px;
}

.w-\\[482px\\] {
  width: 482px;
}

.w-\\[48px\\] {
  width: 48px;
}

.w-\\[492px\\] {
  width: 492px;
}

.w-\\[494px\\] {
  width: 494px;
}

.w-\\[4px\\] {
  width: 4px;
}

.w-\\[50\\%\\] {
  width: 50%;
}

.w-\\[50px\\] {
  width: 50px;
}

.w-\\[512px\\] {
  width: 512px;
}

.w-\\[520px\\] {
  width: 520px;
}

.w-\\[52px\\] {
  width: 52px;
}

.w-\\[536px\\] {
  width: 536px;
}

.w-\\[53px\\] {
  width: 53px;
}

.w-\\[560px\\] {
  width: 560px;
}

.w-\\[5px\\] {
  width: 5px;
}

.w-\\[600px\\] {
  width: 600px;
}

.w-\\[60px\\] {
  width: 60px;
}

.w-\\[612px\\] {
  width: 612px;
}

.w-\\[620px\\] {
  width: 620px;
}

.w-\\[625px\\] {
  width: 625px;
}

.w-\\[640px\\] {
  width: 640px;
}

.w-\\[64px\\] {
  width: 64px;
}

.w-\\[660px\\] {
  width: 660px;
}

.w-\\[69px\\] {
  width: 69px;
}

.w-\\[6px\\] {
  width: 6px;
}

.w-\\[70px\\] {
  width: 70px;
}

.w-\\[71px\\] {
  width: 71px;
}

.w-\\[72px\\] {
  width: 72px;
}

.w-\\[746px\\] {
  width: 746px;
}

.w-\\[800px\\] {
  width: 800px;
}

.w-\\[80px\\] {
  width: 80px;
}

.w-\\[88px\\] {
  width: 88px;
}

.w-\\[8px\\] {
  width: 8px;
}

.w-\\[90px\\] {
  width: 90px;
}

.w-\\[92px\\] {
  width: 92px;
}

.w-\\[95\\%\\] {
  width: 95%;
}

.w-\\[95px\\] {
  width: 95px;
}

.w-\\[96px\\] {
  width: 96px;
}

.w-\\[calc\\(100\\%-20px\\)\\] {
  width: calc(100% - 20px);
}

.w-\\[calc\\(100\\%-24px\\)\\] {
  width: calc(100% - 24px);
}

.w-\\[calc\\(100\\%-300px\\)\\] {
  width: calc(100% - 300px);
}

.w-\\[calc\\(100\\%-76px\\)\\] {
  width: calc(100% - 76px);
}

.w-auto {
  width: auto;
}

.w-fit {
  width: -moz-fit-content;
  width: fit-content;
}

.w-full {
  width: 100%;
}

.w-max {
  width: -moz-max-content;
  width: max-content;
}

.\\!min-w-0 {
  min-width: 0 !important;
}

.\\!min-w-\\[10px\\] {
  min-width: 10px !important;
}

.\\!min-w-\\[16px\\] {
  min-width: 16px !important;
}

.\\!min-w-\\[20px\\] {
  min-width: 20px !important;
}

.\\!min-w-\\[24px\\] {
  min-width: 24px !important;
}

.\\!min-w-\\[280px\\] {
  min-width: 280px !important;
}

.\\!min-w-\\[300px\\] {
  min-width: 300px !important;
}

.\\!min-w-\\[380px\\] {
  min-width: 380px !important;
}

.\\!min-w-\\[400px\\] {
  min-width: 400px !important;
}

.\\!min-w-\\[70px\\] {
  min-width: 70px !important;
}

.\\!min-w-\\[98px\\] {
  min-width: 98px !important;
}

.\\!min-w-min {
  min-width: -moz-min-content !important;
  min-width: min-content !important;
}

.min-w-0, .min-w-\\[0px\\] {
  min-width: 0;
}

.min-w-\\[100px\\] {
  min-width: 100px;
}

.min-w-\\[120px\\] {
  min-width: 120px;
}

.min-w-\\[128px\\] {
  min-width: 128px;
}

.min-w-\\[136px\\] {
  min-width: 136px;
}

.min-w-\\[150px\\] {
  min-width: 150px;
}

.min-w-\\[152px\\] {
  min-width: 152px;
}

.min-w-\\[160px\\] {
  min-width: 160px;
}

.min-w-\\[16px\\] {
  min-width: 16px;
}

.min-w-\\[170px\\] {
  min-width: 170px;
}

.min-w-\\[190px\\] {
  min-width: 190px;
}

.min-w-\\[200px\\] {
  min-width: 200px;
}

.min-w-\\[240px\\] {
  min-width: 240px;
}

.min-w-\\[24px\\] {
  min-width: 24px;
}

.min-w-\\[250px\\] {
  min-width: 250px;
}

.min-w-\\[25px\\] {
  min-width: 25px;
}

.min-w-\\[260px\\] {
  min-width: 260px;
}

.min-w-\\[280px\\] {
  min-width: 280px;
}

.min-w-\\[282px\\] {
  min-width: 282px;
}

.min-w-\\[28px\\] {
  min-width: 28px;
}

.min-w-\\[300px\\] {
  min-width: 300px;
}

.min-w-\\[30px\\] {
  min-width: 30px;
}

.min-w-\\[320px\\] {
  min-width: 320px;
}

.min-w-\\[324px\\] {
  min-width: 324px;
}

.min-w-\\[32px\\] {
  min-width: 32px;
}

.min-w-\\[330px\\] {
  min-width: 330px;
}

.min-w-\\[340px\\] {
  min-width: 340px;
}

.min-w-\\[350px\\] {
  min-width: 350px;
}

.min-w-\\[400px\\] {
  min-width: 400px;
}

.min-w-\\[40px\\] {
  min-width: 40px;
}

.min-w-\\[42px\\] {
  min-width: 42px;
}

.min-w-\\[480px\\] {
  min-width: 480px;
}

.min-w-\\[50px\\] {
  min-width: 50px;
}

.min-w-\\[512px\\] {
  min-width: 512px;
}

.min-w-\\[60px\\] {
  min-width: 60px;
}

.min-w-\\[610px\\] {
  min-width: 610px;
}

.min-w-\\[64px\\] {
  min-width: 64px;
}

.min-w-\\[65\\%\\] {
  min-width: 65%;
}

.min-w-\\[746px\\] {
  min-width: 746px;
}

.min-w-\\[75px\\] {
  min-width: 75px;
}

.min-w-\\[800px\\] {
  min-width: 800px;
}

.min-w-\\[80px\\] {
  min-width: 80px;
}

.min-w-\\[820px\\] {
  min-width: 820px;
}

.min-w-\\[900px\\] {
  min-width: 900px;
}

.min-w-\\[90px\\] {
  min-width: 90px;
}

.min-w-\\[96px\\] {
  min-width: 96px;
}

.min-w-\\[980px\\] {
  min-width: 980px;
}

.min-w-fit {
  min-width: -moz-fit-content;
  min-width: fit-content;
}

.min-w-full {
  min-width: 100%;
}

.min-w-min {
  min-width: -moz-min-content;
  min-width: min-content;
}

.\\!max-w-\\[100px\\] {
  max-width: 100px !important;
}

.\\!max-w-\\[115px\\] {
  max-width: 115px !important;
}

.\\!max-w-\\[130px\\] {
  max-width: 130px !important;
}

.\\!max-w-\\[160px\\] {
  max-width: 160px !important;
}

.\\!max-w-\\[180px\\] {
  max-width: 180px !important;
}

.\\!max-w-\\[200px\\] {
  max-width: 200px !important;
}

.\\!max-w-\\[240px\\] {
  max-width: 240px !important;
}

.\\!max-w-\\[24px\\] {
  max-width: 24px !important;
}

.\\!max-w-\\[260px\\] {
  max-width: 260px !important;
}

.\\!max-w-\\[280px\\] {
  max-width: 280px !important;
}

.\\!max-w-\\[301px\\] {
  max-width: 301px !important;
}

.\\!max-w-\\[320px\\] {
  max-width: 320px !important;
}

.\\!max-w-\\[370px\\] {
  max-width: 370px !important;
}

.\\!max-w-\\[400px\\] {
  max-width: 400px !important;
}

.\\!max-w-\\[600px\\] {
  max-width: 600px !important;
}

.\\!max-w-\\[65px\\] {
  max-width: 65px !important;
}

.\\!max-w-\\[680px\\] {
  max-width: 680px !important;
}

.\\!max-w-full {
  max-width: 100% !important;
}

.max-w-\\[100\\%\\] {
  max-width: 100%;
}

.max-w-\\[1000px\\] {
  max-width: 1000px;
}

.max-w-\\[100px\\] {
  max-width: 100px;
}

.max-w-\\[100vw\\] {
  max-width: 100vw;
}

.max-w-\\[120px\\] {
  max-width: 120px;
}

.max-w-\\[130px\\] {
  max-width: 130px;
}

.max-w-\\[136px\\] {
  max-width: 136px;
}

.max-w-\\[144px\\] {
  max-width: 144px;
}

.max-w-\\[150px\\] {
  max-width: 150px;
}

.max-w-\\[156px\\] {
  max-width: 156px;
}

.max-w-\\[160px\\] {
  max-width: 160px;
}

.max-w-\\[176px\\] {
  max-width: 176px;
}

.max-w-\\[180px\\] {
  max-width: 180px;
}

.max-w-\\[195px\\] {
  max-width: 195px;
}

.max-w-\\[198px\\] {
  max-width: 198px;
}

.max-w-\\[200px\\] {
  max-width: 200px;
}

.max-w-\\[206px\\] {
  max-width: 206px;
}

.max-w-\\[210px\\] {
  max-width: 210px;
}

.max-w-\\[220px\\] {
  max-width: 220px;
}

.max-w-\\[224px\\] {
  max-width: 224px;
}

.max-w-\\[226px\\] {
  max-width: 226px;
}

.max-w-\\[230px\\] {
  max-width: 230px;
}

.max-w-\\[240px\\] {
  max-width: 240px;
}

.max-w-\\[250px\\] {
  max-width: 250px;
}

.max-w-\\[260px\\] {
  max-width: 260px;
}

.max-w-\\[270px\\] {
  max-width: 270px;
}

.max-w-\\[280px\\] {
  max-width: 280px;
}

.max-w-\\[300px\\] {
  max-width: 300px;
}

.max-w-\\[320px\\] {
  max-width: 320px;
}

.max-w-\\[330px\\] {
  max-width: 330px;
}

.max-w-\\[37\\%\\] {
  max-width: 37%;
}

.max-w-\\[380px\\] {
  max-width: 380px;
}

.max-w-\\[400px\\] {
  max-width: 400px;
}

.max-w-\\[432px\\] {
  max-width: 432px;
}

.max-w-\\[460px\\] {
  max-width: 460px;
}

.max-w-\\[540px\\] {
  max-width: 540px;
}

.max-w-\\[546px\\] {
  max-width: 546px;
}

.max-w-\\[570px\\] {
  max-width: 570px;
}

.max-w-\\[60\\%\\] {
  max-width: 60%;
}

.max-w-\\[600px\\] {
  max-width: 600px;
}

.max-w-\\[603px\\] {
  max-width: 603px;
}

.max-w-\\[698px\\] {
  max-width: 698px;
}

.max-w-\\[746px\\] {
  max-width: 746px;
}

.max-w-\\[750px\\] {
  max-width: 750px;
}

.max-w-\\[80\\%\\] {
  max-width: 80%;
}

.max-w-\\[800px\\] {
  max-width: 800px;
}

.max-w-\\[80px\\] {
  max-width: 80px;
}

.max-w-\\[86px\\] {
  max-width: 86px;
}

.max-w-\\[912px\\] {
  max-width: 912px;
}

.max-w-\\[calc\\(100\\%-100px\\)\\] {
  max-width: calc(100% - 100px);
}

.max-w-\\[calc\\(100\\%-44px\\)\\] {
  max-width: calc(100% - 44px);
}

.max-w-\\[calc\\(100\\%_-_24px\\)\\] {
  max-width: calc(100% - 24px);
}

.max-w-\\[calc\\(100vw-170px\\)\\] {
  max-width: calc(100vw - 170px);
}

.max-w-fit {
  max-width: -moz-fit-content;
  max-width: fit-content;
}

.max-w-full {
  max-width: 100%;
}

.\\!flex-1 {
  flex: 1 !important;
}

.flex-1 {
  flex: 1;
}

.flex-\\[0_0_49\\%\\] {
  flex: 0 0 49%;
}

.flex-\\[0_0_auto\\] {
  flex: none;
}

.flex-\\[1\\] {
  flex: 1;
}

.flex-\\[2\\], .flex-\\[2_1_0\\%\\] {
  flex: 2;
}

.flex-\\[3\\] {
  flex: 3;
}

.flex-auto {
  flex: auto;
}

.flex-none {
  flex: none;
}

.\\!flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink {
  flex-shrink: 1;
}

.flex-shrink-0 {
  flex-shrink: 0;
}

.shrink {
  flex-shrink: 1;
}

.shrink-0 {
  flex-shrink: 0;
}

.flex-grow {
  flex-grow: 1;
}

.flex-grow-0 {
  flex-grow: 0;
}

.grow {
  flex-grow: 1;
}

.grow-0 {
  flex-grow: 0;
}

.grow-\\[1\\] {
  flex-grow: 1;
}

.basis {
  flex-basis: var(--coze-8);
}

.basis-1\\/2 {
  flex-basis: 50%;
}

.basis-1\\/3 {
  flex-basis: 33.3333%;
}

.basis-2\\/3 {
  flex-basis: 66.6667%;
}

.basis-40 {
  flex-basis: 10rem;
}

.basis-80 {
  flex-basis: 20rem;
}

.basis-\\[0\\] {
  flex-basis: 0;
}

.basis-\\[122px\\] {
  flex-basis: 122px;
}

.basis-\\[128px\\] {
  flex-basis: 128px;
}

.basis-\\[130px\\] {
  flex-basis: 130px;
}

.basis-\\[140px\\] {
  flex-basis: 140px;
}

.basis-\\[164px\\] {
  flex-basis: 164px;
}

.basis-\\[166px\\] {
  flex-basis: 166px;
}

.basis-full {
  flex-basis: 100%;
}

.table-fixed {
  table-layout: fixed;
}

.border-collapse {
  border-collapse: collapse;
}

.\\!translate-x-\\[-6px\\] {
  --tw-translate-x: -6px !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.-translate-x-1\\/2, .-translate-x-\\[50\\%\\] {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.-translate-y-1\\/2, .-translate-y-\\[50\\%\\] {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-\\[-50\\%\\] {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-\\[5px\\] {
  --tw-translate-x: 5px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-y-\\[-50\\%\\] {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-y-\\[-60\\%\\] {
  --tw-translate-y: -60%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.-rotate-90 {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.rotate-0 {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.rotate-\\[135deg\\] {
  --tw-rotate: 135deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.scale-50 {
  --tw-scale-x: .5;
  --tw-scale-y: .5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.scale-x-\\[-1\\] {
  --tw-scale-x: -1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\!transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: 1s linear infinite spin;
}

.\\!cursor-default {
  cursor: default !important;
}

.\\!cursor-not-allowed {
  cursor: not-allowed !important;
}

.cursor-auto {
  cursor: auto;
}

.cursor-col-resize {
  cursor: col-resize;
}

.cursor-default {
  cursor: default;
}

.cursor-grab {
  cursor: grab;
}

.cursor-grabbing {
  cursor: grabbing;
}

.cursor-help {
  cursor: help;
}

.cursor-move {
  cursor: move;
}

.cursor-nesw-resize {
  cursor: nesw-resize;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.cursor-nwse-resize {
  cursor: nwse-resize;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-text {
  cursor: text;
}

.cursor-zoom-in {
  cursor: zoom-in;
}

.select-none {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.select-text {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}

.select-all {
  -webkit-user-select: all;
  -moz-user-select: all;
  -ms-user-select: all;
  user-select: all;
}

.select-auto {
  -webkit-user-select: auto;
  -moz-user-select: auto;
  -ms-user-select: auto;
  user-select: auto;
}

.resize {
  resize: both;
}

.columns-5 {
  -moz-columns: 5;
  columns: 5;
}

.grid-flow-row {
  grid-auto-flow: row;
}

.grid-flow-col {
  grid-auto-flow: column;
}

.grid-flow-dense {
  grid-auto-flow: dense;
}

.grid-flow-row-dense {
  grid-auto-flow: row dense;
}

.grid-flow-col-dense {
  grid-auto-flow: column dense;
}

.auto-rows-min {
  grid-auto-rows: min-content;
}

.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.grid-cols-10 {
  grid-template-columns: repeat(10, minmax(0, 1fr));
}

.grid-cols-11 {
  grid-template-columns: repeat(11, minmax(0, 1fr));
}

.grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}

.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.grid-cols-6 {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

.grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}

.grid-cols-8 {
  grid-template-columns: repeat(8, minmax(0, 1fr));
}

.grid-cols-9 {
  grid-template-columns: repeat(9, minmax(0, 1fr));
}

.grid-cols-\\[150px_minmax\\(0\\,1fr\\)\\] {
  grid-template-columns: 150px minmax(0, 1fr);
}

.grid-cols-\\[150px_minmax\\(0\\,1fr\\)_104px\\] {
  grid-template-columns: 150px minmax(0, 1fr) 104px;
}

.grid-cols-\\[5fr_5fr_8fr\\] {
  grid-template-columns: 5fr 5fr 8fr;
}

.grid-cols-\\[auto\\,1fr\\] {
  grid-template-columns: auto 1fr;
}

.grid-cols-\\[repeat\\(auto-fill\\,minmax\\(190px\\,1fr\\)\\)\\] {
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
}

.grid-cols-none {
  grid-template-columns: none;
}

.grid-rows-1 {
  grid-template-rows: repeat(1, minmax(0, 1fr));
}

.grid-rows-2 {
  grid-template-rows: repeat(2, minmax(0, 1fr));
}

.grid-rows-3 {
  grid-template-rows: repeat(3, minmax(0, 1fr));
}

.grid-rows-4 {
  grid-template-rows: repeat(4, minmax(0, 1fr));
}

.grid-rows-5 {
  grid-template-rows: repeat(5, minmax(0, 1fr));
}

.grid-rows-6 {
  grid-template-rows: repeat(6, minmax(0, 1fr));
}

.grid-rows-none {
  grid-template-rows: none;
}

.\\!flex-row {
  flex-direction: row !important;
}

.flex-row {
  flex-direction: row;
}

.flex-row-reverse {
  flex-direction: row-reverse;
}

.\\!flex-col {
  flex-direction: column !important;
}

.flex-col {
  flex-direction: column;
}

.flex-col-reverse {
  flex-direction: column-reverse;
}

.flex-wrap {
  flex-wrap: wrap;
}

.\\!flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap;
}

.content-center {
  align-content: center;
}

.\\!items-start {
  align-items: flex-start !important;
}

.items-start {
  align-items: flex-start;
}

.items-end {
  align-items: flex-end;
}

.\\!items-center {
  align-items: center !important;
}

.items-center {
  align-items: center;
}

.items-baseline {
  align-items: baseline;
}

.items-stretch {
  align-items: stretch;
}

.justify-start {
  justify-content: flex-start;
}

.justify-end {
  justify-content: flex-end;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.justify-evenly {
  justify-content: space-evenly;
}

.justify-stretch {
  justify-content: stretch;
}

.justify-items-center {
  justify-items: center;
}

.\\!gap-0 {
  gap: 0 !important;
}

.\\!gap-1 {
  gap: .25rem !important;
}

.gap {
  gap: var(--coze-8);
}

.gap-0 {
  gap: 0;
}

.gap-0\\.5 {
  gap: .125rem;
}

.gap-1 {
  gap: .25rem;
}

.gap-1\\.5 {
  gap: .375rem;
}

.gap-10 {
  gap: 2.5rem;
}

.gap-1080px {
  gap: var(--coze-1080);
}

.gap-10px {
  gap: var(--coze-10);
}

.gap-11 {
  gap: 2.75rem;
}

.gap-12 {
  gap: 3rem;
}

.gap-120px {
  gap: var(--coze-120);
}

.gap-12px {
  gap: var(--coze-12);
}

.gap-14 {
  gap: 3.5rem;
}

.gap-14px {
  gap: var(--coze-14);
}

.gap-15px {
  gap: var(--coze-15);
}

.gap-16 {
  gap: 4rem;
}

.gap-160px {
  gap: var(--coze-160);
}

.gap-16px {
  gap: var(--coze-16);
}

.gap-18px {
  gap: var(--coze-18);
}

.gap-1px {
  gap: var(--coze-1);
}

.gap-2 {
  gap: .5rem;
}

.gap-2\\.5 {
  gap: .625rem;
}

.gap-20 {
  gap: 5rem;
}

.gap-200px {
  gap: var(--coze-200);
}

.gap-20px {
  gap: var(--coze-20);
}

.gap-22px {
  gap: var(--coze-22);
}

.gap-24 {
  gap: 6rem;
}

.gap-240px {
  gap: var(--coze-240);
}

.gap-24px {
  gap: var(--coze-24);
}

.gap-26px {
  gap: var(--coze-26);
}

.gap-28 {
  gap: 7rem;
}

.gap-28px {
  gap: var(--coze-28);
}

.gap-2px {
  gap: var(--coze-2);
}

.gap-3 {
  gap: .75rem;
}

.gap-3\\.5 {
  gap: .875rem;
}

.gap-30px {
  gap: var(--coze-30);
}

.gap-32 {
  gap: 8rem;
}

.gap-320px {
  gap: var(--coze-320);
}

.gap-32px {
  gap: var(--coze-32);
}

.gap-36 {
  gap: 9rem;
}

.gap-3px {
  gap: var(--coze-3);
}

.gap-4 {
  gap: 1rem;
}

.gap-40 {
  gap: 10rem;
}

.gap-40px {
  gap: var(--coze-40);
}

.gap-44 {
  gap: 11rem;
}

.gap-48 {
  gap: 12rem;
}

.gap-480px {
  gap: var(--coze-480);
}

.gap-48px {
  gap: var(--coze-48);
}

.gap-4px {
  gap: var(--coze-4);
}

.gap-5 {
  gap: 1.25rem;
}

.gap-52 {
  gap: 13rem;
}

.gap-56 {
  gap: 14rem;
}

.gap-5px {
  gap: var(--coze-5);
}

.gap-6 {
  gap: 1.5rem;
}

.gap-60 {
  gap: 15rem;
}

.gap-64 {
  gap: 16rem;
}

.gap-640px {
  gap: var(--coze-640);
}

.gap-64px {
  gap: var(--coze-64);
}

.gap-6px {
  gap: var(--coze-6);
}

.gap-7 {
  gap: 1.75rem;
}

.gap-72 {
  gap: 18rem;
}

.gap-8 {
  gap: 2rem;
}

.gap-80 {
  gap: 20rem;
}

.gap-800px {
  gap: var(--coze-800);
}

.gap-80px {
  gap: var(--coze-80);
}

.gap-8px {
  gap: var(--coze-8);
}

.gap-9 {
  gap: 2.25rem;
}

.gap-96 {
  gap: 24rem;
}

.gap-96px {
  gap: var(--coze-96);
}

.gap-9px {
  gap: var(--coze-9);
}

.gap-\\[10px\\] {
  gap: 10px;
}

.gap-\\[12px\\] {
  gap: 12px;
}

.gap-\\[13px\\] {
  gap: 13px;
}

.gap-\\[14px\\] {
  gap: 14px;
}

.gap-\\[16px\\] {
  gap: 16px;
}

.gap-\\[1px\\] {
  gap: 1px;
}

.gap-\\[20px\\] {
  gap: 20px;
}

.gap-\\[24px\\] {
  gap: 24px;
}

.gap-\\[2px\\] {
  gap: 2px;
}

.gap-\\[32px\\] {
  gap: 32px;
}

.gap-\\[3px\\] {
  gap: 3px;
}

.gap-\\[40px\\] {
  gap: 40px;
}

.gap-\\[44px\\] {
  gap: 44px;
}

.gap-\\[4px\\] {
  gap: 4px;
}

.gap-\\[5px\\] {
  gap: 5px;
}

.gap-\\[6px\\] {
  gap: 6px;
}

.gap-\\[7px\\] {
  gap: 7px;
}

.gap-\\[8px\\] {
  gap: 8px;
}

.gap-base {
  gap: 16px;
}

.gap-base-loose {
  gap: 20px;
}

.gap-base-tight {
  gap: 12px;
}

.gap-extra-loose {
  gap: 32px;
}

.gap-extra-tight {
  gap: 4px;
}

.gap-large {
  gap: var(--coze-40);
}

.gap-loose {
  gap: 24px;
}

.gap-md {
  gap: var(--coze-64);
}

.gap-mini {
  gap: var(--coze-16);
}

.gap-mm {
  gap: var(--coze-48);
}

.gap-none {
  gap: 0;
}

.gap-normal {
  gap: var(--coze-32);
}

.gap-px {
  gap: 1px;
}

.gap-small {
  gap: var(--coze-20);
}

.gap-super-loose {
  gap: 40px;
}

.gap-super-tight {
  gap: 2px;
}

.gap-tight {
  gap: 8px;
}

.gap-xl {
  gap: var(--coze-80);
}

.gap-xxl {
  gap: var(--coze-96);
}

.gap-x {
  -moz-column-gap: var(--coze-8);
  column-gap: var(--coze-8);
}

.gap-x-0 {
  -moz-column-gap: 0px;
  column-gap: 0;
}

.gap-x-0\\.5 {
  -moz-column-gap: .125rem;
  column-gap: .125rem;
}

.gap-x-1 {
  -moz-column-gap: .25rem;
  column-gap: .25rem;
}

.gap-x-1\\.5 {
  -moz-column-gap: .375rem;
  column-gap: .375rem;
}

.gap-x-10 {
  -moz-column-gap: 2.5rem;
  column-gap: 2.5rem;
}

.gap-x-1080px {
  -moz-column-gap: var(--coze-1080);
  column-gap: var(--coze-1080);
}

.gap-x-10px {
  -moz-column-gap: var(--coze-10);
  column-gap: var(--coze-10);
}

.gap-x-11 {
  -moz-column-gap: 2.75rem;
  column-gap: 2.75rem;
}

.gap-x-12 {
  -moz-column-gap: 3rem;
  column-gap: 3rem;
}

.gap-x-120px {
  -moz-column-gap: var(--coze-120);
  column-gap: var(--coze-120);
}

.gap-x-12px {
  -moz-column-gap: var(--coze-12);
  column-gap: var(--coze-12);
}

.gap-x-14 {
  -moz-column-gap: 3.5rem;
  column-gap: 3.5rem;
}

.gap-x-14px {
  -moz-column-gap: var(--coze-14);
  column-gap: var(--coze-14);
}

.gap-x-15px {
  -moz-column-gap: var(--coze-15);
  column-gap: var(--coze-15);
}

.gap-x-16 {
  -moz-column-gap: 4rem;
  column-gap: 4rem;
}

.gap-x-160px {
  -moz-column-gap: var(--coze-160);
  column-gap: var(--coze-160);
}

.gap-x-16px {
  -moz-column-gap: var(--coze-16);
  column-gap: var(--coze-16);
}

.gap-x-18px {
  -moz-column-gap: var(--coze-18);
  column-gap: var(--coze-18);
}

.gap-x-1px {
  -moz-column-gap: var(--coze-1);
  column-gap: var(--coze-1);
}

.gap-x-2 {
  -moz-column-gap: .5rem;
  column-gap: .5rem;
}

.gap-x-2\\.5 {
  -moz-column-gap: .625rem;
  column-gap: .625rem;
}

.gap-x-20 {
  -moz-column-gap: 5rem;
  column-gap: 5rem;
}

.gap-x-200px {
  -moz-column-gap: var(--coze-200);
  column-gap: var(--coze-200);
}

.gap-x-20px {
  -moz-column-gap: var(--coze-20);
  column-gap: var(--coze-20);
}

.gap-x-22px {
  -moz-column-gap: var(--coze-22);
  column-gap: var(--coze-22);
}

.gap-x-24 {
  -moz-column-gap: 6rem;
  column-gap: 6rem;
}

.gap-x-240px {
  -moz-column-gap: var(--coze-240);
  column-gap: var(--coze-240);
}

.gap-x-24px {
  -moz-column-gap: var(--coze-24);
  column-gap: var(--coze-24);
}

.gap-x-26px {
  -moz-column-gap: var(--coze-26);
  column-gap: var(--coze-26);
}

.gap-x-28 {
  -moz-column-gap: 7rem;
  column-gap: 7rem;
}

.gap-x-28px {
  -moz-column-gap: var(--coze-28);
  column-gap: var(--coze-28);
}

.gap-x-2px {
  -moz-column-gap: var(--coze-2);
  column-gap: var(--coze-2);
}

.gap-x-3 {
  -moz-column-gap: .75rem;
  column-gap: .75rem;
}

.gap-x-3\\.5 {
  -moz-column-gap: .875rem;
  column-gap: .875rem;
}

.gap-x-30px {
  -moz-column-gap: var(--coze-30);
  column-gap: var(--coze-30);
}

.gap-x-32 {
  -moz-column-gap: 8rem;
  column-gap: 8rem;
}

.gap-x-320px {
  -moz-column-gap: var(--coze-320);
  column-gap: var(--coze-320);
}

.gap-x-32px {
  -moz-column-gap: var(--coze-32);
  column-gap: var(--coze-32);
}

.gap-x-36 {
  -moz-column-gap: 9rem;
  column-gap: 9rem;
}

.gap-x-3px {
  -moz-column-gap: var(--coze-3);
  column-gap: var(--coze-3);
}

.gap-x-4 {
  -moz-column-gap: 1rem;
  column-gap: 1rem;
}

.gap-x-40 {
  -moz-column-gap: 10rem;
  column-gap: 10rem;
}

.gap-x-40px {
  -moz-column-gap: var(--coze-40);
  column-gap: var(--coze-40);
}

.gap-x-44 {
  -moz-column-gap: 11rem;
  column-gap: 11rem;
}

.gap-x-48 {
  -moz-column-gap: 12rem;
  column-gap: 12rem;
}

.gap-x-480px {
  -moz-column-gap: var(--coze-480);
  column-gap: var(--coze-480);
}

.gap-x-48px {
  -moz-column-gap: var(--coze-48);
  column-gap: var(--coze-48);
}

.gap-x-4px {
  -moz-column-gap: var(--coze-4);
  column-gap: var(--coze-4);
}

.gap-x-5 {
  -moz-column-gap: 1.25rem;
  column-gap: 1.25rem;
}

.gap-x-52 {
  -moz-column-gap: 13rem;
  column-gap: 13rem;
}

.gap-x-56 {
  -moz-column-gap: 14rem;
  column-gap: 14rem;
}

.gap-x-5px {
  -moz-column-gap: var(--coze-5);
  column-gap: var(--coze-5);
}

.gap-x-6 {
  -moz-column-gap: 1.5rem;
  column-gap: 1.5rem;
}

.gap-x-60 {
  -moz-column-gap: 15rem;
  column-gap: 15rem;
}

.gap-x-64 {
  -moz-column-gap: 16rem;
  column-gap: 16rem;
}

.gap-x-640px {
  -moz-column-gap: var(--coze-640);
  column-gap: var(--coze-640);
}

.gap-x-64px {
  -moz-column-gap: var(--coze-64);
  column-gap: var(--coze-64);
}

.gap-x-6px {
  -moz-column-gap: var(--coze-6);
  column-gap: var(--coze-6);
}

.gap-x-7 {
  -moz-column-gap: 1.75rem;
  column-gap: 1.75rem;
}

.gap-x-72 {
  -moz-column-gap: 18rem;
  column-gap: 18rem;
}

.gap-x-8 {
  -moz-column-gap: 2rem;
  column-gap: 2rem;
}

.gap-x-80 {
  -moz-column-gap: 20rem;
  column-gap: 20rem;
}

.gap-x-800px {
  -moz-column-gap: var(--coze-800);
  column-gap: var(--coze-800);
}

.gap-x-80px {
  -moz-column-gap: var(--coze-80);
  column-gap: var(--coze-80);
}

.gap-x-8px {
  -moz-column-gap: var(--coze-8);
  column-gap: var(--coze-8);
}

.gap-x-9 {
  -moz-column-gap: 2.25rem;
  column-gap: 2.25rem;
}

.gap-x-96 {
  -moz-column-gap: 24rem;
  column-gap: 24rem;
}

.gap-x-96px {
  -moz-column-gap: var(--coze-96);
  column-gap: var(--coze-96);
}

.gap-x-9px {
  -moz-column-gap: var(--coze-9);
  column-gap: var(--coze-9);
}

.gap-x-\\[18px\\] {
  -moz-column-gap: 18px;
  column-gap: 18px;
}

.gap-x-\\[2px\\] {
  -moz-column-gap: 2px;
  column-gap: 2px;
}

.gap-x-\\[4px\\] {
  -moz-column-gap: 4px;
  column-gap: 4px;
}

.gap-x-\\[6px\\] {
  -moz-column-gap: 6px;
  column-gap: 6px;
}

.gap-x-\\[8px\\] {
  -moz-column-gap: 8px;
  column-gap: 8px;
}

.gap-x-base {
  -moz-column-gap: 16px;
  column-gap: 16px;
}

.gap-x-base-loose {
  -moz-column-gap: 20px;
  column-gap: 20px;
}

.gap-x-base-tight {
  -moz-column-gap: 12px;
  column-gap: 12px;
}

.gap-x-extra-loose {
  -moz-column-gap: 32px;
  column-gap: 32px;
}

.gap-x-extra-tight {
  -moz-column-gap: 4px;
  column-gap: 4px;
}

.gap-x-large {
  -moz-column-gap: var(--coze-40);
  column-gap: var(--coze-40);
}

.gap-x-loose {
  -moz-column-gap: 24px;
  column-gap: 24px;
}

.gap-x-md {
  -moz-column-gap: var(--coze-64);
  column-gap: var(--coze-64);
}

.gap-x-mini {
  -moz-column-gap: var(--coze-16);
  column-gap: var(--coze-16);
}

.gap-x-mm {
  -moz-column-gap: var(--coze-48);
  column-gap: var(--coze-48);
}

.gap-x-none {
  -moz-column-gap: 0;
  column-gap: 0;
}

.gap-x-normal {
  -moz-column-gap: var(--coze-32);
  column-gap: var(--coze-32);
}

.gap-x-px {
  -moz-column-gap: 1px;
  column-gap: 1px;
}

.gap-x-small {
  -moz-column-gap: var(--coze-20);
  column-gap: var(--coze-20);
}

.gap-x-super-loose {
  -moz-column-gap: 40px;
  column-gap: 40px;
}

.gap-x-super-tight {
  -moz-column-gap: 2px;
  column-gap: 2px;
}

.gap-x-tight {
  -moz-column-gap: 8px;
  column-gap: 8px;
}

.gap-x-xl {
  -moz-column-gap: var(--coze-80);
  column-gap: var(--coze-80);
}

.gap-x-xxl {
  -moz-column-gap: var(--coze-96);
  column-gap: var(--coze-96);
}

.gap-y {
  row-gap: var(--coze-8);
}

.gap-y-0 {
  row-gap: 0;
}

.gap-y-0\\.5 {
  row-gap: .125rem;
}

.gap-y-1 {
  row-gap: .25rem;
}

.gap-y-1\\.5 {
  row-gap: .375rem;
}

.gap-y-10 {
  row-gap: 2.5rem;
}

.gap-y-1080px {
  row-gap: var(--coze-1080);
}

.gap-y-10px {
  row-gap: var(--coze-10);
}

.gap-y-11 {
  row-gap: 2.75rem;
}

.gap-y-12 {
  row-gap: 3rem;
}

.gap-y-120px {
  row-gap: var(--coze-120);
}

.gap-y-12px {
  row-gap: var(--coze-12);
}

.gap-y-14 {
  row-gap: 3.5rem;
}

.gap-y-14px {
  row-gap: var(--coze-14);
}

.gap-y-15px {
  row-gap: var(--coze-15);
}

.gap-y-16 {
  row-gap: 4rem;
}

.gap-y-160px {
  row-gap: var(--coze-160);
}

.gap-y-16px {
  row-gap: var(--coze-16);
}

.gap-y-18px {
  row-gap: var(--coze-18);
}

.gap-y-1px {
  row-gap: var(--coze-1);
}

.gap-y-2 {
  row-gap: .5rem;
}

.gap-y-2\\.5 {
  row-gap: .625rem;
}

.gap-y-20 {
  row-gap: 5rem;
}

.gap-y-200px {
  row-gap: var(--coze-200);
}

.gap-y-20px {
  row-gap: var(--coze-20);
}

.gap-y-22px {
  row-gap: var(--coze-22);
}

.gap-y-24 {
  row-gap: 6rem;
}

.gap-y-240px {
  row-gap: var(--coze-240);
}

.gap-y-24px {
  row-gap: var(--coze-24);
}

.gap-y-26px {
  row-gap: var(--coze-26);
}

.gap-y-28 {
  row-gap: 7rem;
}

.gap-y-28px {
  row-gap: var(--coze-28);
}

.gap-y-2px {
  row-gap: var(--coze-2);
}

.gap-y-3 {
  row-gap: .75rem;
}

.gap-y-3\\.5 {
  row-gap: .875rem;
}

.gap-y-30px {
  row-gap: var(--coze-30);
}

.gap-y-32 {
  row-gap: 8rem;
}

.gap-y-320px {
  row-gap: var(--coze-320);
}

.gap-y-32px {
  row-gap: var(--coze-32);
}

.gap-y-36 {
  row-gap: 9rem;
}

.gap-y-3px {
  row-gap: var(--coze-3);
}

.gap-y-4 {
  row-gap: 1rem;
}

.gap-y-40 {
  row-gap: 10rem;
}

.gap-y-40px {
  row-gap: var(--coze-40);
}

.gap-y-44 {
  row-gap: 11rem;
}

.gap-y-48 {
  row-gap: 12rem;
}

.gap-y-480px {
  row-gap: var(--coze-480);
}

.gap-y-48px {
  row-gap: var(--coze-48);
}

.gap-y-4px {
  row-gap: var(--coze-4);
}

.gap-y-5 {
  row-gap: 1.25rem;
}

.gap-y-52 {
  row-gap: 13rem;
}

.gap-y-56 {
  row-gap: 14rem;
}

.gap-y-5px {
  row-gap: var(--coze-5);
}

.gap-y-6 {
  row-gap: 1.5rem;
}

.gap-y-60 {
  row-gap: 15rem;
}

.gap-y-64 {
  row-gap: 16rem;
}

.gap-y-640px {
  row-gap: var(--coze-640);
}

.gap-y-64px {
  row-gap: var(--coze-64);
}

.gap-y-6px {
  row-gap: var(--coze-6);
}

.gap-y-7 {
  row-gap: 1.75rem;
}

.gap-y-72 {
  row-gap: 18rem;
}

.gap-y-8 {
  row-gap: 2rem;
}

.gap-y-80 {
  row-gap: 20rem;
}

.gap-y-800px {
  row-gap: var(--coze-800);
}

.gap-y-80px {
  row-gap: var(--coze-80);
}

.gap-y-8px {
  row-gap: var(--coze-8);
}

.gap-y-9 {
  row-gap: 2.25rem;
}

.gap-y-96 {
  row-gap: 24rem;
}

.gap-y-96px {
  row-gap: var(--coze-96);
}

.gap-y-9px {
  row-gap: var(--coze-9);
}

.gap-y-\\[12px\\] {
  row-gap: 12px;
}

.gap-y-\\[20px\\] {
  row-gap: 20px;
}

.gap-y-\\[2px\\] {
  row-gap: 2px;
}

.gap-y-\\[3px\\] {
  row-gap: 3px;
}

.gap-y-\\[4px\\] {
  row-gap: 4px;
}

.gap-y-\\[8px\\] {
  row-gap: 8px;
}

.gap-y-base {
  row-gap: 16px;
}

.gap-y-base-loose {
  row-gap: 20px;
}

.gap-y-base-tight {
  row-gap: 12px;
}

.gap-y-extra-loose {
  row-gap: 32px;
}

.gap-y-extra-tight {
  row-gap: 4px;
}

.gap-y-large {
  row-gap: var(--coze-40);
}

.gap-y-loose {
  row-gap: 24px;
}

.gap-y-md {
  row-gap: var(--coze-64);
}

.gap-y-mini {
  row-gap: var(--coze-16);
}

.gap-y-mm {
  row-gap: var(--coze-48);
}

.gap-y-none {
  row-gap: 0;
}

.gap-y-normal {
  row-gap: var(--coze-32);
}

.gap-y-px {
  row-gap: 1px;
}

.gap-y-small {
  row-gap: var(--coze-20);
}

.gap-y-super-loose {
  row-gap: 40px;
}

.gap-y-super-tight {
  row-gap: 2px;
}

.gap-y-tight {
  row-gap: 8px;
}

.gap-y-xl {
  row-gap: var(--coze-80);
}

.gap-y-xxl {
  row-gap: var(--coze-96);
}

.space-x-0 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0px * var(--tw-space-x-reverse));
  margin-left: calc(0px * calc(1 - var(--tw-space-x-reverse)));
}

.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(.25rem * var(--tw-space-x-reverse));
  margin-left: calc(.25rem * calc(1 - var(--tw-space-x-reverse)));
}

.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(.5rem * var(--tw-space-x-reverse));
  margin-left: calc(.5rem * calc(1 - var(--tw-space-x-reverse)));
}

.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(.75rem * var(--tw-space-x-reverse));
  margin-left: calc(.75rem * calc(1 - var(--tw-space-x-reverse)));
}

.space-x-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1.25rem * var(--tw-space-x-reverse));
  margin-left: calc(1.25rem * calc(1 - var(--tw-space-x-reverse)));
}

.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(.25rem * var(--tw-space-y-reverse));
}

.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(.5rem * var(--tw-space-y-reverse));
}

.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(.75rem * var(--tw-space-y-reverse));
}

.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}

.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}

.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}

.space-y-\\[10px\\] > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(10px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(10px * var(--tw-space-y-reverse));
}

.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(var(--coze-1) * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(var(--coze-1) * var(--tw-divide-y-reverse));
}

.divide-\\[var\\(--coz-stroke-primary\\)\\] > :not([hidden]) ~ :not([hidden]) {
  border-color: var(--coz-stroke-primary);
}

.divide-background-6 > :not([hidden]) ~ :not([hidden]) {
  border-color: rgba(var(--coze-bg-6), var(--coze-bg-6-alpha));
}

.place-self-center {
  align-self: center;
  justify-self: center;
}

.self-start {
  align-self: flex-start;
}

.self-end {
  align-self: flex-end;
}

.self-center {
  align-self: center;
}

.self-stretch {
  align-self: stretch;
}

.justify-self-end {
  justify-self: end;
}

.\\!overflow-auto {
  overflow: auto !important;
}

.overflow-auto {
  overflow: auto;
}

.\\!overflow-hidden {
  overflow: hidden !important;
}

.overflow-hidden {
  overflow: hidden;
}

.\\!overflow-visible {
  overflow: visible !important;
}

.overflow-visible {
  overflow: visible;
}

.\\!overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto;
}

.overflow-y-auto {
  overflow-y: auto;
}

.overflow-x-hidden {
  overflow-x: hidden;
}

.overflow-y-hidden {
  overflow-y: hidden;
}

.overflow-y-visible {
  overflow-y: visible;
}

.overflow-x-scroll {
  overflow-x: scroll;
}

.truncate {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.overflow-ellipsis, .text-ellipsis {
  text-overflow: ellipsis;
}

.text-clip {
  text-overflow: clip;
}

.whitespace-normal {
  white-space: normal;
}

.whitespace-nowrap {
  white-space: nowrap;
}

.whitespace-pre-line {
  white-space: pre-line;
}

.whitespace-pre-wrap {
  white-space: pre-wrap;
}

.whitespace-break-spaces {
  white-space: break-spaces;
}

.break-words {
  overflow-wrap: break-word;
}

.break-all {
  word-break: break-all;
}

.break-keep {
  word-break: keep-all;
}

.\\!rounded-\\[10px\\] {
  border-radius: 10px !important;
}

.\\!rounded-\\[20px\\] {
  border-radius: 20px !important;
}

.\\!rounded-\\[3px\\] {
  border-radius: 3px !important;
}

.\\!rounded-\\[4px\\] {
  border-radius: 4px !important;
}

.\\!rounded-\\[5px\\] {
  border-radius: 5px !important;
}

.\\!rounded-\\[6px\\] {
  border-radius: 6px !important;
}

.\\!rounded-\\[8px\\] {
  border-radius: 8px !important;
}

.\\!rounded-\\[99px\\] {
  border-radius: 99px !important;
}

.\\!rounded-full {
  border-radius: 9999px !important;
}

.\\!rounded-lg {
  border-radius: .5rem !important;
}

.\\!rounded-none {
  border-radius: 0 !important;
}

.rounded {
  border-radius: var(--coze-8);
}

.rounded-2xl {
  border-radius: 1rem;
}

.rounded-\\[0\\.5px\\] {
  border-radius: .5px;
}

.rounded-\\[10px\\] {
  border-radius: 10px;
}

.rounded-\\[12px\\] {
  border-radius: 12px;
}

.rounded-\\[14px\\] {
  border-radius: 14px;
}

.rounded-\\[16px\\] {
  border-radius: 16px;
}

.rounded-\\[18px\\] {
  border-radius: 18px;
}

.rounded-\\[20px\\] {
  border-radius: 20px;
}

.rounded-\\[21px\\] {
  border-radius: 21px;
}

.rounded-\\[24px\\] {
  border-radius: 24px;
}

.rounded-\\[2px\\] {
  border-radius: 2px;
}

.rounded-\\[36px\\] {
  border-radius: 36px;
}

.rounded-\\[3px\\] {
  border-radius: 3px;
}

.rounded-\\[4px\\] {
  border-radius: 4px;
}

.rounded-\\[50\\%\\] {
  border-radius: 50%;
}

.rounded-\\[5px\\] {
  border-radius: 5px;
}

.rounded-\\[6px\\] {
  border-radius: 6px;
}

.rounded-\\[7px\\] {
  border-radius: 7px;
}

.rounded-\\[8px\\] {
  border-radius: 8px;
}

.rounded-\\[99px\\] {
  border-radius: 99px;
}

.rounded-full {
  border-radius: 9999px;
}

.rounded-lg {
  border-radius: .5rem;
}

.rounded-little {
  border-radius: var(--coze-5);
}

.rounded-m {
  border-radius: var(--coze-10);
}

.rounded-md {
  border-radius: var(--coze-12);
}

.rounded-medium {
  border-radius: 6px;
}

.rounded-mini {
  border-radius: var(--coze-4);
}

.rounded-normal {
  border-radius: var(--coze-8);
}

.rounded-sm {
  border-radius: .125rem;
}

.rounded-small {
  border-radius: 8px;
}

.rounded-ultra {
  border-radius: var(--coze-40);
}

.rounded-xl {
  border-radius: var(--coze-16);
}

.rounded-xxl {
  border-radius: var(--coze-24);
}

.\\!rounded-l-none {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.\\!rounded-r-none {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.\\!rounded-t-none {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-b-\\[6px\\] {
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}

.rounded-b-\\[8px\\] {
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}

.rounded-b-lg {
  border-bottom-right-radius: .5rem;
  border-bottom-left-radius: .5rem;
}

.rounded-l-m {
  border-top-left-radius: var(--coze-10);
  border-bottom-left-radius: var(--coze-10);
}

.rounded-r-\\[8px\\] {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

.rounded-r-none {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.rounded-t-3xl {
  border-top-left-radius: 1.5rem;
  border-top-right-radius: 1.5rem;
}

.rounded-t-\\[6px\\] {
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.rounded-t-\\[7px\\] {
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
}

.rounded-t-\\[8px\\] {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.rounded-t-lg {
  border-top-left-radius: .5rem;
  border-top-right-radius: .5rem;
}

.rounded-t-none {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.rounded-bl-\\[4px\\] {
  border-bottom-left-radius: 4px;
}

.rounded-bl-lg {
  border-bottom-left-radius: .5rem;
}

.rounded-br-\\[14px\\] {
  border-bottom-right-radius: 14px;
}

.rounded-tl-\\[6px\\] {
  border-top-left-radius: 6px;
}

.rounded-tl-\\[8px\\] {
  border-top-left-radius: 8px;
}

.rounded-tl-lg {
  border-top-left-radius: .5rem;
}

.\\!border {
  border-width: var(--coze-1) !important;
}

.\\!border-0 {
  border-width: 0 !important;
}

.\\!border-\\[1px\\] {
  border-width: 1px !important;
}

.border {
  border-width: var(--coze-1);
}

.border-0 {
  border-width: 0;
}

.border-\\[0\\.5px\\] {
  border-width: .5px;
}

.border-\\[0\\] {
  border-width: 0;
}

.border-\\[1\\.5px\\] {
  border-width: 1.5px;
}

.border-\\[1px\\] {
  border-width: 1px;
}

.border-x-0 {
  border-left-width: 0;
  border-right-width: 0;
}

.border-y-0 {
  border-top-width: 0;
  border-bottom-width: 0;
}

.\\!border-b {
  border-bottom-width: var(--coze-1) !important;
}

.\\!border-b-0 {
  border-bottom-width: 0 !important;
}

.\\!border-l {
  border-left-width: var(--coze-1) !important;
}

.\\!border-r {
  border-right-width: var(--coze-1) !important;
}

.\\!border-t-0 {
  border-top-width: 0 !important;
}

.border-b {
  border-bottom-width: var(--coze-1);
}

.border-b-0 {
  border-bottom-width: 0;
}

.border-b-\\[0\\.6px\\] {
  border-bottom-width: .6px;
}

.border-b-\\[1px\\] {
  border-bottom-width: 1px;
}

.border-l {
  border-left-width: var(--coze-1);
}

.border-l-0 {
  border-left-width: 0;
}

.border-l-\\[0\\.25em\\] {
  border-left-width: .25em;
}

.border-l-\\[1px\\] {
  border-left-width: 1px;
}

.border-l-\\[3px\\] {
  border-left-width: 3px;
}

.border-r {
  border-right-width: var(--coze-1);
}

.border-r-0 {
  border-right-width: 0;
}

.border-r-2 {
  border-right-width: 2px;
}

.border-r-\\[0px\\] {
  border-right-width: 0;
}

.border-r-\\[1px\\] {
  border-right-width: 1px;
}

.border-t {
  border-top-width: var(--coze-1);
}

.border-t-0, .border-t-\\[0px\\] {
  border-top-width: 0;
}

.border-t-\\[1px\\] {
  border-top-width: 1px;
}

.\\!border-solid {
  border-style: solid !important;
}

.border-solid {
  border-style: solid;
}

.border-dashed {
  border-style: dashed;
}

.\\!border-none {
  border-style: none !important;
}

.border-none {
  border-style: none;
}

.\\!border-0 {
  border-color: rgba(var(--coze-up-stroke-primary), .12) !important;
}

.\\!border-\\[rgb\\(var\\(--coze-up-brand-9\\)\\)\\] {
  border-color: rgb(var(--coze-up-brand-9)) !important;
}

.\\!border-\\[var\\(--semi-color-border-2\\)\\] {
  border-color: var(--semi-color-border-2) !important;
}

.\\!border-brand-9 {
  border-color: rgba(var(--coze-up-brand-9), 1) !important;
}

.border-0 {
  border-color: rgba(var(--coze-up-stroke-primary), .12);
}

.border-\\[\\#1C1F23\\]\\/\\[8\\%\\] {
  border-color: rgba(28, 31, 35, .08);
}

.border-\\[\\#1D1C2314\\] {
  border-color: rgba(29, 28, 35, .08);
}

.border-\\[\\#EAEEF5\\] {
  --tw-border-opacity: 1;
  border-color: rgba(234, 238, 245, var(--tw-border-opacity));
}

.border-\\[\\#ced0d4\\] {
  --tw-border-opacity: 1;
  border-color: rgba(206, 208, 212, var(--tw-border-opacity));
}

.border-\\[\\#fff\\] {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
}

.border-\\[rgb\\(var\\(--coze-up-brand-3\\)\\)\\] {
  border-color: rgb(var(--coze-up-brand-3));
}

.border-\\[rgba\\(46\\,46\\,57\\,0\\.08\\)\\] {
  border-color: rgba(46, 46, 57, .08);
}

.border-\\[rgba\\(68\\,83\\,130\\,0\\.25\\)\\] {
  border-color: rgba(68, 83, 130, .25);
}

.border-\\[var\\(--coz-border\\)\\] {
  border-color: var(--coz-border);
}

.border-\\[var\\(--coz-stroke-plus\\)\\] {
  border-color: var(--coz-stroke-plus);
}

.border-\\[var\\(--coz-stroke-primary\\)\\] {
  border-color: var(--coz-stroke-primary);
}

.border-\\[var\\(--semi-color-danger\\)\\] {
  border-color: var(--semi-color-danger);
}

.border-brand-9 {
  border-color: rgba(var(--coze-up-brand-9), 1);
}

.border-current {
  border-color: currentColor;
}

.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgba(229, 231, 235, var(--tw-border-opacity));
}

.border-red-2 {
  border-color: rgba(var(--coze-red-2), var(--coze-red-2-alpha));
}

.border-red-5 {
  border-color: rgba(var(--coze-red-5), 1);
}

.border-red-6 {
  border-color: rgba(var(--coze-red-6), 1);
}

.border-stroke {
  border-color: rgba(var(--coze-stroke-5), var(--coze-stroke-5-alpha));
}

.border-transparent {
  border-color: rgba(0, 0, 0, 0);
}

.border-white {
  border-color: rgb(var(--white-1));
}

.border-x-0 {
  border-left-color: rgba(var(--coze-up-stroke-primary), .12);
  border-right-color: rgba(var(--coze-up-stroke-primary), .12);
}

.border-y-0 {
  border-top-color: rgba(var(--coze-up-stroke-primary), .12);
  border-bottom-color: rgba(var(--coze-up-stroke-primary), .12);
}

.\\!border-b-0 {
  border-bottom-color: rgba(var(--coze-up-stroke-primary), .12) !important;
}

.\\!border-b-transparent {
  border-bottom-color: rgba(0, 0, 0, 0) !important;
}

.\\!border-l-transparent {
  border-left-color: rgba(0, 0, 0, 0) !important;
}

.\\!border-r-transparent {
  border-right-color: rgba(0, 0, 0, 0) !important;
}

.\\!border-t-0 {
  border-top-color: rgba(var(--coze-up-stroke-primary), .12) !important;
}

.\\!border-t-\\[var\\(--coz-stroke-primary\\)\\] {
  border-top-color: var(--coz-stroke-primary) !important;
}

.border-b-0 {
  border-bottom-color: rgba(var(--coze-up-stroke-primary), .12);
}

.border-b-\\[rgba\\(68\\,83\\,130\\,\\.25\\)\\] {
  border-bottom-color: rgba(68, 83, 130, .25);
}

.border-b-stroke {
  border-bottom-color: rgba(var(--coze-stroke-5), var(--coze-stroke-5-alpha));
}

.border-l-0 {
  border-left-color: rgba(var(--coze-up-stroke-primary), .12);
}

.border-l-\\[var\\(--color-border-default\\)\\] {
  border-left-color: var(--color-border-default);
}

.border-r-0 {
  border-right-color: rgba(var(--coze-up-stroke-primary), .12);
}

.border-t-0 {
  border-top-color: rgba(var(--coze-up-stroke-primary), .12);
}

.\\!bg-\\[\\#F7F7FC\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(247, 247, 252, var(--tw-bg-opacity)) !important;
}

.\\!bg-\\[rgba\\(0\\,0\\,0\\,0\\.28\\)\\] {
  background-color: rgba(0, 0, 0, .28) !important;
}

.\\!bg-\\[rgba\\(230\\,247\\,237\\,1\\)\\] {
  background-color: #e6f7ed !important;
}

.\\!bg-\\[rgba\\(251\\,238\\,225\\,1\\)\\] {
  background-color: #fbeee1 !important;
}

.\\!bg-\\[rgba\\(255\\,235\\,233\\,1\\)\\] {
  background-color: #ffebe9 !important;
}

.\\!bg-\\[var\\(--coz-mg-secondary\\)\\] {
  background-color: var(--coz-mg-secondary) !important;
}

.\\!bg-brand-3 {
  background-color: rgba(var(--coze-up-brand-3), 1) !important;
}

.\\!bg-gray-200 {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity)) !important;
}

.\\!bg-transparent {
  background-color: rgba(0, 0, 0, 0) !important;
}

.\\!bg-white {
  background-color: rgb(var(--white-1)) !important;
}

.bg-\\[\\#00B2B2\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 178, 178, var(--tw-bg-opacity));
}

.bg-\\[\\#0b0d12\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(11, 13, 18, var(--tw-bg-opacity));
}

.bg-\\[\\#1e1e1e\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(30, 30, 30, var(--tw-bg-opacity));
}

.bg-\\[\\#2E2E380A\\] {
  background-color: rgba(46, 46, 56, .04);
}

.bg-\\[\\#5A6CA70A\\] {
  background-color: rgba(90, 108, 167, .04);
}

.bg-\\[\\#8E4EFF\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(142, 78, 255, var(--tw-bg-opacity));
}

.bg-\\[\\#969fff26\\] {
  background-color: rgba(150, 159, 255, .15);
}

.bg-\\[\\#ABB5FF4D\\] {
  background-color: rgba(171, 181, 255, .3);
}

.bg-\\[\\#DEDBFF\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(222, 219, 255, var(--tw-bg-opacity));
}

.bg-\\[\\#EDD5FC\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(237, 213, 252, var(--tw-bg-opacity));
}

.bg-\\[\\#F2F3F7\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(242, 243, 247, var(--tw-bg-opacity));
}

.bg-\\[\\#F5F5F5\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(245, 245, 245, var(--tw-bg-opacity));
}

.bg-\\[\\#F6F6FB\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(246, 246, 251, var(--tw-bg-opacity));
}

.bg-\\[\\#F7F7FA\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(247, 247, 250, var(--tw-bg-opacity));
}

.bg-\\[\\#F7F7FCA6\\] {
  background-color: rgba(247, 247, 252, .65);
}

.bg-\\[\\#F7F7FC\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(247, 247, 252, var(--tw-bg-opacity));
}

.bg-\\[\\#F9F9F9\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(249, 249, 249, var(--tw-bg-opacity));
}

.bg-\\[\\#FCFCFF\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(252, 252, 255, var(--tw-bg-opacity));
}

.bg-\\[\\#FFEBE9\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 235, 233, var(--tw-bg-opacity));
}

.bg-\\[\\#FFEFF1\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 239, 241, var(--tw-bg-opacity));
}

.bg-\\[\\#FFF3EA\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 243, 234, var(--tw-bg-opacity));
}

.bg-\\[\\#FFFBED\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 251, 237, var(--tw-bg-opacity));
}

.bg-\\[\\#FFF\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

.bg-\\[\\#f0f0f5\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(240, 240, 245, var(--tw-bg-opacity));
}

.bg-\\[\\#fcfcff\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(252, 252, 255, var(--tw-bg-opacity));
}

.bg-\\[\\#fff\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

.bg-\\[--semi-color-bg-0\\] {
  background-color: var(--semi-color-bg-0);
}

.bg-\\[--semi-color-danger-light-default\\] {
  background-color: var(--semi-color-danger-light-default);
}

.bg-\\[--semi-color-disabled-fill\\] {
  background-color: var(--semi-color-disabled-fill);
}

.bg-\\[black\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--tw-bg-opacity));
}

.bg-\\[rgb\\(var\\(--coze-up-brand-3\\)\\)\\] {
  background-color: rgb(var(--coze-up-brand-3));
}

.bg-\\[rgb\\(var\\(--coze-up-brand-7\\)\\)\\] {
  background-color: rgb(var(--coze-up-brand-7));
}

.bg-\\[rgb\\(var\\(--coze-up-brand-9\\)\\)\\] {
  background-color: rgb(var(--coze-up-brand-9));
}

.bg-\\[rgba\\(0\\,0\\,0\\,0\\.12\\)\\] {
  background-color: rgba(0, 0, 0, .12);
}

.bg-\\[rgba\\(0\\,0\\,0\\,0\\.4\\)\\] {
  background-color: rgba(0, 0, 0, .4);
}

.bg-\\[rgba\\(238\\,68\\,51\\,0\\.3\\)\\] {
  background-color: rgba(238, 68, 51, .3);
}

.bg-\\[rgba\\(255\\,255\\,255\\,0\\.12\\)\\] {
  background-color: rgba(255, 255, 255, .12);
}

.bg-\\[rgba\\(255\\,255\\,255\\,0\\.8\\)\\] {
  background-color: rgba(255, 255, 255, .8);
}

.bg-\\[rgba\\(34\\,184\\,24\\,0\\.3\\)\\] {
  background-color: rgba(34, 184, 24, .3);
}

.bg-\\[rgba\\(var\\(--coze-brand-1\\)\\,var\\(--coze-brand-1-alpha\\)\\)\\] {
  background-color: rgba(var(--coze-brand-1), var(--coze-brand-1-alpha));
}

.bg-\\[rgba\\(var\\(--coze-green-1\\)\\,var\\(--coze-green-1-alpha\\)\\)\\] {
  background-color: rgba(var(--coze-green-1), var(--coze-green-1-alpha));
}

.bg-\\[rgba\\(var\\(--coze-red-1\\)\\,var\\(--coze-red-1-alpha\\)\\)\\] {
  background-color: rgba(var(--coze-red-1), var(--coze-red-1-alpha));
}

.bg-\\[rgba\\(var\\(--coze-up-brand-4\\)\\)\\] {
  background-color: rgba(var(--coze-up-brand-4));
}

.bg-\\[rgba\\(var\\(--coze-yellow-1\\)\\,var\\(--coze-yellow-1-alpha\\)\\)\\] {
  background-color: rgba(var(--coze-yellow-1), var(--coze-yellow-1-alpha));
}

.bg-\\[var\\(--coz-bg-max\\)\\] {
  background-color: var(--coz-bg-max);
}

.bg-\\[var\\(--coz-bg-plus\\)\\] {
  background-color: var(--coz-bg-plus);
}

.bg-\\[var\\(--coz-bg-primary\\)\\] {
  background-color: var(--coz-bg-primary);
}

.bg-\\[var\\(--coz-fg-secondary\\)\\] {
  background-color: var(--coz-fg-secondary);
}

.bg-\\[var\\(--coz-mg-card\\)\\] {
  background-color: var(--coz-mg-card);
}

.bg-\\[var\\(--coz-mg-color-cyan\\)\\] {
  background-color: var(--coz-mg-color-cyan);
}

.bg-\\[var\\(--coz-mg-color-magenta\\)\\] {
  background-color: var(--coz-mg-color-magenta);
}

.bg-\\[var\\(--coz-mg-hglt\\)\\] {
  background-color: var(--coz-mg-hglt);
}

.bg-\\[var\\(--coz-mg-hglt-green\\)\\] {
  background-color: var(--coz-mg-hglt-green);
}

.bg-\\[var\\(--coz-mg-hglt-plus-dim\\)\\] {
  background-color: var(--coz-mg-hglt-plus-dim);
}

.bg-\\[var\\(--coz-mg-plus\\)\\] {
  background-color: var(--coz-mg-plus);
}

.bg-\\[var\\(--coz-mg-primary\\)\\] {
  background-color: var(--coz-mg-primary);
}

.bg-\\[var\\(--coz-mg-secondary\\)\\] {
  background-color: var(--coz-mg-secondary);
}

.bg-\\[var\\(--coz-stroke-plus\\)\\] {
  background-color: var(--coz-stroke-plus);
}

.bg-\\[var\\(--coz-stroke-primary\\)\\] {
  background-color: var(--coz-stroke-primary);
}

.bg-\\[var\\(--light-usage-fill-color-fill-0\\,rgba\\(46\\,47\\,56\\,5\\%\\)\\)\\] {
  background-color: var(--light-usage-fill-color-fill-0, rgba(46, 47, 56, .05));
}

.bg-\\[var\\(--semi-color-fill-0\\)\\] {
  background-color: var(--semi-color-fill-0);
}

.bg-\\[var\\(--semi-color-primary\\)\\] {
  background-color: var(--semi-color-primary);
}

.bg-\\[white\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

.bg-background-1 {
  background-color: rgba(var(--coze-bg-1), var(--coze-bg-1-alpha));
}

.bg-background-2 {
  background-color: rgba(var(--coze-bg-2), var(--coze-bg-2-alpha));
}

.bg-background-3 {
  background-color: rgba(var(--coze-bg-3), var(--coze-bg-3-alpha));
}

.bg-background-4 {
  background-color: rgba(var(--coze-bg-4), var(--coze-bg-4-alpha));
}

.bg-black {
  background-color: rgb(var(--black-6));
}

.bg-black\\/70 {
  background-color: rgb(var(--black-6) / .7);
}

.bg-black\\/90 {
  background-color: rgb(var(--black-6) / .9);
}

.bg-black\\/\\[0\\.65\\] {
  background-color: rgb(var(--black-6) / .65);
}

.bg-blue-400 {
  --tw-bg-opacity: 1;
  background-color: rgba(96, 165, 250, var(--tw-bg-opacity));
}

.bg-brand {
  background-color: rgba(var(--coze-up-brand-9), 1);
}

.bg-brand-3 {
  background-color: rgba(var(--coze-up-brand-3), 1);
}

.bg-brand-4 {
  background-color: rgba(var(--coze-up-brand-4), 1);
}

.bg-foreground-3 {
  background-color: rgba(var(--coze-fg-3), var(--coze-fg-3-alpha));
}

.bg-foreground-5 {
  background-color: rgba(var(--coze-fg-5), var(--coze-fg-5-alpha));
}

.bg-foreground-white {
  background-color: rgba(var(--coze-fg-white), var(--coze-fg-white-alpha));
}

.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
}

.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
}

.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgba(209, 213, 219, var(--tw-bg-opacity));
}

.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgba(249, 250, 251, var(--tw-bg-opacity));
}

.bg-green-700 {
  --tw-bg-opacity: 1;
  background-color: rgba(21, 128, 61, var(--tw-bg-opacity));
}

.bg-inherit {
  background-color: inherit;
}

.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgba(239, 68, 68, var(--tw-bg-opacity));
}

.bg-stroke {
  background-color: rgba(var(--coze-stroke-5), var(--coze-stroke-5-alpha));
}

.bg-transparent {
  background-color: rgba(0, 0, 0, 0);
}

.bg-white {
  background-color: rgb(var(--white-1));
}

.bg-white\\/70 {
  background-color: rgb(var(--white-1) / .7);
}

.bg-yellow-1 {
  background-color: rgba(var(--coze-yellow-1), var(--coze-yellow-1-alpha));
}

.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}

.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}

.from-\\[rgba\\(255\\,255\\,255\\,1\\)\\] {
  --tw-gradient-from: #fff var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 255, 255, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.to-transparent {
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}

.decoration-clone {
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;
}

.fill {
  fill: rgba(var(--coze-fg-5), var(--coze-fg-5-alpha));
}

.fill-background {
  fill: rgba(var(--background), 1);
}

.fill-brand-6 {
  fill: rgba(var(--coze-up-brand-6), 1);
}

.fill-foreground {
  fill: rgba(var(--foreground), 1);
}

.fill-foreground-3 {
  fill: rgba(var(--coze-fg-3), var(--coze-fg-3-alpha));
}

.fill-green-6 {
  fill: rgba(var(--coze-green-6), 1);
}

.fill-red-6 {
  fill: rgba(var(--coze-red-6), 1);
}

.fill-yellow-6 {
  fill: rgba(var(--coze-yellow-6), 1);
}

.object-contain {
  -o-object-fit: contain;
  object-fit: contain;
}

.object-cover {
  -o-object-fit: cover;
  object-fit: cover;
}

.object-center {
  -o-object-position: center;
  object-position: center;
}

.\\!p {
  padding: var(--coze-8) !important;
}

.\\!p-0 {
  padding: 0 !important;
}

.\\!p-0\\.5 {
  padding: .125rem !important;
}

.\\!p-1 {
  padding: .25rem !important;
}

.\\!p-2 {
  padding: .5rem !important;
}

.\\!p-3 {
  padding: .75rem !important;
}

.\\!p-4 {
  padding: 1rem !important;
}

.\\!p-\\[20px\\] {
  padding: 20px !important;
}

.\\!p-\\[2px\\] {
  padding: 2px !important;
}

.\\!p-\\[4px\\] {
  padding: 4px !important;
}

.\\!p-\\[5px\\] {
  padding: 5px !important;
}

.\\!p-\\[8px\\] {
  padding: 8px !important;
}

.p {
  padding: var(--coze-8);
}

.p-0 {
  padding: 0;
}

.p-0\\.5 {
  padding: .125rem;
}

.p-1 {
  padding: .25rem;
}

.p-1\\.5 {
  padding: .375rem;
}

.p-12px {
  padding: var(--coze-12);
}

.p-16 {
  padding: 4rem;
}

.p-2 {
  padding: .5rem;
}

.p-2\\.5 {
  padding: .625rem;
}

.p-24px {
  padding: var(--coze-24);
}

.p-3 {
  padding: .75rem;
}

.p-4 {
  padding: 1rem;
}

.p-4px {
  padding: var(--coze-4);
}

.p-5 {
  padding: 1.25rem;
}

.p-6 {
  padding: 1.5rem;
}

.p-8 {
  padding: 2rem;
}

.p-8px {
  padding: var(--coze-8);
}

.p-\\[10px\\] {
  padding: 10px;
}

.p-\\[11px\\] {
  padding: 11px;
}

.p-\\[12px\\] {
  padding: 12px;
}

.p-\\[13px\\] {
  padding: 13px;
}

.p-\\[16px\\] {
  padding: 16px;
}

.p-\\[1px\\] {
  padding: 1px;
}

.p-\\[24px\\] {
  padding: 24px;
}

.p-\\[2px\\] {
  padding: 2px;
}

.p-\\[3px\\] {
  padding: 3px;
}

.p-\\[4px\\] {
  padding: 4px;
}

.p-\\[5px\\] {
  padding: 5px;
}

.p-\\[6px\\] {
  padding: 6px;
}

.p-\\[8px\\] {
  padding: 8px;
}

.\\!px-0 {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.\\!px-1 {
  padding-left: .25rem !important;
  padding-right: .25rem !important;
}

.\\!px-2 {
  padding-left: .5rem !important;
  padding-right: .5rem !important;
}

.\\!px-3 {
  padding-left: .75rem !important;
  padding-right: .75rem !important;
}

.\\!px-4 {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}

.\\!px-4px {
  padding-left: var(--coze-4) !important;
  padding-right: var(--coze-4) !important;
}

.\\!px-6 {
  padding-left: 1.5rem !important;
  padding-right: 1.5rem !important;
}

.\\!px-8px {
  padding-left: var(--coze-8) !important;
  padding-right: var(--coze-8) !important;
}

.\\!px-\\[3px\\] {
  padding-left: 3px !important;
  padding-right: 3px !important;
}

.\\!px-\\[4px\\] {
  padding-left: 4px !important;
  padding-right: 4px !important;
}

.\\!px-\\[76px\\] {
  padding-left: 76px !important;
  padding-right: 76px !important;
}

.\\!px-\\[8px\\] {
  padding-left: 8px !important;
  padding-right: 8px !important;
}

.\\!py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.\\!py-0\\.5 {
  padding-top: .125rem !important;
  padding-bottom: .125rem !important;
}

.\\!py-1 {
  padding-top: .25rem !important;
  padding-bottom: .25rem !important;
}

.\\!py-2 {
  padding-top: .5rem !important;
  padding-bottom: .5rem !important;
}

.\\!py-2px {
  padding-top: var(--coze-2) !important;
  padding-bottom: var(--coze-2) !important;
}

.\\!py-\\[1px\\] {
  padding-top: 1px !important;
  padding-bottom: 1px !important;
}

.\\!py-\\[2px\\] {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}

.\\!py-\\[4px\\] {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

.\\!py-\\[6px\\] {
  padding-top: 6px !important;
  padding-bottom: 6px !important;
}

.\\!py-\\[8px\\] {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.px {
  padding-left: var(--coze-8);
  padding-right: var(--coze-8);
}

.px-0 {
  padding-left: 0;
  padding-right: 0;
}

.px-0\\.5 {
  padding-left: .125rem;
  padding-right: .125rem;
}

.px-1 {
  padding-left: .25rem;
  padding-right: .25rem;
}

.px-12px {
  padding-left: var(--coze-12);
  padding-right: var(--coze-12);
}

.px-16px {
  padding-left: var(--coze-16);
  padding-right: var(--coze-16);
}

.px-2 {
  padding-left: .5rem;
  padding-right: .5rem;
}

.px-20px {
  padding-left: var(--coze-20);
  padding-right: var(--coze-20);
}

.px-24px {
  padding-left: var(--coze-24);
  padding-right: var(--coze-24);
}

.px-2px {
  padding-left: var(--coze-2);
  padding-right: var(--coze-2);
}

.px-3 {
  padding-left: .75rem;
  padding-right: .75rem;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.px-4px {
  padding-left: var(--coze-4);
  padding-right: var(--coze-4);
}

.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.px-6px {
  padding-left: var(--coze-6);
  padding-right: var(--coze-6);
}

.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}

.px-8px {
  padding-left: var(--coze-8);
  padding-right: var(--coze-8);
}

.px-\\[10px\\] {
  padding-left: 10px;
  padding-right: 10px;
}

.px-\\[11px\\] {
  padding-left: 11px;
  padding-right: 11px;
}

.px-\\[12px\\] {
  padding-left: 12px;
  padding-right: 12px;
}

.px-\\[14px\\] {
  padding-left: 14px;
  padding-right: 14px;
}

.px-\\[16px\\] {
  padding-left: 16px;
  padding-right: 16px;
}

.px-\\[18px\\] {
  padding-left: 18px;
  padding-right: 18px;
}

.px-\\[20px\\] {
  padding-left: 20px;
  padding-right: 20px;
}

.px-\\[22px\\] {
  padding-left: 22px;
  padding-right: 22px;
}

.px-\\[24px\\] {
  padding-left: 24px;
  padding-right: 24px;
}

.px-\\[28px\\] {
  padding-left: 28px;
  padding-right: 28px;
}

.px-\\[2px\\] {
  padding-left: 2px;
  padding-right: 2px;
}

.px-\\[36px\\] {
  padding-left: 36px;
  padding-right: 36px;
}

.px-\\[3px\\] {
  padding-left: 3px;
  padding-right: 3px;
}

.px-\\[40px\\] {
  padding-left: 40px;
  padding-right: 40px;
}

.px-\\[4px\\] {
  padding-left: 4px;
  padding-right: 4px;
}

.px-\\[52px\\] {
  padding-left: 52px;
  padding-right: 52px;
}

.px-\\[5px\\] {
  padding-left: 5px;
  padding-right: 5px;
}

.px-\\[6px\\] {
  padding-left: 6px;
  padding-right: 6px;
}

.px-\\[7px\\] {
  padding-left: 7px;
  padding-right: 7px;
}

.px-\\[8px\\] {
  padding-left: 8px;
  padding-right: 8px;
}

.py {
  padding-top: var(--coze-8);
  padding-bottom: var(--coze-8);
}

.py-0 {
  padding-top: 0;
  padding-bottom: 0;
}

.py-0\\.5 {
  padding-top: .125rem;
  padding-bottom: .125rem;
}

.py-1 {
  padding-top: .25rem;
  padding-bottom: .25rem;
}

.py-1\\.5 {
  padding-top: .375rem;
  padding-bottom: .375rem;
}

.py-10px {
  padding-top: var(--coze-10);
  padding-bottom: var(--coze-10);
}

.py-12px {
  padding-top: var(--coze-12);
  padding-bottom: var(--coze-12);
}

.py-16px {
  padding-top: var(--coze-16);
  padding-bottom: var(--coze-16);
}

.py-2 {
  padding-top: .5rem;
  padding-bottom: .5rem;
}

.py-2\\.5 {
  padding-top: .625rem;
  padding-bottom: .625rem;
}

.py-3 {
  padding-top: .75rem;
  padding-bottom: .75rem;
}

.py-3px {
  padding-top: var(--coze-3);
  padding-bottom: var(--coze-3);
}

.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.py-4px {
  padding-top: var(--coze-4);
  padding-bottom: var(--coze-4);
}

.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}

.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.py-6px {
  padding-top: var(--coze-6);
  padding-bottom: var(--coze-6);
}

.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.py-8px {
  padding-top: var(--coze-8);
  padding-bottom: var(--coze-8);
}

.py-\\[0\\] {
  padding-top: 0;
  padding-bottom: 0;
}

.py-\\[10px\\] {
  padding-top: 10px;
  padding-bottom: 10px;
}

.py-\\[12px\\] {
  padding-top: 12px;
  padding-bottom: 12px;
}

.py-\\[14px\\] {
  padding-top: 14px;
  padding-bottom: 14px;
}

.py-\\[16px\\] {
  padding-top: 16px;
  padding-bottom: 16px;
}

.py-\\[1px\\] {
  padding-top: 1px;
  padding-bottom: 1px;
}

.py-\\[24px\\] {
  padding-top: 24px;
  padding-bottom: 24px;
}

.py-\\[2px\\] {
  padding-top: 2px;
  padding-bottom: 2px;
}

.py-\\[3px\\] {
  padding-top: 3px;
  padding-bottom: 3px;
}

.py-\\[4px\\] {
  padding-top: 4px;
  padding-bottom: 4px;
}

.py-\\[5px\\] {
  padding-top: 5px;
  padding-bottom: 5px;
}

.py-\\[6px\\] {
  padding-top: 6px;
  padding-bottom: 6px;
}

.py-\\[8px\\] {
  padding-top: 8px;
  padding-bottom: 8px;
}

.py-\\[9px\\] {
  padding-top: 9px;
  padding-bottom: 9px;
}

.\\!pb-0 {
  padding-bottom: 0 !important;
}

.\\!pb-1 {
  padding-bottom: .25rem !important;
}

.\\!pb-3 {
  padding-bottom: .75rem !important;
}

.\\!pb-\\[16px\\] {
  padding-bottom: 16px !important;
}

.\\!pl-0 {
  padding-left: 0 !important;
}

.\\!pl-2 {
  padding-left: .5rem !important;
}

.\\!pl-3 {
  padding-left: .75rem !important;
}

.\\!pl-5 {
  padding-left: 1.25rem !important;
}

.\\!pl-\\[2px\\] {
  padding-left: 2px !important;
}

.\\!pl-\\[5px\\] {
  padding-left: 5px !important;
}

.\\!pl-\\[8px\\] {
  padding-left: 8px !important;
}

.\\!pr-0 {
  padding-right: 0 !important;
}

.\\!pr-\\[10px\\] {
  padding-right: 10px !important;
}

.\\!pr-\\[2px\\] {
  padding-right: 2px !important;
}

.\\!pr-\\[5px\\] {
  padding-right: 5px !important;
}

.\\!pr-\\[6px\\] {
  padding-right: 6px !important;
}

.\\!pr-\\[8px\\] {
  padding-right: 8px !important;
}

.\\!pt-0 {
  padding-top: 0 !important;
}

.\\!pt-0\\.5 {
  padding-top: .125rem !important;
}

.\\!pt-1 {
  padding-top: .25rem !important;
}

.\\!pt-1\\.5 {
  padding-top: .375rem !important;
}

.\\!pt-2 {
  padding-top: .5rem !important;
}

.\\!pt-\\[0px\\] {
  padding-top: 0 !important;
}

.\\!pt-\\[16px\\] {
  padding-top: 16px !important;
}

.\\!pt-\\[20px\\] {
  padding-top: 20px !important;
}

.pb {
  padding-bottom: var(--coze-8);
}

.pb-0 {
  padding-bottom: 0;
}

.pb-1 {
  padding-bottom: .25rem;
}

.pb-1\\.5 {
  padding-bottom: .375rem;
}

.pb-14 {
  padding-bottom: 3.5rem;
}

.pb-16px {
  padding-bottom: var(--coze-16);
}

.pb-2 {
  padding-bottom: .5rem;
}

.pb-20px {
  padding-bottom: var(--coze-20);
}

.pb-24px {
  padding-bottom: var(--coze-24);
}

.pb-2px {
  padding-bottom: var(--coze-2);
}

.pb-3 {
  padding-bottom: .75rem;
}

.pb-32px {
  padding-bottom: var(--coze-32);
}

.pb-4 {
  padding-bottom: 1rem;
}

.pb-40 {
  padding-bottom: 10rem;
}

.pb-5 {
  padding-bottom: 1.25rem;
}

.pb-6 {
  padding-bottom: 1.5rem;
}

.pb-9 {
  padding-bottom: 2.25rem;
}

.pb-\\[100px\\] {
  padding-bottom: 100px;
}

.pb-\\[10px\\] {
  padding-bottom: 10px;
}

.pb-\\[12px\\] {
  padding-bottom: 12px;
}

.pb-\\[16px\\] {
  padding-bottom: 16px;
}

.pb-\\[18px\\] {
  padding-bottom: 18px;
}

.pb-\\[1px\\] {
  padding-bottom: 1px;
}

.pb-\\[24px\\] {
  padding-bottom: 24px;
}

.pb-\\[2px\\] {
  padding-bottom: 2px;
}

.pb-\\[32px\\] {
  padding-bottom: 32px;
}

.pb-\\[3px\\] {
  padding-bottom: 3px;
}

.pb-\\[48px\\] {
  padding-bottom: 48px;
}

.pb-\\[4px\\] {
  padding-bottom: 4px;
}

.pb-\\[60px\\] {
  padding-bottom: 60px;
}

.pb-\\[6px\\] {
  padding-bottom: 6px;
}

.pb-\\[72px\\] {
  padding-bottom: 72px;
}

.pb-\\[7px\\] {
  padding-bottom: 7px;
}

.pb-\\[8px\\] {
  padding-bottom: 8px;
}

.pe:not(:-webkit-any(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi))) {
  padding-right: var(--coze-8);
}

.pe:not(:-moz-any(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi))) {
  padding-right: var(--coze-8);
}

.pe:not(:is(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi))) {
  padding-right: var(--coze-8);
}

.pe:-webkit-any(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi)) {
  padding-left: var(--coze-8);
}

.pe:-moz-any(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi)) {
  padding-left: var(--coze-8);
}

.pe:is(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi)) {
  padding-left: var(--coze-8);
}

.pl {
  padding-left: var(--coze-8);
}

.pl-0 {
  padding-left: 0;
}

.pl-0\\.5 {
  padding-left: .125rem;
}

.pl-1 {
  padding-left: .25rem;
}

.pl-2 {
  padding-left: .5rem;
}

.pl-20px {
  padding-left: var(--coze-20);
}

.pl-24px {
  padding-left: var(--coze-24);
}

.pl-28px {
  padding-left: var(--coze-28);
}

.pl-3 {
  padding-left: .75rem;
}

.pl-32px {
  padding-left: var(--coze-32);
}

.pl-4 {
  padding-left: 1rem;
}

.pl-6 {
  padding-left: 1.5rem;
}

.pl-6px {
  padding-left: var(--coze-6);
}

.pl-7 {
  padding-left: 1.75rem;
}

.pl-8 {
  padding-left: 2rem;
}

.pl-8px {
  padding-left: var(--coze-8);
}

.pl-\\[10px\\] {
  padding-left: 10px;
}

.pl-\\[12px\\] {
  padding-left: 12px;
}

.pl-\\[16px\\] {
  padding-left: 16px;
}

.pl-\\[18px\\] {
  padding-left: 18px;
}

.pl-\\[22px\\] {
  padding-left: 22px;
}

.pl-\\[24px\\] {
  padding-left: 24px;
}

.pl-\\[26px\\] {
  padding-left: 26px;
}

.pl-\\[2px\\] {
  padding-left: 2px;
}

.pl-\\[32px\\] {
  padding-left: 32px;
}

.pl-\\[3px\\] {
  padding-left: 3px;
}

.pl-\\[4px\\] {
  padding-left: 4px;
}

.pl-\\[68px\\] {
  padding-left: 68px;
}

.pl-\\[6px\\] {
  padding-left: 6px;
}

.pl-\\[8px\\] {
  padding-left: 8px;
}

.pr {
  padding-right: var(--coze-8);
}

.pr-0 {
  padding-right: 0;
}

.pr-0\\.5 {
  padding-right: .125rem;
}

.pr-1 {
  padding-right: .25rem;
}

.pr-10 {
  padding-right: 2.5rem;
}

.pr-2 {
  padding-right: .5rem;
}

.pr-24px {
  padding-right: var(--coze-24);
}

.pr-3 {
  padding-right: .75rem;
}

.pr-4 {
  padding-right: 1rem;
}

.pr-4px {
  padding-right: var(--coze-4);
}

.pr-5 {
  padding-right: 1.25rem;
}

.pr-6 {
  padding-right: 1.5rem;
}

.pr-6px {
  padding-right: var(--coze-6);
}

.pr-8px {
  padding-right: var(--coze-8);
}

.pr-\\[10px\\] {
  padding-right: 10px;
}

.pr-\\[12px\\] {
  padding-right: 12px;
}

.pr-\\[16px\\] {
  padding-right: 16px;
}

.pr-\\[18px\\] {
  padding-right: 18px;
}

.pr-\\[20px\\] {
  padding-right: 20px;
}

.pr-\\[24px\\] {
  padding-right: 24px;
}

.pr-\\[28px\\] {
  padding-right: 28px;
}

.pr-\\[2px\\] {
  padding-right: 2px;
}

.pr-\\[3px\\] {
  padding-right: 3px;
}

.pr-\\[4px\\] {
  padding-right: 4px;
}

.pr-\\[6px\\] {
  padding-right: 6px;
}

.pr-\\[8px\\] {
  padding-right: 8px;
}

.pr-\\[9px\\] {
  padding-right: 9px;
}

.ps:not(:-webkit-any(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi))) {
  padding-left: var(--coze-8);
}

.ps:not(:-moz-any(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi))) {
  padding-left: var(--coze-8);
}

.ps:not(:is(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi))) {
  padding-left: var(--coze-8);
}

.ps:-webkit-any(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi)) {
  padding-right: var(--coze-8);
}

.ps:-moz-any(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi)) {
  padding-right: var(--coze-8);
}

.ps:is(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi)) {
  padding-right: var(--coze-8);
}

.pt {
  padding-top: var(--coze-8);
}

.pt-0 {
  padding-top: 0;
}

.pt-1 {
  padding-top: .25rem;
}

.pt-10 {
  padding-top: 2.5rem;
}

.pt-16px {
  padding-top: var(--coze-16);
}

.pt-2 {
  padding-top: .5rem;
}

.pt-2\\.5 {
  padding-top: .625rem;
}

.pt-2px {
  padding-top: var(--coze-2);
}

.pt-3 {
  padding-top: .75rem;
}

.pt-32px {
  padding-top: var(--coze-32);
}

.pt-4 {
  padding-top: 1rem;
}

.pt-5 {
  padding-top: 1.25rem;
}

.pt-6 {
  padding-top: 1.5rem;
}

.pt-8px {
  padding-top: var(--coze-8);
}

.pt-\\[100px\\] {
  padding-top: 100px;
}

.pt-\\[10px\\] {
  padding-top: 10px;
}

.pt-\\[120px\\] {
  padding-top: 120px;
}

.pt-\\[12px\\] {
  padding-top: 12px;
}

.pt-\\[13px\\] {
  padding-top: 13px;
}

.pt-\\[14px\\] {
  padding-top: 14px;
}

.pt-\\[16px\\] {
  padding-top: 16px;
}

.pt-\\[1px\\] {
  padding-top: 1px;
}

.pt-\\[20px\\] {
  padding-top: 20px;
}

.pt-\\[24px\\] {
  padding-top: 24px;
}

.pt-\\[2px\\] {
  padding-top: 2px;
}

.pt-\\[30px\\] {
  padding-top: 30px;
}

.pt-\\[32px\\] {
  padding-top: 32px;
}

.pt-\\[4px\\] {
  padding-top: 4px;
}

.pt-\\[50px\\] {
  padding-top: 50px;
}

.pt-\\[60px\\] {
  padding-top: 60px;
}

.pt-\\[6px\\] {
  padding-top: 6px;
}

.pt-\\[7px\\] {
  padding-top: 7px;
}

.pt-\\[8px\\] {
  padding-top: 8px;
}

.pt-\\[96px\\] {
  padding-top: 96px;
}

.text-left {
  text-align: left;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.text-start:not(:-webkit-any(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi))) {
  text-align: left;
}

.text-start:not(:-moz-any(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi))) {
  text-align: left;
}

.text-start:not(:is(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi))) {
  text-align: left;
}

.text-start:-webkit-any(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi)) {
  text-align: right;
}

.text-start:-moz-any(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi)) {
  text-align: right;
}

.text-start:is(:lang(ae), :lang(ar), :lang(arc), :lang(bcc), :lang(bqi), :lang(ckb), :lang(dv), :lang(fa), :lang(glk), :lang(he), :lang(ku), :lang(mzn), :lang(nqo), :lang(pnb), :lang(ps), :lang(sd), :lang(ug), :lang(ur), :lang(yi)) {
  text-align: right;
}

.indent {
  text-indent: var(--coze-8);
}

.align-top {
  vertical-align: top;
}

.align-middle {
  vertical-align: middle;
}

.align-sub {
  vertical-align: sub;
}

.\\!font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace !important;
}

.font-\\[\\'JetBrainsMonoBold\\'\\] {
  font-family: JetBrainsMonoBold;
}

.font-\\[\\'PICO_Sans_VFE_SC\\'\\] {
  font-family: PICO Sans VFE SC;
}

.font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace;
}

.\\!text-\\[10px\\] {
  font-size: 10px !important;
}

.\\!text-\\[12px\\] {
  font-size: 12px !important;
}

.\\!text-\\[13px\\] {
  font-size: 13px !important;
}

.\\!text-\\[14px\\] {
  font-size: 14px !important;
}

.\\!text-\\[16px\\] {
  font-size: 16px !important;
}

.\\!text-\\[18px\\] {
  font-size: 18px !important;
}

.\\!text-base {
  font-size: var(--coze-12) !important;
}

.\\!text-sm {
  font-size: .875rem !important;
  line-height: 1.25rem !important;
}

.\\!text-xs {
  font-size: .75rem !important;
  line-height: 1rem !important;
}

.\\!text-xxl {
  font-size: var(--coze-16) !important;
}

.text-18px {
  font-size: var(--coze-18);
}

.text-20px {
  font-size: var(--coze-20);
}

.text-24px {
  font-size: var(--coze-24);
}

.text-28px {
  font-size: var(--coze-28);
}

.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}

.text-32px {
  font-size: var(--coze-32);
}

.text-36px {
  font-size: var(--coze-36);
}

.text-64px {
  font-size: var(--coze-64);
}

.text-\\[\\#16px\\] {
  font-size: #16px;
}

.text-\\[0\\], .text-\\[0px\\] {
  font-size: 0;
}

.text-\\[10px\\] {
  font-size: 10px;
}

.text-\\[11px\\] {
  font-size: 11px;
}

.text-\\[120px\\] {
  font-size: 120px;
}

.text-\\[12px\\] {
  font-size: 12px;
}

.text-\\[13px\\] {
  font-size: 13px;
}

.text-\\[14px\\] {
  font-size: 14px;
}

.text-\\[15px\\] {
  font-size: 15px;
}

.text-\\[160px\\] {
  font-size: 160px;
}

.text-\\[16px\\] {
  font-size: 16px;
}

.text-\\[17px\\] {
  font-size: 17px;
}

.text-\\[18px\\] {
  font-size: 18px;
}

.text-\\[20px\\] {
  font-size: 20px;
}

.text-\\[22px\\] {
  font-size: 22px;
}

.text-\\[24px\\] {
  font-size: 24px;
}

.text-\\[28px\\] {
  font-size: 28px;
}

.text-\\[32px\\] {
  font-size: 32px;
}

.text-\\[48px\\] {
  font-size: 48px;
}

.text-base {
  font-size: var(--coze-12);
}

.text-lg {
  font-size: var(--coze-14);
}

.text-mini {
  font-size: var(--coze-10);
}

.text-sm {
  font-size: .875rem;
  line-height: 1.25rem;
}

.text-xl {
  font-size: var(--coze-15);
}

.text-xs {
  font-size: .75rem;
  line-height: 1rem;
}

.text-xxl {
  font-size: var(--coze-16);
}

.\\!font-\\[12px\\] {
  font-weight: 12px !important;
}

.\\!font-\\[400\\] {
  font-weight: 400 !important;
}

.\\!font-bold {
  font-weight: 700 !important;
}

.\\!font-medium {
  font-weight: 500 !important;
}

.\\!font-normal {
  font-weight: 400 !important;
}

.\\!font-semibold {
  font-weight: 600 !important;
}

.font-\\[13px\\] {
  font-weight: 13px;
}

.font-\\[400\\] {
  font-weight: 400;
}

.font-\\[500\\] {
  font-weight: 500;
}

.font-\\[600\\] {
  font-weight: 600;
}

.font-bold {
  font-weight: 700;
}

.font-medium {
  font-weight: 500;
}

.font-normal {
  font-weight: 400;
}

.font-semibold {
  font-weight: 600;
}

.uppercase {
  text-transform: uppercase;
}

.capitalize {
  text-transform: capitalize;
}

.italic {
  font-style: italic;
}

.not-italic {
  font-style: normal;
}

.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}

.\\!leading-\\[16px\\] {
  line-height: 16px !important;
}

.\\!leading-\\[20px\\] {
  line-height: 20px !important;
}

.\\!leading-\\[22px\\] {
  line-height: 22px !important;
}

.\\!leading-mini {
  line-height: var(--coze-16) !important;
}

.leading-14px {
  line-height: var(--coze-14);
}

.leading-16px {
  line-height: var(--coze-16);
}

.leading-20px {
  line-height: var(--coze-20);
}

.leading-22px {
  line-height: var(--coze-22);
}

.leading-28px {
  line-height: var(--coze-28);
}

.leading-3 {
  line-height: .75rem;
}

.leading-36px {
  line-height: var(--coze-36);
}

.leading-4 {
  line-height: 1rem;
}

.leading-5 {
  line-height: 1.25rem;
}

.leading-6 {
  line-height: 1.5rem;
}

.leading-7 {
  line-height: 1.75rem;
}

.leading-8 {
  line-height: 2rem;
}

.leading-\\[0\\] {
  line-height: 0;
}

.leading-\\[0px\\] {
  line-height: 0;
}

.leading-\\[1\\.5\\] {
  line-height: 1.5;
}

.leading-\\[10px\\] {
  line-height: 10px;
}

.leading-\\[12px\\] {
  line-height: 12px;
}

.leading-\\[14px\\] {
  line-height: 14px;
}

.leading-\\[16px\\] {
  line-height: 16px;
}

.leading-\\[17px\\] {
  line-height: 17px;
}

.leading-\\[18px\\] {
  line-height: 18px;
}

.leading-\\[20px\\] {
  line-height: 20px;
}

.leading-\\[22px\\] {
  line-height: 22px;
}

.leading-\\[24px\\] {
  line-height: 24px;
}

.leading-\\[26px\\] {
  line-height: 26px;
}

.leading-\\[28px\\] {
  line-height: 28px;
}

.leading-\\[32px\\] {
  line-height: 32px;
}

.leading-\\[36px\\] {
  line-height: 36px;
}

.leading-\\[44px\\] {
  line-height: 44px;
}

.leading-\\[72px\\] {
  line-height: 72px;
}

.leading-none {
  line-height: 1;
}

.tracking-\\[0\\.12px\\] {
  letter-spacing: .12px;
}

.\\!text-\\[\\#5A4DED\\] {
  --tw-text-opacity: 1 !important;
  color: rgba(90, 77, 237, var(--tw-text-opacity)) !important;
}

.\\!text-\\[\\#6B6B75\\] {
  --tw-text-opacity: 1 !important;
  color: rgba(107, 107, 117, var(--tw-text-opacity)) !important;
}

.\\!text-\\[\\#9498F7\\] {
  --tw-text-opacity: 1 !important;
  color: rgba(148, 152, 247, var(--tw-text-opacity)) !important;
}

.\\!text-\\[\\#E53241\\] {
  --tw-text-opacity: 1 !important;
  color: rgba(229, 50, 65, var(--tw-text-opacity)) !important;
}

.\\!text-\\[\\#FF9600\\] {
  --tw-text-opacity: 1 !important;
  color: rgba(255, 150, 0, var(--tw-text-opacity)) !important;
}

.\\!text-\\[\\#ff441e\\] {
  --tw-text-opacity: 1 !important;
  color: rgba(255, 68, 30, var(--tw-text-opacity)) !important;
}

.\\!text-\\[color\\:var\\(--coz-fg-primary\\)\\] {
  color: var(--coz-fg-primary) !important;
}

.\\!text-\\[rgb\\(var\\(--coze-up-brand-9\\)\\)\\] {
  color: rgb(var(--coze-up-brand-9)) !important;
}

.\\!text-\\[rgba\\(0\\,129\\,92\\,1\\)\\] {
  color: #00815c !important;
}

.\\!text-\\[rgba\\(160\\,95\\,1\\,1\\)\\] {
  color: #a05f01 !important;
}

.\\!text-\\[rgba\\(208\\,41\\,47\\,1\\)\\] {
  color: #d0292f !important;
}

.\\!text-\\[var\\(--coz-fg-dim\\)\\] {
  color: var(--coz-fg-dim) !important;
}

.\\!text-\\[var\\(--coz-fg-hglt-red\\)\\] {
  color: var(--coz-fg-hglt-red) !important;
}

.\\!text-\\[var\\(--coz-fg-plus\\)\\] {
  color: var(--coz-fg-plus) !important;
}

.\\!text-\\[var\\(--coz-fg-primary\\)\\] {
  color: var(--coz-fg-primary) !important;
}

.\\!text-\\[var\\(--coz-fg-secondary\\)\\] {
  color: var(--coz-fg-secondary) !important;
}

.\\!text-brand-7 {
  color: rgba(var(--coze-up-brand-7), 1) !important;
}

.\\!text-brand-9 {
  color: rgba(var(--coze-up-brand-9), 1) !important;
}

.\\!text-inherit {
  color: inherit !important;
}

.\\!text-white {
  color: rgb(var(--white-1)) !important;
}

.text-\\[\\#000000\\] {
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}

.text-\\[\\#00815C\\] {
  --tw-text-opacity: 1;
  color: rgba(0, 129, 92, var(--tw-text-opacity));
}

.text-\\[\\#0195AD\\] {
  --tw-text-opacity: 1;
  color: rgba(1, 149, 173, var(--tw-text-opacity));
}

.text-\\[\\#0607094D\\] {
  color: rgba(6, 7, 9, .3);
}

.text-\\[\\#06070980\\] {
  color: rgba(6, 7, 9, .5);
}

.text-\\[\\#060709CC\\] {
  color: rgba(6, 7, 9, .8);
}

.text-\\[\\#1C1D2359\\] {
  color: rgba(28, 29, 35, .35);
}

.text-\\[\\#1C1D24\\] {
  --tw-text-opacity: 1;
  color: rgba(28, 29, 36, var(--tw-text-opacity));
}

.text-\\[\\#1C1F23\\] {
  --tw-text-opacity: 1;
  color: rgba(28, 31, 35, var(--tw-text-opacity));
}

.text-\\[\\#1D1C2359\\] {
  color: rgba(29, 28, 35, .35);
}

.text-\\[\\#1D1C2399\\] {
  color: rgba(29, 28, 35, .6);
}

.text-\\[\\#1D1C23CC\\] {
  color: rgba(29, 28, 35, .8);
}

.text-\\[\\#1D1C23\\] {
  --tw-text-opacity: 1;
  color: rgba(29, 28, 35, var(--tw-text-opacity));
}

.text-\\[\\#1d1c2359\\] {
  color: rgba(29, 28, 35, .35);
}

.text-\\[\\#222222\\] {
  --tw-text-opacity: 1;
  color: rgba(34, 34, 34, var(--tw-text-opacity));
}

.text-\\[\\#4C54F0\\] {
  --tw-text-opacity: 1;
  color: rgba(76, 84, 240, var(--tw-text-opacity));
}

.text-\\[\\#4D53E8\\], .text-\\[\\#4d53e8\\] {
  --tw-text-opacity: 1;
  color: rgba(77, 83, 232, var(--tw-text-opacity));
}

.text-\\[\\#5A4DED\\] {
  --tw-text-opacity: 1;
  color: rgba(90, 77, 237, var(--tw-text-opacity));
}

.text-\\[\\#6C2CC6\\] {
  --tw-text-opacity: 1;
  color: rgba(108, 44, 198, var(--tw-text-opacity));
}

.text-\\[\\#888D92\\] {
  --tw-text-opacity: 1;
  color: rgba(136, 141, 146, var(--tw-text-opacity));
}

.text-\\[\\#A7A9B0\\] {
  --tw-text-opacity: 1;
  color: rgba(167, 169, 176, var(--tw-text-opacity));
}

.text-\\[\\#B0B9FF\\] {
  --tw-text-opacity: 1;
  color: rgba(176, 185, 255, var(--tw-text-opacity));
}

.text-\\[\\#D0292F\\] {
  --tw-text-opacity: 1;
  color: rgba(208, 41, 47, var(--tw-text-opacity));
}

.text-\\[\\#E53241\\] {
  --tw-text-opacity: 1;
  color: rgba(229, 50, 65, var(--tw-text-opacity));
}

.text-\\[\\#FF2710\\] {
  --tw-text-opacity: 1;
  color: rgba(255, 39, 16, var(--tw-text-opacity));
}

.text-\\[\\#FF441E\\] {
  --tw-text-opacity: 1;
  color: rgba(255, 68, 30, var(--tw-text-opacity));
}

.text-\\[\\#FFFFFF\\/60\\] {
  color: #fff / 60;
}

.text-\\[\\#cb4b16\\] {
  --tw-text-opacity: 1;
  color: rgba(203, 75, 22, var(--tw-text-opacity));
}

.text-\\[\\#ff441e\\] {
  --tw-text-opacity: 1;
  color: rgba(255, 68, 30, var(--tw-text-opacity));
}

.text-\\[--coz-fg-dim\\] {
  color: var(--coz-fg-dim);
}

.text-\\[--semi-color-danger\\] {
  color: var(--semi-color-danger);
}

.text-\\[--semi-color-secondary\\] {
  color: var(--semi-color-secondary);
}

.text-\\[--semi-color-tertiary-active\\] {
  color: var(--semi-color-tertiary-active);
}

.text-\\[--semi-color-text-2\\] {
  color: var(--semi-color-text-2);
}

.text-\\[--semi-color-warning\\] {
  color: var(--semi-color-warning);
}

.text-\\[16\\] {
  color: 16;
}

.text-\\[color\\:var\\(--text-color-text-2\\,\\#42464E\\)\\] {
  color: var(--text-color-text-2, #42464e);
}

.text-\\[red\\] {
  --tw-text-opacity: 1;
  color: rgba(255, 0, 0, var(--tw-text-opacity));
}

.text-\\[rgb\\(var\\(--coze-red-5\\)\\)\\] {
  color: rgb(var(--coze-red-5));
}

.text-\\[rgb\\(var\\(--coze-up-brand-9\\)\\)\\] {
  color: rgb(var(--coze-up-brand-9));
}

.text-\\[rgba\\(15\\,21\\,40\\,0\\.82\\)\\] {
  color: rgba(15, 21, 40, .82);
}

.text-\\[rgba\\(28\\,29\\,35\\,0\\.35\\)\\] {
  color: rgba(28, 29, 35, .35);
}

.text-\\[rgba\\(28\\,_29\\,_36\\,_0\\.80\\)\\] {
  color: rgba(28, 29, 36, .8);
}

.text-\\[rgba\\(29\\,_28\\,_36\\,_0\\.60\\)\\] {
  color: rgba(29, 28, 36, .6);
}

.text-\\[rgba\\(32\\,41\\,69\\,0\\.62\\)\\] {
  color: rgba(32, 41, 69, .62);
}

.text-\\[rgba\\(var\\(--coze-up-brand-9\\)\\)\\] {
  color: rgba(var(--coze-up-brand-9));
}

.text-\\[unset\\] {
  color: unset;
}

.text-\\[var\\(--color-fg-muted\\)\\] {
  color: var(--color-fg-muted);
}

.text-\\[var\\(--coz-fg-color-cyan\\)\\] {
  color: var(--coz-fg-color-cyan);
}

.text-\\[var\\(--coz-fg-color-magenta\\)\\] {
  color: var(--coz-fg-color-magenta);
}

.text-\\[var\\(--coz-fg-dim\\)\\] {
  color: var(--coz-fg-dim);
}

.text-\\[var\\(--coz-fg-hglt\\)\\] {
  color: var(--coz-fg-hglt);
}

.text-\\[var\\(--coz-fg-hglt-dim\\)\\] {
  color: var(--coz-fg-hglt-dim);
}

.text-\\[var\\(--coz-fg-hglt-green\\)\\] {
  color: var(--coz-fg-hglt-green);
}

.text-\\[var\\(--coz-fg-plus\\)\\] {
  color: var(--coz-fg-plus);
}

.text-\\[var\\(--coz-fg-primary\\)\\] {
  color: var(--coz-fg-primary);
}

.text-\\[var\\(--coz-fg-se\\)\\] {
  color: var(--coz-fg-se);
}

.text-\\[var\\(--coz-fg-secondary\\)\\] {
  color: var(--coz-fg-secondary);
}

.text-\\[var\\(--coz-stroke-primary\\)\\] {
  color: var(--coz-stroke-primary);
}

.text-\\[var\\(--light-usage-text-color-text-0\\,\\#1c1d23\\)\\] {
  color: var(--light-usage-text-color-text-0, #1c1d23);
}

.text-\\[var\\(--semi-color-link\\)\\] {
  color: var(--semi-color-link);
}

.text-\\[var\\(--semi-color-text-0\\)\\] {
  color: var(--semi-color-text-0);
}

.text-\\[var\\(--semi-color-text-2\\)\\] {
  color: var(--semi-color-text-2);
}

.text-\\[var\\(--semi-color-text-3\\)\\] {
  color: var(--semi-color-text-3);
}

.text-background {
  color: rgba(var(--background), 1);
}

.text-black {
  color: rgb(var(--black-6));
}

.text-brand {
  color: rgba(var(--coze-up-brand-9), 1);
}

.text-brand-6 {
  color: rgba(var(--coze-up-brand-6), 1);
}

.text-brand-7 {
  color: rgba(var(--coze-up-brand-7), 1);
}

.text-brand-9 {
  color: rgba(var(--coze-up-brand-9), 1);
}

.text-foreground {
  color: rgba(var(--foreground), 1);
}

.text-foreground-1 {
  color: rgba(var(--coze-fg-1), var(--coze-fg-1-alpha));
}

.text-foreground-2 {
  color: rgba(var(--coze-fg-2), var(--coze-fg-2-alpha));
}

.text-foreground-3 {
  color: rgba(var(--coze-fg-3), var(--coze-fg-3-alpha));
}

.text-foreground-4 {
  color: rgba(var(--coze-fg-4), var(--coze-fg-4-alpha));
}

.text-foreground-5 {
  color: rgba(var(--coze-fg-5), var(--coze-fg-5-alpha));
}

.text-gray-200 {
  --tw-text-opacity: 1;
  color: rgba(229, 231, 235, var(--tw-text-opacity));
}

.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgba(156, 163, 175, var(--tw-text-opacity));
}

.text-gray-50 {
  --tw-text-opacity: 1;
  color: rgba(249, 250, 251, var(--tw-text-opacity));
}

.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgba(107, 114, 128, var(--tw-text-opacity));
}

.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgba(75, 85, 99, var(--tw-text-opacity));
}

.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgba(55, 65, 81, var(--tw-text-opacity));
}

.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgba(31, 41, 55, var(--tw-text-opacity));
}

.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgba(17, 24, 39, var(--tw-text-opacity));
}

.text-green-500 {
  --tw-text-opacity: 1;
  color: rgba(34, 197, 94, var(--tw-text-opacity));
}

.text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgba(79, 70, 229, var(--tw-text-opacity));
}

.text-inherit {
  color: inherit;
}

.text-orange-500 {
  --tw-text-opacity: 1;
  color: rgba(249, 115, 22, var(--tw-text-opacity));
}

.text-red {
  color: rgba(var(--coze-red-7), 1);
}

.text-red-500 {
  --tw-text-opacity: 1;
  color: rgba(239, 68, 68, var(--tw-text-opacity));
}

.text-red-600 {
  --tw-text-opacity: 1;
  color: rgba(220, 38, 38, var(--tw-text-opacity));
}

.text-sky-500 {
  --tw-text-opacity: 1;
  color: rgba(14, 165, 233, var(--tw-text-opacity));
}

.text-slate-500 {
  --tw-text-opacity: 1;
  color: rgba(100, 116, 139, var(--tw-text-opacity));
}

.text-transparent {
  color: rgba(0, 0, 0, 0);
}

.text-white {
  color: rgb(var(--white-1));
}

.text-white\\/70 {
  color: rgb(var(--white-1) / .7);
}

.text-yellow-7 {
  color: rgba(var(--coze-yellow-7), 1);
}

.\\!text-opacity-70 {
  --tw-text-opacity: .7 !important;
}

.underline {
  -webkit-text-decoration-line: underline;
  text-decoration-line: underline;
}

.line-through {
  -webkit-text-decoration-line: line-through;
  text-decoration-line: line-through;
}

.no-underline {
  -webkit-text-decoration-line: none;
  text-decoration-line: none;
}

.decoration-\\[var\\(--coz-fg-secondary\\)\\] {
  -webkit-text-decoration-color: var(--coz-fg-secondary);
  text-decoration-color: var(--coz-fg-secondary);
}

.decoration-dotted {
  -webkit-text-decoration-style: dotted;
  text-decoration-style: dotted;
}

.underline-offset-2 {
  text-underline-offset: 2px;
}

.\\!opacity-70 {
  opacity: .7 !important;
}

.opacity-0 {
  opacity: 0;
}

.opacity-100 {
  opacity: 1;
}

.opacity-30 {
  opacity: .3;
}

.opacity-40 {
  opacity: .4;
}

.opacity-50 {
  opacity: .5;
}

.opacity-60 {
  opacity: .6;
}

.opacity-70 {
  opacity: .7;
}

.opacity-80 {
  opacity: .8;
}

.shadow {
  --tw-shadow: 0 8px 28px 0px rgba(var(--coze-up-brand-12), .08);
  --tw-shadow-colored: 0 8px 28px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}

.shadow-\\[0_20px_60px_rgba\\(15\\,23\\,42\\,0\\.24\\)\\] {
  --tw-shadow: 0 20px 60px rgba(15, 23, 42, .24);
  --tw-shadow-colored: 0 20px 60px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}

.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgba(0, 0, 0, .1), 0 4px 6px -4px rgba(0, 0, 0, .1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}

.shadow-normal {
  --tw-shadow: 0 8px 28px 0px rgba(var(--coze-up-brand-12), .08);
  --tw-shadow-colored: 0 8px 28px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}

.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, .05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}

.outline-none {
  outline-offset: 2px;
  outline: 2px solid rgba(0, 0, 0, 0);
}

.outline {
  outline-style: solid;
}

.outline-1, .outline-\\[1px\\] {
  outline-width: 1px;
}

.outline-\\[\\#0607091A\\] {
  outline-color: rgba(6, 7, 9, .1);
}

.outline-\\[\\#F2B600\\] {
  outline-color: #f2b600;
}

.outline-\\[\\#FF811A\\] {
  outline-color: #ff811a;
}

.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0, 0, 0, 0));
}

.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0, 0, 0, 0));
}

.ring-offset-2 {
  --tw-ring-offset-width: 2px;
}

.ring-offset-background {
  --tw-ring-offset-color: rgba(var(--background), 1);
}

.blur {
  --tw-blur: blur(8px);
  -webkit-filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.invert {
  --tw-invert: invert(100%);
  -webkit-filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.\\!filter {
  -webkit-filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}

.filter {
  -webkit-filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.backdrop-blur-\\[20px\\] {
  --tw-backdrop-blur: blur(20px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.backdrop-blur-\\[3\\.45px\\] {
  --tw-backdrop-blur: blur(3.45px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.backdrop-blur-\\[6px\\] {
  --tw-backdrop-blur: blur(6px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.backdrop-blur-md {
  --tw-backdrop-blur: blur(12px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.transition {
  transition-property: color, background-color, border-color, -webkit-text-decoration-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, -webkit-filter, filter, -webkit-backdrop-filter, backdrop-filter;
  transition-duration: .15s;
  transition-timing-function: cubic-bezier(.4, 0, .2, 1);
}

.transition-all {
  transition-property: all;
  transition-duration: .15s;
  transition-timing-function: cubic-bezier(.4, 0, .2, 1);
}

.transition-colors {
  transition-property: color, background-color, border-color, -webkit-text-decoration-color, text-decoration-color, fill, stroke;
  transition-duration: .15s;
  transition-timing-function: cubic-bezier(.4, 0, .2, 1);
}

.transition-opacity {
  transition-property: opacity;
  transition-duration: .15s;
  transition-timing-function: cubic-bezier(.4, 0, .2, 1);
}

.transition-transform {
  transition-property: transform;
  transition-duration: .15s;
  transition-timing-function: cubic-bezier(.4, 0, .2, 1);
}

.duration-100 {
  transition-duration: .1s;
}

.duration-150 {
  transition-duration: .15s;
}

.duration-200 {
  transition-duration: .2s;
}

.duration-300 {
  transition-duration: .3s;
}

.duration-500 {
  transition-duration: .5s;
}

.ease-in {
  transition-timing-function: cubic-bezier(.4, 0, 1, 1);
}

.ease-in-out {
  transition-timing-function: cubic-bezier(.4, 0, .2, 1);
}

.ease-out {
  transition-timing-function: cubic-bezier(0, 0, .2, 1);
}

.coz-fg-hglt-plus, .coz-fg-hglt-plus-dim {
  color: rgba(var(--coze-fg-5), var(--coze-fg-5-alpha));
}

.\\!coz-fg-plus {
  color: rgba(var(--coze-fg-4), var(--coze-fg-4-alpha)) !important;
}

.coz-fg-plus {
  color: rgba(var(--coze-fg-4), var(--coze-fg-4-alpha));
}

.\\!coz-fg-primary {
  color: rgba(var(--coze-fg-3), var(--coze-fg-3-alpha)) !important;
}

.coz-fg-primary {
  color: rgba(var(--coze-fg-3), var(--coze-fg-3-alpha));
}

.\\!coz-fg-secondary {
  color: rgba(var(--coze-fg-2), var(--coze-fg-2-alpha)) !important;
}

.coz-fg-secondary {
  color: rgba(var(--coze-fg-2), var(--coze-fg-2-alpha));
}

.\\!coz-fg-dim {
  color: rgba(var(--coze-fg-1), var(--coze-fg-1-alpha)) !important;
}

.coz-fg-dim {
  color: rgba(var(--coze-fg-1), var(--coze-fg-1-alpha));
}

.\\!coz-fg-white {
  color: rgba(var(--coze-fg-7), 1) !important;
}

.coz-fg-white {
  color: rgba(var(--coze-fg-7), 1);
}

.coz-fg-white-dim {
  color: rgba(var(--coze-fg-white), var(--coze-fg-white-alpha));
}

.coz-fg-hglt-ai {
  color: rgba(var(--coze-purple-5), 1);
}

.coz-fg-hglt-ai-dim {
  color: rgba(var(--coze-purple-3), var(--coze-purple-3-alpha));
}

.\\!coz-fg-hglt-red {
  color: rgba(var(--coze-red-5), 1) !important;
}

.coz-fg-hglt-red {
  color: rgba(var(--coze-red-5), 1);
}

.coz-fg-hglt-red-dim {
  color: rgba(var(--coze-red-3), var(--coze-red-3-alpha));
}

.coz-fg-hglt-yellow {
  color: rgba(var(--coze-yellow-5), 1);
}

.coz-fg-hglt-yellow-dim {
  color: rgba(var(--coze-yellow-3), var(--coze-yellow-3-alpha));
}

.coz-fg-hglt-green {
  color: rgba(var(--coze-green-5), 1);
}

.coz-fg-hglt-green-dim {
  color: rgba(var(--coze-green-3), var(--coze-green-3-alpha));
}

.coz-fg-color-orange {
  color: rgba(var(--coze-yellow-5), 1);
}

.coz-fg-color-orange-dim {
  color: rgba(var(--coze-yellow-3), var(--coze-yellow-3-alpha));
}

.coz-fg-color-emerald {
  color: rgba(var(--coze-green-5), 1);
}

.coz-fg-color-emerald-dim {
  color: rgba(var(--coze-green-3), var(--coze-green-3-alpha));
}

.coz-fg-color-cyan {
  color: rgba(var(--coze-cyan-50), var(--coze-cyan-50-alpha));
}

.coz-fg-color-cyan-dim {
  color: rgba(var(--coze-cyan-30), var(--coze-cyan-30-alpha));
}

.\\!coz-fg-color-blue {
  color: rgba(var(--coze-blue-50), var(--coze-blue-50-alpha)) !important;
}

.coz-fg-color-blue {
  color: rgba(var(--coze-blue-50), var(--coze-blue-50-alpha));
}

.coz-fg-color-blue-dim {
  color: rgba(var(--coze-blue-30), var(--coze-blue-30-alpha));
}

.coz-fg-color-purple {
  color: rgba(var(--coze-purple-50), var(--coze-purple-50-alpha));
}

.coz-fg-color-purple-dim {
  color: rgba(var(--coze-purple-30), var(--coze-purple-30-alpha));
}

.coz-fg-color-magenta {
  color: rgba(var(--coze-magenta-50), var(--coze-magenta-50-alpha));
}

.coz-fg-color-magenta-dim {
  color: rgba(var(--coze-magenta-3), var(--coze-magenta-3-alpha));
}

.coz-fg-color-yellow {
  color: rgba(var(--coze-yellow-50), var(--coze-yellow-50-alpha));
}

.coz-fg-color-yellow-dim {
  color: rgba(var(--coze-yellow-30), var(--coze-yellow-30-alpha));
}

.coz-fg-hglt-orange {
  color: rgba(var(--coze-orange-5), 1);
}

.coz-fg-hglt-orange-dim {
  color: rgba(var(--coze-orange-3), var(--coze-orange-3-alpha));
}

.coz-fg-hglt-emerald {
  color: rgba(var(--coze-emerald-5), 1);
}

.coz-fg-hglt-emerald-dim {
  color: rgba(var(--coze-emerald-3), var(--coze-emerald-3-alpha));
}

.coz-fg-hglt-cyan {
  color: rgba(var(--coze-cyan-5), 1);
}

.coz-fg-hglt-cyan-dim {
  color: rgba(var(--coze-cyan-3), var(--coze-cyan-3-alpha));
}

.coz-fg-hglt-blue {
  color: rgba(var(--coze-blue-5), var(--coze-blue-5-alpha));
}

.coz-fg-hglt-blue-dim {
  color: rgba(var(--coze-blue-3), var(--coze-blue-3-alpha));
}

.coz-fg-hglt-purple {
  color: rgba(var(--coze-purple-5), 1);
}

.coz-fg-hglt-purple-dim {
  color: rgba(var(--coze-purple-3), var(--coze-purple-3-alpha));
}

.coz-fg-hglt-magenta {
  color: rgba(var(--coze-magenta-5), 1);
}

.coz-fg-hglt-magenta-dim {
  color: rgba(var(--coze-magenta-3), var(--coze-magenta-3-alpha));
}

.coz-fg-color-brand {
  color: rgba(var(--coze-brand-50), var(--coze-brand-50-alpha));
}

.coz-fg-color-brand-dim {
  color: rgba(var(--coze-brand-30), var(--coze-brand-30-alpha));
}

.coz-fg-color-alternative {
  color: rgba(var(--coze-alternative-50), 1);
}

.coz-fg-color-alternative-dim {
  color: rgba(var(--coze-alternative-30), var(--coze-alternative-30-alpha));
}

.coz-mg-hglt-secondary-red {
  background-color: rgba(var(--coze-red-0), var(--coze-red-0-alpha));
}

.coz-mg-hglt-secondary-yellow {
  background-color: rgba(var(--coze-yellow-0), var(--coze-yellow-0-alpha));
}

.coz-mg-hglt-secondary-green {
  background-color: rgba(var(--coze-green-0), var(--coze-green-0-alpha));
}

.coz-mg-plus-pressed {
  background-color: rgba(var(--coze-bg-8), var(--coze-bg-8-alpha));
}

.coz-mg-plus-hovered {
  background-color: rgba(var(--coze-bg-7), var(--coze-bg-7-alpha));
}

.\\!coz-mg-plus {
  background-color: rgba(var(--coze-bg-6), var(--coze-bg-6-alpha)) !important;
}

.coz-mg-plus {
  background-color: rgba(var(--coze-bg-6), var(--coze-bg-6-alpha));
}

.coz-mg-hglt-pressed {
  background-color: rgba(var(--coze-up-brand-3), 1);
}

.coz-mg-hglt-plus-ai-pressed {
  background-color: rgba(var(--coze-purple-7), 1);
}

.coz-mg-hglt-plus-ai-hovered {
  background-color: rgba(var(--coze-purple-6), 1);
}

.coz-mg-hglt-plus-ai {
  background-color: rgba(var(--coze-purple-5), 1);
}

.coz-mg-hglt-plus-ai-dim {
  background-color: rgba(var(--coze-purple-3), var(--coze-purple-3-alpha));
}

.coz-mg-hglt-ai-pressed {
  background-color: rgba(var(--coze-purple-3), var(--coze-purple-3-alpha));
}

.coz-mg-hglt-ai-hovered {
  background-color: rgba(var(--coze-purple-2), var(--coze-purple-2-alpha));
}

.coz-mg-hglt-ai {
  background-color: rgba(var(--coze-purple-1), var(--coze-purple-1-alpha));
}

.coz-mg-hglt-plus-red-pressed {
  background-color: rgba(var(--coze-red-7), 1);
}

.coz-mg-hglt-plus-red-hovered {
  background-color: rgba(var(--coze-red-6), 1);
}

.coz-mg-hglt-plus-red {
  background-color: rgba(var(--coze-red-5), 1);
}

.coz-mg-hglt-plus-red-dim {
  background-color: rgba(var(--coze-red-3), var(--coze-red-3-alpha));
}

.coz-mg-hglt-plus-yellow-pressed {
  background-color: rgba(var(--coze-yellow-7), 1);
}

.coz-mg-hglt-plus-yellow-hovered {
  background-color: rgba(var(--coze-yellow-6), 1);
}

.coz-mg-hglt-plus-yellow {
  background-color: rgba(var(--coze-yellow-5), 1);
}

.coz-mg-hglt-plus-yellow-dim {
  background-color: rgba(var(--coze-yellow-3), var(--coze-yellow-3-alpha));
}

.coz-mg-hglt-plus-green-pressed {
  background-color: rgba(var(--coze-green-7), 1);
}

.coz-mg-hglt-plus-green-hovered {
  background-color: rgba(var(--coze-green-6), 1);
}

.coz-mg-hglt-plus-green {
  background-color: rgba(var(--coze-green-5), 1);
}

.coz-mg-hglt-plus-green-dim {
  background-color: rgba(var(--coze-green-3), var(--coze-green-3-alpha));
}

.coz-mg-hglt-red-pressed {
  background-color: rgba(var(--coze-red-3), var(--coze-red-3-alpha));
}

.coz-mg-hglt-red-hovered {
  background-color: rgba(var(--coze-red-2), var(--coze-red-2-alpha));
}

.coz-mg-hglt-red {
  background-color: rgba(var(--coze-red-1), var(--coze-red-1-alpha));
}

.coz-mg-hglt-yellow-pressed {
  background-color: rgba(var(--coze-yellow-3), var(--coze-yellow-3-alpha));
}

.coz-mg-hglt-yellow-hovered {
  background-color: rgba(var(--coze-yellow-2), var(--coze-yellow-2-alpha));
}

.coz-mg-hglt-yellow {
  background-color: rgba(var(--coze-yellow-1), var(--coze-yellow-1-alpha));
}

.coz-mg-hglt-green-pressed {
  background-color: rgba(var(--coze-green-3), var(--coze-green-3-alpha));
}

.coz-mg-hglt-green-hovered {
  background-color: rgba(var(--coze-green-2), var(--coze-green-2-alpha));
}

.coz-mg-hglt-green {
  background-color: rgba(var(--coze-green-1), var(--coze-green-1-alpha));
}

.coz-mg-color-plus-orange {
  background-color: rgba(var(--coze-yellow-5), 1);
}

.coz-mg-color-plus-emerald {
  background-color: rgba(var(--coze-green-5), 1);
}

.coz-mg-color-plus-cyan {
  background-color: rgba(var(--coze-cyan-50), var(--coze-cyan-50-alpha));
}

.coz-mg-color-plus-blue {
  background-color: rgba(var(--coze-blue-50), var(--coze-blue-50-alpha));
}

.coz-mg-color-plus-purple {
  background-color: rgba(var(--coze-purple-50), var(--coze-purple-50-alpha));
}

.coz-mg-color-plus-magenta {
  background-color: rgba(var(--coze-magenta-50), var(--coze-magenta-50-alpha));
}

.coz-mg-color-plus-yellow {
  background-color: rgba(var(--coze-yellow-50), var(--coze-yellow-50-alpha));
}

.coz-mg-color-orange-pressed {
  background-color: rgba(var(--coze-yellow-3), var(--coze-yellow-3-alpha));
}

.coz-mg-color-orange-hovered {
  background-color: rgba(var(--coze-yellow-2), var(--coze-yellow-2-alpha));
}

.coz-mg-color-orange {
  background-color: rgba(var(--coze-yellow-1), var(--coze-yellow-1-alpha));
}

.coz-mg-color-emerald-pressed {
  background-color: rgba(var(--coze-green-3), var(--coze-green-3-alpha));
}

.coz-mg-color-emerald-hovered {
  background-color: rgba(var(--coze-green-2), var(--coze-green-2-alpha));
}

.coz-mg-color-emerald {
  background-color: rgba(var(--coze-green-1), var(--coze-green-1-alpha));
}

.coz-mg-color-cyan-pressed {
  background-color: rgba(var(--coze-cyan-30), var(--coze-cyan-30-alpha));
}

.coz-mg-color-cyan-hovered {
  background-color: rgba(var(--coze-cyan-20), var(--coze-cyan-20-alpha));
}

.coz-mg-color-cyan {
  background-color: rgba(var(--coze-cyan-10), var(--coze-cyan-10-alpha));
}

.coz-mg-color-blue-pressed {
  background-color: rgba(var(--coze-blue-30), var(--coze-blue-30-alpha));
}

.coz-mg-color-blue-hovered {
  background-color: rgba(var(--coze-blue-20), var(--coze-blue-20-alpha));
}

.\\!coz-mg-color-blue {
  background-color: rgba(var(--coze-blue-10), var(--coze-blue-10-alpha)) !important;
}

.coz-mg-color-blue {
  background-color: rgba(var(--coze-blue-10), var(--coze-blue-10-alpha));
}

.coz-mg-color-purple-pressed {
  background-color: rgba(var(--coze-purple-30), var(--coze-purple-30-alpha));
}

.coz-mg-color-purple-hovered {
  background-color: rgba(var(--coze-purple-20), var(--coze-purple-20-alpha));
}

.coz-mg-color-purple {
  background-color: rgba(var(--coze-purple-10), var(--coze-purple-10-alpha));
}

.coz-mg-color-magenta-pressed {
  background-color: rgba(var(--coze-magenta-30), var(--coze-magenta-30-alpha));
}

.coz-mg-color-magenta-hovered {
  background-color: rgba(var(--coze-magenta-20), var(--coze-magenta-20-alpha));
}

.coz-mg-color-magenta {
  background-color: rgba(var(--coze-magenta-10), var(--coze-magenta-10-alpha));
}

.\\!coz-mg-primary-pressed {
  background-color: rgba(var(--coze-bg-7), var(--coze-bg-7-alpha)) !important;
}

.coz-mg-primary-pressed {
  background-color: rgba(var(--coze-bg-7), var(--coze-bg-7-alpha));
}

.coz-mg-primary-hovered {
  background-color: rgba(var(--coze-bg-6), var(--coze-bg-6-alpha));
}

.\\!coz-mg-primary {
  background-color: rgba(var(--coze-bg-5), var(--coze-bg-5-alpha)) !important;
}

.coz-mg-primary {
  background-color: rgba(var(--coze-bg-5), var(--coze-bg-5-alpha));
}

.\\!coz-mg-secondary-pressed {
  background-color: rgba(var(--coze-bg-6), var(--coze-bg-6-alpha)) !important;
}

.coz-mg-secondary-pressed {
  background-color: rgba(var(--coze-bg-6), var(--coze-bg-6-alpha));
}

.\\!coz-mg-secondary-hovered {
  background-color: rgba(var(--coze-bg-5), var(--coze-bg-5-alpha)) !important;
}

.coz-mg-secondary-hovered {
  background-color: rgba(var(--coze-bg-5), var(--coze-bg-5-alpha));
}

.coz-mg-secondary {
  background-color: rgba(var(--coze-bg-4), var(--coze-bg-4-alpha));
}

.coz-mg-mask {
  background-color: rgba(var(--coze-mask-5), .4);
}

.coz-mg-card-hovered, .coz-mg-card {
  background-color: rgba(var(--coze-bg-3), var(--coze-bg-3-alpha));
}

.coz-mg-color-plus-brand {
  background-color: rgba(var(--coze-brand-50), var(--coze-brand-50-alpha));
}

.\\!coz-bg-max {
  background-color: rgba(var(--coze-bg-3), var(--coze-bg-3-alpha)) !important;
}

.coz-bg-max {
  background-color: rgba(var(--coze-bg-3), var(--coze-bg-3-alpha));
}

.coz-bg-plus {
  background-color: rgba(var(--coze-bg-2), var(--coze-bg-2-alpha));
}

.\\!coz-bg-primary {
  background-color: rgba(var(--coze-bg-1), var(--coze-bg-1-alpha)) !important;
}

.coz-bg-primary {
  background-color: rgba(var(--coze-bg-1), var(--coze-bg-1-alpha));
}

.\\!coz-bg-secondary {
  background-color: rgba(var(--coze-bg-0), 1) !important;
}

.coz-bg-secondary {
  background-color: rgba(var(--coze-bg-0), 1);
}

.\\!coz-stroke-plus {
  border-color: rgba(var(--coze-stroke-6), var(--coze-stroke-6-alpha)) !important;
}

.coz-stroke-plus {
  border-color: rgba(var(--coze-stroke-6), var(--coze-stroke-6-alpha));
}

.\\!coz-stroke-primary {
  border-color: rgba(var(--coze-stroke-5), var(--coze-stroke-5-alpha)) !important;
}

.coz-stroke-primary {
  border-color: rgba(var(--coze-stroke-5), var(--coze-stroke-5-alpha));
}

.\\!coz-stroke-hglt-red {
  border-color: rgba(var(--coze-red-5), 1) !important;
}

.coz-stroke-hglt-red {
  border-color: rgba(var(--coze-red-5), 1);
}

.coz-stroke-hglt-yellow {
  border-color: rgba(var(--coze-yellow-5), 1);
}

.coz-stroke-hglt-green {
  border-color: rgba(var(--coze-green-5), 1);
}

.coz-stroke-color-orange {
  border-color: rgba(var(--coze-yellow-5), 1);
}

.coz-stroke-color-emerald {
  border-color: rgba(var(--coze-green-5), 1);
}

.coz-stroke-color-cyan {
  border-color: rgba(var(--coze-cyan-50), var(--coze-cyan-50-alpha));
}

.coz-stroke-color-blue {
  border-color: rgba(var(--coze-blue-50), var(--coze-blue-50-alpha));
}

.coz-stroke-color-purple {
  border-color: rgba(var(--coze-purple-50), var(--coze-purple-50-alpha));
}

.coz-stroke-color-magenta {
  border-color: rgba(var(--coze-magenta-50), var(--coze-magenta-50-alpha));
}

.coz-stroke-color-yellow {
  border-color: rgba(var(--coze-yellow-50), var(--coze-yellow-50-alpha));
}

.coz-stroke-color-brand {
  border-color: rgba(var(--coze-brand-50), var(--coze-brand-50-alpha));
}

.coz-shadow-default {
  box-shadow: 0 8px 28px 0px rgba(var(--coze-up-brand-12), .08);
}

.\\!coz-fg-hglt {
  color: rgba(var(--coze-up-brand-9), 1) !important;
}

.coz-fg-hglt {
  color: rgba(var(--coze-up-brand-9), 1);
}

.coz-fg-hglt-dim {
  color: rgba(var(--coze-up-brand-5), 1);
}

.\\!coz-stroke-hglt {
  border-color: rgba(var(--coze-up-brand-9), 1) !important;
}

.coz-stroke-hglt {
  border-color: rgba(var(--coze-up-brand-9), 1);
}

.coz-shadow-large {
  box-shadow: 0 8px 48px 0px rgba(var(--coze-up-brand-12), .12);
}

.coz-shadow-small {
  box-shadow: 0 8px 16px 0 rgba(var(--coze-up-brand-12), .06);
}

.coz-mg-hglt-secondary-pressed {
  background-color: rgba(var(--coze-up-brand-4), 1);
}

.coz-mg-hglt-secondary-hovered {
  background-color: rgba(var(--coze-up-brand-3), 1);
}

.coz-mg-hglt-secondary {
  background-color: rgba(var(--coze-up-brand-2), 1);
}

.coz-mg-hglt-plus-pressed {
  background-color: rgba(var(--coze-up-brand-11), 1);
}

.coz-mg-hglt-plus-hovered {
  background-color: rgba(var(--coze-up-brand-10), 1);
}

.coz-mg-hglt-plus {
  background-color: rgba(var(--coze-up-brand-9), 1);
}

.coz-mg-hglt-plus-dim, .coz-mg-hglt-pressed {
  background-color: rgba(var(--coze-up-brand-5), 1);
}

.coz-mg-hglt-hovered {
  background-color: rgba(var(--coze-up-brand-4), 1);
}

.\\!coz-mg-hglt {
  background-color: rgba(var(--coze-up-brand-3), 1) !important;
}

.coz-mg-hglt {
  background-color: rgba(var(--coze-up-brand-3), 1);
}

.\\[border-top\\:1px_solid_rgba\\(_56\\,55\\,67_\\,0\\.08\\)\\] {
  border-top: 1px solid rgba(56, 55, 67, .08);
}

#root {
  width: 100%;
  height: 100%;
}

.placeholder\\:coz-fg-dim::placeholder {
  color: rgba(var(--coze-fg-1), var(--coze-fg-1-alpha));
}

.placeholder\\:coz-fg-dim::placeholder {
  color: rgba(var(--coze-fg-1), var(--coze-fg-1-alpha));
}

.placeholder\\:coz-fg-dim::placeholder {
  color: rgba(var(--coze-fg-1), var(--coze-fg-1-alpha));
}

.after\\:absolute:after {
  content: var(--tw-content);
  position: absolute;
}

.after\\:bottom-0:after {
  content: var(--tw-content);
  bottom: 0;
}

.after\\:left-0:after {
  content: var(--tw-content);
  left: 0;
}

.after\\:right-0:after {
  content: var(--tw-content);
  right: 0;
}

.after\\:hidden:after {
  content: var(--tw-content);
  display: none;
}

.after\\:h-\\[1px\\]:after {
  content: var(--tw-content);
  height: 1px;
}

.after\\:content-\\[\\"\\"\\]:after {
  --tw-content: "";
  content: var(--tw-content);
}

.after\\:coz-mg-primary:after {
  content: var(--tw-content);
  background-color: rgba(var(--coze-bg-5), var(--coze-bg-5-alpha));
}

.first\\:hidden:first-child {
  display: none;
}

.last\\:mb-0:last-child {
  margin-bottom: 0;
}

.last\\:flex-1:last-child {
  flex: 1;
}

.last\\:border-b-0:last-child {
  border-bottom-width: 0;
}

.last\\:border-r-0:last-child {
  border-right-width: 0;
}

.last\\:border-none:last-child {
  border-style: none;
}

.last\\:border-b-0:last-child {
  border-bottom-color: rgba(var(--coze-up-stroke-primary), .12);
}

.last\\:border-r-0:last-child {
  border-right-color: rgba(var(--coze-up-stroke-primary), .12);
}

.empty\\:hidden:empty {
  display: none;
}

.focus-within\\:pointer-events-auto:focus-within {
  pointer-events: auto;
}

.focus-within\\:opacity-100:focus-within {
  opacity: 1;
}

.hover\\:cursor-col-resize:hover {
  cursor: col-resize;
}

.hover\\:cursor-pointer:hover {
  cursor: pointer;
}

.hover\\:cursor-row-resize:hover {
  cursor: row-resize;
}

.hover\\:rounded:hover {
  border-radius: var(--coze-8);
}

.hover\\:rounded-lg:hover {
  border-radius: .5rem;
}

.hover\\:rounded-mini:hover {
  border-radius: var(--coze-4);
}

.hover\\:border-0:hover {
  border-width: 0;
}

.hover\\:border-l-2:hover {
  border-left-width: 2px;
}

.hover\\:border-t-2:hover {
  border-top-width: 2px;
}

.hover\\:border-none:hover {
  border-style: none;
}

.hover\\:border-0:hover {
  border-color: rgba(var(--coze-up-stroke-primary), .12);
}

.hover\\:border-\\[var\\(--coz-stroke-plus\\)\\]:hover {
  border-color: var(--coz-stroke-plus);
}

.hover\\:bg-\\[\\#0607091A\\]:hover {
  background-color: rgba(6, 7, 9, .1);
}

.hover\\:bg-\\[\\#336df4\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(51, 109, 244, var(--tw-bg-opacity));
}

.hover\\:bg-\\[\\#969fff26\\]:hover {
  background-color: rgba(150, 159, 255, .15);
}

.hover\\:bg-\\[rgb\\(var\\(--coze-up-brand-7\\)\\)\\]:hover {
  background-color: rgb(var(--coze-up-brand-7));
}

.hover\\:bg-\\[rgb\\(var\\(--coze-up-brand-9\\)\\)\\]:hover {
  background-color: rgb(var(--coze-up-brand-9));
}

.hover\\:bg-\\[var\\(--coz-mg-hglt-hovered\\)\\]:hover {
  background-color: var(--coz-mg-hglt-hovered);
}

.hover\\:bg-\\[var\\(--coz-mg-plus\\)\\]:hover {
  background-color: var(--coz-mg-plus);
}

.hover\\:bg-\\[var\\(--coz-mg-primary\\)\\]:hover {
  background-color: var(--coz-mg-primary);
}

.hover\\:bg-\\[var\\(--coz-mg-secondary\\)\\]:hover {
  background-color: var(--coz-mg-secondary);
}

.hover\\:bg-\\[var\\(--coz-mg-secondary-hovered\\)\\]:hover {
  background-color: var(--coz-mg-secondary-hovered);
}

.hover\\:bg-\\[var\\(--light-usage-fill-color-fill-0\\,rgba\\(46\\,50\\,56\\,5\\%\\)\\)\\]:hover {
  background-color: var(--light-usage-fill-color-fill-0, rgba(46, 50, 56, .05));
}

.hover\\:bg-background-5:hover {
  background-color: rgba(var(--coze-bg-5), var(--coze-bg-5-alpha));
}

.hover\\:bg-blue-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(96, 165, 250, var(--tw-bg-opacity));
}

.hover\\:bg-brand-3:hover {
  background-color: rgba(var(--coze-up-brand-3), 1);
}

.hover\\:bg-foreground-4:hover {
  background-color: rgba(var(--coze-fg-4), var(--coze-fg-4-alpha));
}

.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
}

.hover\\:bg-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
}

.hover\\:bg-transparent:hover {
  background-color: rgba(0, 0, 0, 0);
}

.hover\\:text-\\[rgb\\(var\\(--coze-up-brand-9\\)\\)\\]:hover {
  color: rgb(var(--coze-up-brand-9));
}

.hover\\:text-\\[rgba\\(var\\(--coze-up-brand-9\\)\\)\\]:hover {
  color: rgba(var(--coze-up-brand-9));
}

.hover\\:text-\\[var\\(--coz-fg-primary\\)\\]:hover {
  color: var(--coz-fg-primary);
}

.hover\\:text-\\[var\\(--light-usage-text-color-text-0\\,\\#1c1f23\\)\\]:hover {
  color: var(--light-usage-text-color-text-0, #1c1f23);
}

.hover\\:text-brand-6:hover {
  color: rgba(var(--coze-up-brand-6), 1);
}

.hover\\:text-foreground-4:hover {
  color: rgba(var(--coze-fg-4), var(--coze-fg-4-alpha));
}

.hover\\:text-gray-900:hover {
  --tw-text-opacity: 1;
  color: rgba(17, 24, 39, var(--tw-text-opacity));
}

.hover\\:underline:hover {
  -webkit-text-decoration-line: underline;
  text-decoration-line: underline;
}

.hover\\:shadow-\\[0_4px_12px_0_rgba\\(0\\,0\\,0\\,0\\.08\\)\\,_0_8px_24px_0_rgba\\(0\\,0\\,0\\,0\\.04\\)\\]:hover {
  --tw-shadow: 0 4px 12px 0 rgba(0, 0, 0, .08), 0 8px 24px 0 rgba(0, 0, 0, .04);
  --tw-shadow-colored: 0 4px 12px 0 var(--tw-shadow-color), 0 8px 24px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}

.hover\\:shadow-\\[0_6px_8px_0_rgba\\(28\\,31\\,35\\,6\\%\\)\\]:hover {
  --tw-shadow: 0 6px 8px 0 rgba(28, 31, 35, .06);
  --tw-shadow-colored: 0 6px 8px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}

.hover\\:outline-\\[\\#4E40E5\\]:hover {
  outline-color: #4e40e5;
}

.hover\\:coz-fg-hglt-plus-dim:hover {
  color: rgba(var(--coze-fg-5), var(--coze-fg-5-alpha));
}

.hover\\:coz-fg-primary:hover {
  color: rgba(var(--coze-fg-3), var(--coze-fg-3-alpha));
}

.hover\\:coz-fg-dim:hover {
  color: rgba(var(--coze-fg-1), var(--coze-fg-1-alpha));
}

.hover\\:coz-fg-hglt-red-dim:hover {
  color: rgba(var(--coze-red-3), var(--coze-red-3-alpha));
}

.hover\\:coz-mg-hglt-plus-red-hovered:hover {
  background-color: rgba(var(--coze-red-6), 1);
}

.hover\\:coz-mg-hglt-plus-yellow-hovered:hover {
  background-color: rgba(var(--coze-yellow-6), 1);
}

.hover\\:coz-mg-hglt-plus-green-hovered:hover {
  background-color: rgba(var(--coze-green-6), 1);
}

.hover\\:coz-mg-hglt-red-hovered:hover {
  background-color: rgba(var(--coze-red-2), var(--coze-red-2-alpha));
}

.hover\\:coz-mg-hglt-red:hover {
  background-color: rgba(var(--coze-red-1), var(--coze-red-1-alpha));
}

.hover\\:coz-mg-hglt-yellow-hovered:hover {
  background-color: rgba(var(--coze-yellow-2), var(--coze-yellow-2-alpha));
}

.hover\\:coz-mg-hglt-yellow:hover {
  background-color: rgba(var(--coze-yellow-1), var(--coze-yellow-1-alpha));
}

.hover\\:coz-mg-hglt-green-hovered:hover {
  background-color: rgba(var(--coze-green-2), var(--coze-green-2-alpha));
}

.hover\\:coz-mg-hglt-green:hover {
  background-color: rgba(var(--coze-green-1), var(--coze-green-1-alpha));
}

.hover\\:coz-mg-color-cyan-hovered:hover {
  background-color: rgba(var(--coze-cyan-20), var(--coze-cyan-20-alpha));
}

.hover\\:coz-mg-color-cyan:hover {
  background-color: rgba(var(--coze-cyan-10), var(--coze-cyan-10-alpha));
}

.hover\\:coz-mg-color-blue-hovered:hover {
  background-color: rgba(var(--coze-blue-20), var(--coze-blue-20-alpha));
}

.hover\\:coz-mg-color-blue:hover {
  background-color: rgba(var(--coze-blue-10), var(--coze-blue-10-alpha));
}

.hover\\:coz-mg-color-purple-hovered:hover {
  background-color: rgba(var(--coze-purple-20), var(--coze-purple-20-alpha));
}

.hover\\:coz-mg-color-purple:hover {
  background-color: rgba(var(--coze-purple-10), var(--coze-purple-10-alpha));
}

.hover\\:coz-mg-color-magenta-hovered:hover {
  background-color: rgba(var(--coze-magenta-20), var(--coze-magenta-20-alpha));
}

.hover\\:coz-mg-color-magenta:hover {
  background-color: rgba(var(--coze-magenta-10), var(--coze-magenta-10-alpha));
}

.hover\\:\\!coz-mg-primary-hovered:hover {
  background-color: rgba(var(--coze-bg-6), var(--coze-bg-6-alpha)) !important;
}

.hover\\:coz-mg-primary-hovered:hover {
  background-color: rgba(var(--coze-bg-6), var(--coze-bg-6-alpha));
}

.hover\\:coz-mg-primary:hover {
  background-color: rgba(var(--coze-bg-5), var(--coze-bg-5-alpha));
}

.hover\\:\\!coz-mg-secondary-hovered:hover {
  background-color: rgba(var(--coze-bg-5), var(--coze-bg-5-alpha)) !important;
}

.hover\\:coz-mg-secondary-hovered:hover {
  background-color: rgba(var(--coze-bg-5), var(--coze-bg-5-alpha));
}

.hover\\:coz-mg-secondary:hover {
  background-color: rgba(var(--coze-bg-4), var(--coze-bg-4-alpha));
}

.hover\\:\\!coz-bg-max:hover {
  background-color: rgba(var(--coze-bg-3), var(--coze-bg-3-alpha)) !important;
}

.hover\\:coz-stroke-plus:hover {
  border-color: rgba(var(--coze-stroke-6), var(--coze-stroke-6-alpha));
}

.hover\\:coz-stroke-hglt-red:hover {
  border-color: rgba(var(--coze-red-5), 1);
}

.hover\\:coz-shadow-default:hover {
  box-shadow: 0 8px 28px 0px rgba(var(--coze-up-brand-12), .08);
}

.hover\\:\\!coz-fg-hglt:hover {
  color: rgba(var(--coze-up-brand-9), 1) !important;
}

.hover\\:coz-fg-hglt:hover {
  color: rgba(var(--coze-up-brand-9), 1);
}

.hover\\:coz-fg-hglt-dim:hover {
  color: rgba(var(--coze-up-brand-5), 1);
}

.hover\\:coz-stroke-hglt:hover {
  border-color: rgba(var(--coze-up-brand-9), 1);
}

.hover\\:coz-mg-hglt-secondary-hovered:hover {
  background-color: rgba(var(--coze-up-brand-3), 1);
}

.hover\\:coz-mg-hglt-plus-hovered:hover {
  background-color: rgba(var(--coze-up-brand-10), 1);
}

.hover\\:coz-mg-hglt-plus-dim:hover {
  background-color: rgba(var(--coze-up-brand-5), 1);
}

.hover\\:\\!coz-mg-hglt-hovered:hover {
  background-color: rgba(var(--coze-up-brand-4), 1) !important;
}

.hover\\:coz-mg-hglt-hovered:hover {
  background-color: rgba(var(--coze-up-brand-4), 1);
}

.hover\\:coz-mg-hglt:hover {
  background-color: rgba(var(--coze-up-brand-3), 1);
}

.hover\\:after\\:hidden:hover:after {
  content: var(--tw-content);
  display: none;
}

.focus\\:border-0:focus {
  border-width: 0;
  border-color: rgba(var(--coze-up-stroke-primary), .12);
}

.focus\\:outline-none:focus {
  outline-offset: 2px;
  outline: 2px solid rgba(0, 0, 0, 0);
}

.focus-visible\\:z-10:focus-visible {
  z-index: 10;
}

.focus-visible\\:outline:focus-visible {
  outline-style: solid;
}

.focus-visible\\:outline-2:focus-visible {
  outline-width: 2px;
}

.focus-visible\\:outline-offset-2:focus-visible {
  outline-offset: 2px;
}

.focus-visible\\:outline-current:focus-visible {
  outline-color: currentColor;
}

.focus-visible\\:ring-2:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0, 0, 0, 0));
}

.focus-visible\\:ring-white:focus-visible {
  --tw-ring-color: rgb(var(--white-1));
}

.active\\:border-transparent:active {
  border-color: rgba(0, 0, 0, 0);
}

.active\\:bg-\\[var\\(--coz-mg-secondary-pressed\\)\\]:active {
  background-color: var(--coz-mg-secondary-pressed);
}

.active\\:bg-background-6:active {
  background-color: rgba(var(--coze-bg-6), var(--coze-bg-6-alpha));
}

.active\\:bg-foreground-5:active {
  background-color: rgba(var(--coze-fg-5), var(--coze-fg-5-alpha));
}

.active\\:bg-transparent:active {
  background-color: rgba(0, 0, 0, 0);
}

.active\\:text-brand-6:active {
  color: rgba(var(--coze-up-brand-6), 1);
}

.active\\:text-foreground-4:active {
  color: rgba(var(--coze-fg-4), var(--coze-fg-4-alpha));
}

.active\\:no-underline:active {
  -webkit-text-decoration-line: none;
  text-decoration-line: none;
}

.active\\:coz-fg-hglt-plus-dim:active {
  color: rgba(var(--coze-fg-5), var(--coze-fg-5-alpha));
}

.active\\:coz-fg-dim:active {
  color: rgba(var(--coze-fg-1), var(--coze-fg-1-alpha));
}

.active\\:coz-mg-hglt-plus-red-pressed:active {
  background-color: rgba(var(--coze-red-7), 1);
}

.active\\:coz-mg-hglt-plus-yellow-pressed:active {
  background-color: rgba(var(--coze-yellow-7), 1);
}

.active\\:coz-mg-hglt-plus-green-pressed:active {
  background-color: rgba(var(--coze-green-7), 1);
}

.active\\:coz-mg-hglt-red-pressed:active {
  background-color: rgba(var(--coze-red-3), var(--coze-red-3-alpha));
}

.active\\:coz-mg-hglt-red:active {
  background-color: rgba(var(--coze-red-1), var(--coze-red-1-alpha));
}

.active\\:coz-mg-hglt-yellow-pressed:active {
  background-color: rgba(var(--coze-yellow-3), var(--coze-yellow-3-alpha));
}

.active\\:coz-mg-hglt-yellow:active {
  background-color: rgba(var(--coze-yellow-1), var(--coze-yellow-1-alpha));
}

.active\\:coz-mg-hglt-green-pressed:active {
  background-color: rgba(var(--coze-green-3), var(--coze-green-3-alpha));
}

.active\\:coz-mg-hglt-green:active {
  background-color: rgba(var(--coze-green-1), var(--coze-green-1-alpha));
}

.active\\:coz-mg-color-cyan-pressed:active {
  background-color: rgba(var(--coze-cyan-30), var(--coze-cyan-30-alpha));
}

.active\\:coz-mg-color-cyan:active {
  background-color: rgba(var(--coze-cyan-10), var(--coze-cyan-10-alpha));
}

.active\\:coz-mg-color-blue-pressed:active {
  background-color: rgba(var(--coze-blue-30), var(--coze-blue-30-alpha));
}

.active\\:coz-mg-color-blue:active {
  background-color: rgba(var(--coze-blue-10), var(--coze-blue-10-alpha));
}

.active\\:coz-mg-color-purple-pressed:active {
  background-color: rgba(var(--coze-purple-30), var(--coze-purple-30-alpha));
}

.active\\:coz-mg-color-purple:active {
  background-color: rgba(var(--coze-purple-10), var(--coze-purple-10-alpha));
}

.active\\:coz-mg-color-magenta-pressed:active {
  background-color: rgba(var(--coze-magenta-30), var(--coze-magenta-30-alpha));
}

.active\\:coz-mg-color-magenta:active {
  background-color: rgba(var(--coze-magenta-10), var(--coze-magenta-10-alpha));
}

.active\\:coz-mg-primary-pressed:active {
  background-color: rgba(var(--coze-bg-7), var(--coze-bg-7-alpha));
}

.active\\:coz-mg-primary:active {
  background-color: rgba(var(--coze-bg-5), var(--coze-bg-5-alpha));
}

.active\\:\\!coz-mg-secondary-pressed:active {
  background-color: rgba(var(--coze-bg-6), var(--coze-bg-6-alpha)) !important;
}

.active\\:coz-mg-secondary-pressed:active {
  background-color: rgba(var(--coze-bg-6), var(--coze-bg-6-alpha));
}

.active\\:coz-stroke-hglt-red:active {
  border-color: rgba(var(--coze-red-5), 1);
}

.active\\:coz-stroke-hglt:active {
  border-color: rgba(var(--coze-up-brand-9), 1);
}

.active\\:coz-mg-hglt-plus-pressed:active {
  background-color: rgba(var(--coze-up-brand-11), 1);
}

.active\\:coz-mg-hglt-plus-dim:active {
  background-color: rgba(var(--coze-up-brand-5), 1);
}

.active\\:\\!coz-mg-hglt-pressed:active {
  background-color: rgba(var(--coze-up-brand-5), 1) !important;
}

.active\\:coz-mg-hglt-pressed:active {
  background-color: rgba(var(--coze-up-brand-5), 1);
}

.active\\:coz-mg-hglt:active {
  background-color: rgba(var(--coze-up-brand-3), 1);
}

.disabled\\:bg-transparent:disabled {
  background-color: rgba(0, 0, 0, 0);
}

.disabled\\:text-\\[rgb\\(28\\,31\\,35\\,0\\.35\\)\\]:disabled {
  color: rgba(28, 31, 35, .35);
}

.disabled\\:coz-fg-hglt-plus-dim:disabled {
  color: rgba(var(--coze-fg-5), var(--coze-fg-5-alpha));
}

.disabled\\:coz-fg-dim:disabled {
  color: rgba(var(--coze-fg-1), var(--coze-fg-1-alpha));
}

.disabled\\:coz-fg-white-dim:disabled {
  color: rgba(var(--coze-fg-white), var(--coze-fg-white-alpha));
}

.disabled\\:coz-fg-hglt-red-dim:disabled {
  color: rgba(var(--coze-red-3), var(--coze-red-3-alpha));
}

.disabled\\:coz-mg-hglt-plus-red-dim:disabled {
  background-color: rgba(var(--coze-red-3), var(--coze-red-3-alpha));
}

.disabled\\:coz-mg-hglt-plus-yellow-dim:disabled {
  background-color: rgba(var(--coze-yellow-3), var(--coze-yellow-3-alpha));
}

.disabled\\:coz-mg-hglt-plus-green-dim:disabled {
  background-color: rgba(var(--coze-green-3), var(--coze-green-3-alpha));
}

.disabled\\:coz-mg-hglt-red:disabled {
  background-color: rgba(var(--coze-red-1), var(--coze-red-1-alpha));
}

.disabled\\:coz-mg-primary:disabled {
  background-color: rgba(var(--coze-bg-5), var(--coze-bg-5-alpha));
}

.disabled\\:coz-bg-max:disabled {
  background-color: rgba(var(--coze-bg-3), var(--coze-bg-3-alpha));
}

.disabled\\:coz-fg-hglt-dim:disabled {
  color: rgba(var(--coze-up-brand-5), 1);
}

.disabled\\:coz-mg-hglt-plus-dim:disabled {
  background-color: rgba(var(--coze-up-brand-5), 1);
}

.disabled\\:coz-mg-hglt:disabled {
  background-color: rgba(var(--coze-up-brand-3), 1);
}

.group:hover .group-hover\\:pointer-events-auto {
  pointer-events: auto;
}

.group:hover .group-hover\\:visible {
  visibility: visible;
}

.group:hover .group-hover\\:block {
  display: block;
}

.group:hover .group-hover\\:\\!flex {
  display: flex !important;
}

.group:hover .group-hover\\:flex {
  display: flex;
}

.group:hover .group-hover\\:\\!inline-flex {
  display: inline-flex !important;
}

.group:hover .group-hover\\:bg-\\[\\#336df4\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(51, 109, 244, var(--tw-bg-opacity));
}

.group:hover .group-hover\\:bg-\\[rgb\\(var\\(--coze-up-brand-7\\)\\)\\] {
  background-color: rgb(var(--coze-up-brand-7));
}

.group:hover .group-hover\\:bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
}

.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}

.data-\\[focus-visible\\=true\\]\\:z-10[data-focus-visible="true"] {
  z-index: 10;
}

.data-\\[focus-visible\\=true\\]\\:outline-2[data-focus-visible="true"] {
  outline-width: 2px;
}

.data-\\[focus-visible\\=true\\]\\:outline-offset-2[data-focus-visible="true"] {
  outline-offset: 2px;
}

.group[data-focus-visible="true"] .group-data-\\[focus-visible\\=true\\]\\:z-10 {
  z-index: 10;
}

.group[data-focus-visible="true"] .group-data-\\[focus-visible\\=true\\]\\:ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0, 0, 0, 0));
}

.group[data-focus-visible="true"] .group-data-\\[focus-visible\\=true\\]\\:ring-offset-2 {
  --tw-ring-offset-width: 2px;
}

.group[data-focus-visible="true"] .group-data-\\[focus-visible\\=true\\]\\:ring-offset-background {
  --tw-ring-offset-color: rgba(var(--background), 1);
}

@media (min-width: 640px) {
  .sm\\:grid-flow-row {
    grid-auto-flow: row;
  }

  .sm\\:grid-flow-col {
    grid-auto-flow: column;
  }

  .sm\\:grid-flow-dense {
    grid-auto-flow: dense;
  }

  .sm\\:grid-flow-row-dense {
    grid-auto-flow: row dense;
  }

  .sm\\:grid-flow-col-dense {
    grid-auto-flow: column dense;
  }

  .sm\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .sm\\:grid-cols-10 {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }

  .sm\\:grid-cols-11 {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }

  .sm\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sm\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .sm\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .sm\\:grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .sm\\:grid-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }

  .sm\\:grid-cols-9 {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }

  .sm\\:grid-cols-none {
    grid-template-columns: none;
  }

  .sm\\:grid-rows-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }

  .sm\\:grid-rows-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-rows-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-rows-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }

  .sm\\:grid-rows-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }

  .sm\\:grid-rows-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }

  .sm\\:grid-rows-none {
    grid-template-rows: none;
  }

  .sm\\:flex-col {
    flex-direction: column;
  }

  .sm\\:flex-col-reverse {
    flex-direction: column-reverse;
  }

  .sm\\:gap-0 {
    gap: 0;
  }

  .sm\\:gap-0\\.5 {
    gap: .125rem;
  }

  .sm\\:gap-1 {
    gap: .25rem;
  }

  .sm\\:gap-1\\.5 {
    gap: .375rem;
  }

  .sm\\:gap-10 {
    gap: 2.5rem;
  }

  .sm\\:gap-1080px {
    gap: var(--coze-1080);
  }

  .sm\\:gap-10px {
    gap: var(--coze-10);
  }

  .sm\\:gap-11 {
    gap: 2.75rem;
  }

  .sm\\:gap-12 {
    gap: 3rem;
  }

  .sm\\:gap-120px {
    gap: var(--coze-120);
  }

  .sm\\:gap-12px {
    gap: var(--coze-12);
  }

  .sm\\:gap-14 {
    gap: 3.5rem;
  }

  .sm\\:gap-14px {
    gap: var(--coze-14);
  }

  .sm\\:gap-15px {
    gap: var(--coze-15);
  }

  .sm\\:gap-16 {
    gap: 4rem;
  }

  .sm\\:gap-160px {
    gap: var(--coze-160);
  }

  .sm\\:gap-16px {
    gap: var(--coze-16);
  }

  .sm\\:gap-18px {
    gap: var(--coze-18);
  }

  .sm\\:gap-1px {
    gap: var(--coze-1);
  }

  .sm\\:gap-2 {
    gap: .5rem;
  }

  .sm\\:gap-2\\.5 {
    gap: .625rem;
  }

  .sm\\:gap-20 {
    gap: 5rem;
  }

  .sm\\:gap-200px {
    gap: var(--coze-200);
  }

  .sm\\:gap-20px {
    gap: var(--coze-20);
  }

  .sm\\:gap-22px {
    gap: var(--coze-22);
  }

  .sm\\:gap-24 {
    gap: 6rem;
  }

  .sm\\:gap-240px {
    gap: var(--coze-240);
  }

  .sm\\:gap-24px {
    gap: var(--coze-24);
  }

  .sm\\:gap-26px {
    gap: var(--coze-26);
  }

  .sm\\:gap-28 {
    gap: 7rem;
  }

  .sm\\:gap-28px {
    gap: var(--coze-28);
  }

  .sm\\:gap-2px {
    gap: var(--coze-2);
  }

  .sm\\:gap-3 {
    gap: .75rem;
  }

  .sm\\:gap-3\\.5 {
    gap: .875rem;
  }

  .sm\\:gap-30px {
    gap: var(--coze-30);
  }

  .sm\\:gap-32 {
    gap: 8rem;
  }

  .sm\\:gap-320px {
    gap: var(--coze-320);
  }

  .sm\\:gap-32px {
    gap: var(--coze-32);
  }

  .sm\\:gap-36 {
    gap: 9rem;
  }

  .sm\\:gap-3px {
    gap: var(--coze-3);
  }

  .sm\\:gap-4 {
    gap: 1rem;
  }

  .sm\\:gap-40 {
    gap: 10rem;
  }

  .sm\\:gap-40px {
    gap: var(--coze-40);
  }

  .sm\\:gap-44 {
    gap: 11rem;
  }

  .sm\\:gap-48 {
    gap: 12rem;
  }

  .sm\\:gap-480px {
    gap: var(--coze-480);
  }

  .sm\\:gap-48px {
    gap: var(--coze-48);
  }

  .sm\\:gap-4px {
    gap: var(--coze-4);
  }

  .sm\\:gap-5 {
    gap: 1.25rem;
  }

  .sm\\:gap-52 {
    gap: 13rem;
  }

  .sm\\:gap-56 {
    gap: 14rem;
  }

  .sm\\:gap-5px {
    gap: var(--coze-5);
  }

  .sm\\:gap-6 {
    gap: 1.5rem;
  }

  .sm\\:gap-60 {
    gap: 15rem;
  }

  .sm\\:gap-64 {
    gap: 16rem;
  }

  .sm\\:gap-640px {
    gap: var(--coze-640);
  }

  .sm\\:gap-64px {
    gap: var(--coze-64);
  }

  .sm\\:gap-6px {
    gap: var(--coze-6);
  }

  .sm\\:gap-7 {
    gap: 1.75rem;
  }

  .sm\\:gap-72 {
    gap: 18rem;
  }

  .sm\\:gap-8 {
    gap: 2rem;
  }

  .sm\\:gap-80 {
    gap: 20rem;
  }

  .sm\\:gap-800px {
    gap: var(--coze-800);
  }

  .sm\\:gap-80px {
    gap: var(--coze-80);
  }

  .sm\\:gap-8px {
    gap: var(--coze-8);
  }

  .sm\\:gap-9 {
    gap: 2.25rem;
  }

  .sm\\:gap-96 {
    gap: 24rem;
  }

  .sm\\:gap-96px {
    gap: var(--coze-96);
  }

  .sm\\:gap-9px {
    gap: var(--coze-9);
  }

  .sm\\:gap-base {
    gap: 16px;
  }

  .sm\\:gap-base-loose {
    gap: 20px;
  }

  .sm\\:gap-base-tight {
    gap: 12px;
  }

  .sm\\:gap-extra-loose {
    gap: 32px;
  }

  .sm\\:gap-extra-tight {
    gap: 4px;
  }

  .sm\\:gap-large {
    gap: var(--coze-40);
  }

  .sm\\:gap-loose {
    gap: 24px;
  }

  .sm\\:gap-md {
    gap: var(--coze-64);
  }

  .sm\\:gap-mini {
    gap: var(--coze-16);
  }

  .sm\\:gap-mm {
    gap: var(--coze-48);
  }

  .sm\\:gap-none {
    gap: 0;
  }

  .sm\\:gap-normal {
    gap: var(--coze-32);
  }

  .sm\\:gap-px {
    gap: 1px;
  }

  .sm\\:gap-small {
    gap: var(--coze-20);
  }

  .sm\\:gap-super-loose {
    gap: 40px;
  }

  .sm\\:gap-super-tight {
    gap: 2px;
  }

  .sm\\:gap-tight {
    gap: 8px;
  }

  .sm\\:gap-xl {
    gap: var(--coze-80);
  }

  .sm\\:gap-xxl {
    gap: var(--coze-96);
  }

  .sm\\:gap-x {
    -moz-column-gap: var(--coze-8);
    column-gap: var(--coze-8);
  }

  .sm\\:gap-x-0 {
    -moz-column-gap: 0px;
    column-gap: 0;
  }

  .sm\\:gap-x-0\\.5 {
    -moz-column-gap: .125rem;
    column-gap: .125rem;
  }

  .sm\\:gap-x-1 {
    -moz-column-gap: .25rem;
    column-gap: .25rem;
  }

  .sm\\:gap-x-1\\.5 {
    -moz-column-gap: .375rem;
    column-gap: .375rem;
  }

  .sm\\:gap-x-10 {
    -moz-column-gap: 2.5rem;
    column-gap: 2.5rem;
  }

  .sm\\:gap-x-1080px {
    -moz-column-gap: var(--coze-1080);
    column-gap: var(--coze-1080);
  }

  .sm\\:gap-x-10px {
    -moz-column-gap: var(--coze-10);
    column-gap: var(--coze-10);
  }

  .sm\\:gap-x-11 {
    -moz-column-gap: 2.75rem;
    column-gap: 2.75rem;
  }

  .sm\\:gap-x-12 {
    -moz-column-gap: 3rem;
    column-gap: 3rem;
  }

  .sm\\:gap-x-120px {
    -moz-column-gap: var(--coze-120);
    column-gap: var(--coze-120);
  }

  .sm\\:gap-x-12px {
    -moz-column-gap: var(--coze-12);
    column-gap: var(--coze-12);
  }

  .sm\\:gap-x-14 {
    -moz-column-gap: 3.5rem;
    column-gap: 3.5rem;
  }

  .sm\\:gap-x-14px {
    -moz-column-gap: var(--coze-14);
    column-gap: var(--coze-14);
  }

  .sm\\:gap-x-15px {
    -moz-column-gap: var(--coze-15);
    column-gap: var(--coze-15);
  }

  .sm\\:gap-x-16 {
    -moz-column-gap: 4rem;
    column-gap: 4rem;
  }

  .sm\\:gap-x-160px {
    -moz-column-gap: var(--coze-160);
    column-gap: var(--coze-160);
  }

  .sm\\:gap-x-16px {
    -moz-column-gap: var(--coze-16);
    column-gap: var(--coze-16);
  }

  .sm\\:gap-x-18px {
    -moz-column-gap: var(--coze-18);
    column-gap: var(--coze-18);
  }

  .sm\\:gap-x-1px {
    -moz-column-gap: var(--coze-1);
    column-gap: var(--coze-1);
  }

  .sm\\:gap-x-2 {
    -moz-column-gap: .5rem;
    column-gap: .5rem;
  }

  .sm\\:gap-x-2\\.5 {
    -moz-column-gap: .625rem;
    column-gap: .625rem;
  }

  .sm\\:gap-x-20 {
    -moz-column-gap: 5rem;
    column-gap: 5rem;
  }

  .sm\\:gap-x-200px {
    -moz-column-gap: var(--coze-200);
    column-gap: var(--coze-200);
  }

  .sm\\:gap-x-20px {
    -moz-column-gap: var(--coze-20);
    column-gap: var(--coze-20);
  }

  .sm\\:gap-x-22px {
    -moz-column-gap: var(--coze-22);
    column-gap: var(--coze-22);
  }

  .sm\\:gap-x-24 {
    -moz-column-gap: 6rem;
    column-gap: 6rem;
  }

  .sm\\:gap-x-240px {
    -moz-column-gap: var(--coze-240);
    column-gap: var(--coze-240);
  }

  .sm\\:gap-x-24px {
    -moz-column-gap: var(--coze-24);
    column-gap: var(--coze-24);
  }

  .sm\\:gap-x-26px {
    -moz-column-gap: var(--coze-26);
    column-gap: var(--coze-26);
  }

  .sm\\:gap-x-28 {
    -moz-column-gap: 7rem;
    column-gap: 7rem;
  }

  .sm\\:gap-x-28px {
    -moz-column-gap: var(--coze-28);
    column-gap: var(--coze-28);
  }

  .sm\\:gap-x-2px {
    -moz-column-gap: var(--coze-2);
    column-gap: var(--coze-2);
  }

  .sm\\:gap-x-3 {
    -moz-column-gap: .75rem;
    column-gap: .75rem;
  }

  .sm\\:gap-x-3\\.5 {
    -moz-column-gap: .875rem;
    column-gap: .875rem;
  }

  .sm\\:gap-x-30px {
    -moz-column-gap: var(--coze-30);
    column-gap: var(--coze-30);
  }

  .sm\\:gap-x-32 {
    -moz-column-gap: 8rem;
    column-gap: 8rem;
  }

  .sm\\:gap-x-320px {
    -moz-column-gap: var(--coze-320);
    column-gap: var(--coze-320);
  }

  .sm\\:gap-x-32px {
    -moz-column-gap: var(--coze-32);
    column-gap: var(--coze-32);
  }

  .sm\\:gap-x-36 {
    -moz-column-gap: 9rem;
    column-gap: 9rem;
  }

  .sm\\:gap-x-3px {
    -moz-column-gap: var(--coze-3);
    column-gap: var(--coze-3);
  }

  .sm\\:gap-x-4 {
    -moz-column-gap: 1rem;
    column-gap: 1rem;
  }

  .sm\\:gap-x-40 {
    -moz-column-gap: 10rem;
    column-gap: 10rem;
  }

  .sm\\:gap-x-40px {
    -moz-column-gap: var(--coze-40);
    column-gap: var(--coze-40);
  }

  .sm\\:gap-x-44 {
    -moz-column-gap: 11rem;
    column-gap: 11rem;
  }

  .sm\\:gap-x-48 {
    -moz-column-gap: 12rem;
    column-gap: 12rem;
  }

  .sm\\:gap-x-480px {
    -moz-column-gap: var(--coze-480);
    column-gap: var(--coze-480);
  }

  .sm\\:gap-x-48px {
    -moz-column-gap: var(--coze-48);
    column-gap: var(--coze-48);
  }

  .sm\\:gap-x-4px {
    -moz-column-gap: var(--coze-4);
    column-gap: var(--coze-4);
  }

  .sm\\:gap-x-5 {
    -moz-column-gap: 1.25rem;
    column-gap: 1.25rem;
  }

  .sm\\:gap-x-52 {
    -moz-column-gap: 13rem;
    column-gap: 13rem;
  }

  .sm\\:gap-x-56 {
    -moz-column-gap: 14rem;
    column-gap: 14rem;
  }

  .sm\\:gap-x-5px {
    -moz-column-gap: var(--coze-5);
    column-gap: var(--coze-5);
  }

  .sm\\:gap-x-6 {
    -moz-column-gap: 1.5rem;
    column-gap: 1.5rem;
  }

  .sm\\:gap-x-60 {
    -moz-column-gap: 15rem;
    column-gap: 15rem;
  }

  .sm\\:gap-x-64 {
    -moz-column-gap: 16rem;
    column-gap: 16rem;
  }

  .sm\\:gap-x-640px {
    -moz-column-gap: var(--coze-640);
    column-gap: var(--coze-640);
  }

  .sm\\:gap-x-64px {
    -moz-column-gap: var(--coze-64);
    column-gap: var(--coze-64);
  }

  .sm\\:gap-x-6px {
    -moz-column-gap: var(--coze-6);
    column-gap: var(--coze-6);
  }

  .sm\\:gap-x-7 {
    -moz-column-gap: 1.75rem;
    column-gap: 1.75rem;
  }

  .sm\\:gap-x-72 {
    -moz-column-gap: 18rem;
    column-gap: 18rem;
  }

  .sm\\:gap-x-8 {
    -moz-column-gap: 2rem;
    column-gap: 2rem;
  }

  .sm\\:gap-x-80 {
    -moz-column-gap: 20rem;
    column-gap: 20rem;
  }

  .sm\\:gap-x-800px {
    -moz-column-gap: var(--coze-800);
    column-gap: var(--coze-800);
  }

  .sm\\:gap-x-80px {
    -moz-column-gap: var(--coze-80);
    column-gap: var(--coze-80);
  }

  .sm\\:gap-x-8px {
    -moz-column-gap: var(--coze-8);
    column-gap: var(--coze-8);
  }

  .sm\\:gap-x-9 {
    -moz-column-gap: 2.25rem;
    column-gap: 2.25rem;
  }

  .sm\\:gap-x-96 {
    -moz-column-gap: 24rem;
    column-gap: 24rem;
  }

  .sm\\:gap-x-96px {
    -moz-column-gap: var(--coze-96);
    column-gap: var(--coze-96);
  }

  .sm\\:gap-x-9px {
    -moz-column-gap: var(--coze-9);
    column-gap: var(--coze-9);
  }

  .sm\\:gap-x-base {
    -moz-column-gap: 16px;
    column-gap: 16px;
  }

  .sm\\:gap-x-base-loose {
    -moz-column-gap: 20px;
    column-gap: 20px;
  }

  .sm\\:gap-x-base-tight {
    -moz-column-gap: 12px;
    column-gap: 12px;
  }

  .sm\\:gap-x-extra-loose {
    -moz-column-gap: 32px;
    column-gap: 32px;
  }

  .sm\\:gap-x-extra-tight {
    -moz-column-gap: 4px;
    column-gap: 4px;
  }

  .sm\\:gap-x-large {
    -moz-column-gap: var(--coze-40);
    column-gap: var(--coze-40);
  }

  .sm\\:gap-x-loose {
    -moz-column-gap: 24px;
    column-gap: 24px;
  }

  .sm\\:gap-x-md {
    -moz-column-gap: var(--coze-64);
    column-gap: var(--coze-64);
  }

  .sm\\:gap-x-mini {
    -moz-column-gap: var(--coze-16);
    column-gap: var(--coze-16);
  }

  .sm\\:gap-x-mm {
    -moz-column-gap: var(--coze-48);
    column-gap: var(--coze-48);
  }

  .sm\\:gap-x-none {
    -moz-column-gap: 0;
    column-gap: 0;
  }

  .sm\\:gap-x-normal {
    -moz-column-gap: var(--coze-32);
    column-gap: var(--coze-32);
  }

  .sm\\:gap-x-px {
    -moz-column-gap: 1px;
    column-gap: 1px;
  }

  .sm\\:gap-x-small {
    -moz-column-gap: var(--coze-20);
    column-gap: var(--coze-20);
  }

  .sm\\:gap-x-super-loose {
    -moz-column-gap: 40px;
    column-gap: 40px;
  }

  .sm\\:gap-x-super-tight {
    -moz-column-gap: 2px;
    column-gap: 2px;
  }

  .sm\\:gap-x-tight {
    -moz-column-gap: 8px;
    column-gap: 8px;
  }

  .sm\\:gap-x-xl {
    -moz-column-gap: var(--coze-80);
    column-gap: var(--coze-80);
  }

  .sm\\:gap-x-xxl {
    -moz-column-gap: var(--coze-96);
    column-gap: var(--coze-96);
  }

  .sm\\:gap-y {
    row-gap: var(--coze-8);
  }

  .sm\\:gap-y-0 {
    row-gap: 0;
  }

  .sm\\:gap-y-0\\.5 {
    row-gap: .125rem;
  }

  .sm\\:gap-y-1 {
    row-gap: .25rem;
  }

  .sm\\:gap-y-1\\.5 {
    row-gap: .375rem;
  }

  .sm\\:gap-y-10 {
    row-gap: 2.5rem;
  }

  .sm\\:gap-y-1080px {
    row-gap: var(--coze-1080);
  }

  .sm\\:gap-y-10px {
    row-gap: var(--coze-10);
  }

  .sm\\:gap-y-11 {
    row-gap: 2.75rem;
  }

  .sm\\:gap-y-12 {
    row-gap: 3rem;
  }

  .sm\\:gap-y-120px {
    row-gap: var(--coze-120);
  }

  .sm\\:gap-y-12px {
    row-gap: var(--coze-12);
  }

  .sm\\:gap-y-14 {
    row-gap: 3.5rem;
  }

  .sm\\:gap-y-14px {
    row-gap: var(--coze-14);
  }

  .sm\\:gap-y-15px {
    row-gap: var(--coze-15);
  }

  .sm\\:gap-y-16 {
    row-gap: 4rem;
  }

  .sm\\:gap-y-160px {
    row-gap: var(--coze-160);
  }

  .sm\\:gap-y-16px {
    row-gap: var(--coze-16);
  }

  .sm\\:gap-y-18px {
    row-gap: var(--coze-18);
  }

  .sm\\:gap-y-1px {
    row-gap: var(--coze-1);
  }

  .sm\\:gap-y-2 {
    row-gap: .5rem;
  }

  .sm\\:gap-y-2\\.5 {
    row-gap: .625rem;
  }

  .sm\\:gap-y-20 {
    row-gap: 5rem;
  }

  .sm\\:gap-y-200px {
    row-gap: var(--coze-200);
  }

  .sm\\:gap-y-20px {
    row-gap: var(--coze-20);
  }

  .sm\\:gap-y-22px {
    row-gap: var(--coze-22);
  }

  .sm\\:gap-y-24 {
    row-gap: 6rem;
  }

  .sm\\:gap-y-240px {
    row-gap: var(--coze-240);
  }

  .sm\\:gap-y-24px {
    row-gap: var(--coze-24);
  }

  .sm\\:gap-y-26px {
    row-gap: var(--coze-26);
  }

  .sm\\:gap-y-28 {
    row-gap: 7rem;
  }

  .sm\\:gap-y-28px {
    row-gap: var(--coze-28);
  }

  .sm\\:gap-y-2px {
    row-gap: var(--coze-2);
  }

  .sm\\:gap-y-3 {
    row-gap: .75rem;
  }

  .sm\\:gap-y-3\\.5 {
    row-gap: .875rem;
  }

  .sm\\:gap-y-30px {
    row-gap: var(--coze-30);
  }

  .sm\\:gap-y-32 {
    row-gap: 8rem;
  }

  .sm\\:gap-y-320px {
    row-gap: var(--coze-320);
  }

  .sm\\:gap-y-32px {
    row-gap: var(--coze-32);
  }

  .sm\\:gap-y-36 {
    row-gap: 9rem;
  }

  .sm\\:gap-y-3px {
    row-gap: var(--coze-3);
  }

  .sm\\:gap-y-4 {
    row-gap: 1rem;
  }

  .sm\\:gap-y-40 {
    row-gap: 10rem;
  }

  .sm\\:gap-y-40px {
    row-gap: var(--coze-40);
  }

  .sm\\:gap-y-44 {
    row-gap: 11rem;
  }

  .sm\\:gap-y-48 {
    row-gap: 12rem;
  }

  .sm\\:gap-y-480px {
    row-gap: var(--coze-480);
  }

  .sm\\:gap-y-48px {
    row-gap: var(--coze-48);
  }

  .sm\\:gap-y-4px {
    row-gap: var(--coze-4);
  }

  .sm\\:gap-y-5 {
    row-gap: 1.25rem;
  }

  .sm\\:gap-y-52 {
    row-gap: 13rem;
  }

  .sm\\:gap-y-56 {
    row-gap: 14rem;
  }

  .sm\\:gap-y-5px {
    row-gap: var(--coze-5);
  }

  .sm\\:gap-y-6 {
    row-gap: 1.5rem;
  }

  .sm\\:gap-y-60 {
    row-gap: 15rem;
  }

  .sm\\:gap-y-64 {
    row-gap: 16rem;
  }

  .sm\\:gap-y-640px {
    row-gap: var(--coze-640);
  }

  .sm\\:gap-y-64px {
    row-gap: var(--coze-64);
  }

  .sm\\:gap-y-6px {
    row-gap: var(--coze-6);
  }

  .sm\\:gap-y-7 {
    row-gap: 1.75rem;
  }

  .sm\\:gap-y-72 {
    row-gap: 18rem;
  }

  .sm\\:gap-y-8 {
    row-gap: 2rem;
  }

  .sm\\:gap-y-80 {
    row-gap: 20rem;
  }

  .sm\\:gap-y-800px {
    row-gap: var(--coze-800);
  }

  .sm\\:gap-y-80px {
    row-gap: var(--coze-80);
  }

  .sm\\:gap-y-8px {
    row-gap: var(--coze-8);
  }

  .sm\\:gap-y-9 {
    row-gap: 2.25rem;
  }

  .sm\\:gap-y-96 {
    row-gap: 24rem;
  }

  .sm\\:gap-y-96px {
    row-gap: var(--coze-96);
  }

  .sm\\:gap-y-9px {
    row-gap: var(--coze-9);
  }

  .sm\\:gap-y-base {
    row-gap: 16px;
  }

  .sm\\:gap-y-base-loose {
    row-gap: 20px;
  }

  .sm\\:gap-y-base-tight {
    row-gap: 12px;
  }

  .sm\\:gap-y-extra-loose {
    row-gap: 32px;
  }

  .sm\\:gap-y-extra-tight {
    row-gap: 4px;
  }

  .sm\\:gap-y-large {
    row-gap: var(--coze-40);
  }

  .sm\\:gap-y-loose {
    row-gap: 24px;
  }

  .sm\\:gap-y-md {
    row-gap: var(--coze-64);
  }

  .sm\\:gap-y-mini {
    row-gap: var(--coze-16);
  }

  .sm\\:gap-y-mm {
    row-gap: var(--coze-48);
  }

  .sm\\:gap-y-none {
    row-gap: 0;
  }

  .sm\\:gap-y-normal {
    row-gap: var(--coze-32);
  }

  .sm\\:gap-y-px {
    row-gap: 1px;
  }

  .sm\\:gap-y-small {
    row-gap: var(--coze-20);
  }

  .sm\\:gap-y-super-loose {
    row-gap: 40px;
  }

  .sm\\:gap-y-super-tight {
    row-gap: 2px;
  }

  .sm\\:gap-y-tight {
    row-gap: 8px;
  }

  .sm\\:gap-y-xl {
    row-gap: var(--coze-80);
  }

  .sm\\:gap-y-xxl {
    row-gap: var(--coze-96);
  }
}

@media (min-width: 768px) {
  .md\\:grid-flow-row {
    grid-auto-flow: row;
  }

  .md\\:grid-flow-col {
    grid-auto-flow: column;
  }

  .md\\:grid-flow-dense {
    grid-auto-flow: dense;
  }

  .md\\:grid-flow-row-dense {
    grid-auto-flow: row dense;
  }

  .md\\:grid-flow-col-dense {
    grid-auto-flow: column dense;
  }

  .md\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .md\\:grid-cols-10 {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }

  .md\\:grid-cols-11 {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }

  .md\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .md\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .md\\:grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .md\\:grid-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }

  .md\\:grid-cols-9 {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }

  .md\\:grid-cols-none {
    grid-template-columns: none;
  }

  .md\\:grid-rows-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }

  .md\\:grid-rows-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-rows-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-rows-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-rows-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }

  .md\\:grid-rows-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }

  .md\\:grid-rows-none {
    grid-template-rows: none;
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:flex-row-reverse {
    flex-direction: row-reverse;
  }

  .md\\:gap-0 {
    gap: 0;
  }

  .md\\:gap-0\\.5 {
    gap: .125rem;
  }

  .md\\:gap-1 {
    gap: .25rem;
  }

  .md\\:gap-1\\.5 {
    gap: .375rem;
  }

  .md\\:gap-10 {
    gap: 2.5rem;
  }

  .md\\:gap-1080px {
    gap: var(--coze-1080);
  }

  .md\\:gap-10px {
    gap: var(--coze-10);
  }

  .md\\:gap-11 {
    gap: 2.75rem;
  }

  .md\\:gap-12 {
    gap: 3rem;
  }

  .md\\:gap-120px {
    gap: var(--coze-120);
  }

  .md\\:gap-12px {
    gap: var(--coze-12);
  }

  .md\\:gap-14 {
    gap: 3.5rem;
  }

  .md\\:gap-14px {
    gap: var(--coze-14);
  }

  .md\\:gap-15px {
    gap: var(--coze-15);
  }

  .md\\:gap-16 {
    gap: 4rem;
  }

  .md\\:gap-160px {
    gap: var(--coze-160);
  }

  .md\\:gap-16px {
    gap: var(--coze-16);
  }

  .md\\:gap-18px {
    gap: var(--coze-18);
  }

  .md\\:gap-1px {
    gap: var(--coze-1);
  }

  .md\\:gap-2 {
    gap: .5rem;
  }

  .md\\:gap-2\\.5 {
    gap: .625rem;
  }

  .md\\:gap-20 {
    gap: 5rem;
  }

  .md\\:gap-200px {
    gap: var(--coze-200);
  }

  .md\\:gap-20px {
    gap: var(--coze-20);
  }

  .md\\:gap-22px {
    gap: var(--coze-22);
  }

  .md\\:gap-24 {
    gap: 6rem;
  }

  .md\\:gap-240px {
    gap: var(--coze-240);
  }

  .md\\:gap-24px {
    gap: var(--coze-24);
  }

  .md\\:gap-26px {
    gap: var(--coze-26);
  }

  .md\\:gap-28 {
    gap: 7rem;
  }

  .md\\:gap-28px {
    gap: var(--coze-28);
  }

  .md\\:gap-2px {
    gap: var(--coze-2);
  }

  .md\\:gap-3 {
    gap: .75rem;
  }

  .md\\:gap-3\\.5 {
    gap: .875rem;
  }

  .md\\:gap-30px {
    gap: var(--coze-30);
  }

  .md\\:gap-32 {
    gap: 8rem;
  }

  .md\\:gap-320px {
    gap: var(--coze-320);
  }

  .md\\:gap-32px {
    gap: var(--coze-32);
  }

  .md\\:gap-36 {
    gap: 9rem;
  }

  .md\\:gap-3px {
    gap: var(--coze-3);
  }

  .md\\:gap-4 {
    gap: 1rem;
  }

  .md\\:gap-40 {
    gap: 10rem;
  }

  .md\\:gap-40px {
    gap: var(--coze-40);
  }

  .md\\:gap-44 {
    gap: 11rem;
  }

  .md\\:gap-48 {
    gap: 12rem;
  }

  .md\\:gap-480px {
    gap: var(--coze-480);
  }

  .md\\:gap-48px {
    gap: var(--coze-48);
  }

  .md\\:gap-4px {
    gap: var(--coze-4);
  }

  .md\\:gap-5 {
    gap: 1.25rem;
  }

  .md\\:gap-52 {
    gap: 13rem;
  }

  .md\\:gap-56 {
    gap: 14rem;
  }

  .md\\:gap-5px {
    gap: var(--coze-5);
  }

  .md\\:gap-6 {
    gap: 1.5rem;
  }

  .md\\:gap-60 {
    gap: 15rem;
  }

  .md\\:gap-64 {
    gap: 16rem;
  }

  .md\\:gap-640px {
    gap: var(--coze-640);
  }

  .md\\:gap-64px {
    gap: var(--coze-64);
  }

  .md\\:gap-6px {
    gap: var(--coze-6);
  }

  .md\\:gap-7 {
    gap: 1.75rem;
  }

  .md\\:gap-72 {
    gap: 18rem;
  }

  .md\\:gap-8 {
    gap: 2rem;
  }

  .md\\:gap-80 {
    gap: 20rem;
  }

  .md\\:gap-800px {
    gap: var(--coze-800);
  }

  .md\\:gap-80px {
    gap: var(--coze-80);
  }

  .md\\:gap-8px {
    gap: var(--coze-8);
  }

  .md\\:gap-9 {
    gap: 2.25rem;
  }

  .md\\:gap-96 {
    gap: 24rem;
  }

  .md\\:gap-96px {
    gap: var(--coze-96);
  }

  .md\\:gap-9px {
    gap: var(--coze-9);
  }

  .md\\:gap-base {
    gap: 16px;
  }

  .md\\:gap-base-loose {
    gap: 20px;
  }

  .md\\:gap-base-tight {
    gap: 12px;
  }

  .md\\:gap-extra-loose {
    gap: 32px;
  }

  .md\\:gap-extra-tight {
    gap: 4px;
  }

  .md\\:gap-large {
    gap: var(--coze-40);
  }

  .md\\:gap-loose {
    gap: 24px;
  }

  .md\\:gap-md {
    gap: var(--coze-64);
  }

  .md\\:gap-mini {
    gap: var(--coze-16);
  }

  .md\\:gap-mm {
    gap: var(--coze-48);
  }

  .md\\:gap-none {
    gap: 0;
  }

  .md\\:gap-normal {
    gap: var(--coze-32);
  }

  .md\\:gap-px {
    gap: 1px;
  }

  .md\\:gap-small {
    gap: var(--coze-20);
  }

  .md\\:gap-super-loose {
    gap: 40px;
  }

  .md\\:gap-super-tight {
    gap: 2px;
  }

  .md\\:gap-tight {
    gap: 8px;
  }

  .md\\:gap-xl {
    gap: var(--coze-80);
  }

  .md\\:gap-xxl {
    gap: var(--coze-96);
  }

  .md\\:gap-x {
    -moz-column-gap: var(--coze-8);
    column-gap: var(--coze-8);
  }

  .md\\:gap-x-0 {
    -moz-column-gap: 0px;
    column-gap: 0;
  }

  .md\\:gap-x-0\\.5 {
    -moz-column-gap: .125rem;
    column-gap: .125rem;
  }

  .md\\:gap-x-1 {
    -moz-column-gap: .25rem;
    column-gap: .25rem;
  }

  .md\\:gap-x-1\\.5 {
    -moz-column-gap: .375rem;
    column-gap: .375rem;
  }

  .md\\:gap-x-10 {
    -moz-column-gap: 2.5rem;
    column-gap: 2.5rem;
  }

  .md\\:gap-x-1080px {
    -moz-column-gap: var(--coze-1080);
    column-gap: var(--coze-1080);
  }

  .md\\:gap-x-10px {
    -moz-column-gap: var(--coze-10);
    column-gap: var(--coze-10);
  }

  .md\\:gap-x-11 {
    -moz-column-gap: 2.75rem;
    column-gap: 2.75rem;
  }

  .md\\:gap-x-12 {
    -moz-column-gap: 3rem;
    column-gap: 3rem;
  }

  .md\\:gap-x-120px {
    -moz-column-gap: var(--coze-120);
    column-gap: var(--coze-120);
  }

  .md\\:gap-x-12px {
    -moz-column-gap: var(--coze-12);
    column-gap: var(--coze-12);
  }

  .md\\:gap-x-14 {
    -moz-column-gap: 3.5rem;
    column-gap: 3.5rem;
  }

  .md\\:gap-x-14px {
    -moz-column-gap: var(--coze-14);
    column-gap: var(--coze-14);
  }

  .md\\:gap-x-15px {
    -moz-column-gap: var(--coze-15);
    column-gap: var(--coze-15);
  }

  .md\\:gap-x-16 {
    -moz-column-gap: 4rem;
    column-gap: 4rem;
  }

  .md\\:gap-x-160px {
    -moz-column-gap: var(--coze-160);
    column-gap: var(--coze-160);
  }

  .md\\:gap-x-16px {
    -moz-column-gap: var(--coze-16);
    column-gap: var(--coze-16);
  }

  .md\\:gap-x-18px {
    -moz-column-gap: var(--coze-18);
    column-gap: var(--coze-18);
  }

  .md\\:gap-x-1px {
    -moz-column-gap: var(--coze-1);
    column-gap: var(--coze-1);
  }

  .md\\:gap-x-2 {
    -moz-column-gap: .5rem;
    column-gap: .5rem;
  }

  .md\\:gap-x-2\\.5 {
    -moz-column-gap: .625rem;
    column-gap: .625rem;
  }

  .md\\:gap-x-20 {
    -moz-column-gap: 5rem;
    column-gap: 5rem;
  }

  .md\\:gap-x-200px {
    -moz-column-gap: var(--coze-200);
    column-gap: var(--coze-200);
  }

  .md\\:gap-x-20px {
    -moz-column-gap: var(--coze-20);
    column-gap: var(--coze-20);
  }

  .md\\:gap-x-22px {
    -moz-column-gap: var(--coze-22);
    column-gap: var(--coze-22);
  }

  .md\\:gap-x-24 {
    -moz-column-gap: 6rem;
    column-gap: 6rem;
  }

  .md\\:gap-x-240px {
    -moz-column-gap: var(--coze-240);
    column-gap: var(--coze-240);
  }

  .md\\:gap-x-24px {
    -moz-column-gap: var(--coze-24);
    column-gap: var(--coze-24);
  }

  .md\\:gap-x-26px {
    -moz-column-gap: var(--coze-26);
    column-gap: var(--coze-26);
  }

  .md\\:gap-x-28 {
    -moz-column-gap: 7rem;
    column-gap: 7rem;
  }

  .md\\:gap-x-28px {
    -moz-column-gap: var(--coze-28);
    column-gap: var(--coze-28);
  }

  .md\\:gap-x-2px {
    -moz-column-gap: var(--coze-2);
    column-gap: var(--coze-2);
  }

  .md\\:gap-x-3 {
    -moz-column-gap: .75rem;
    column-gap: .75rem;
  }

  .md\\:gap-x-3\\.5 {
    -moz-column-gap: .875rem;
    column-gap: .875rem;
  }

  .md\\:gap-x-30px {
    -moz-column-gap: var(--coze-30);
    column-gap: var(--coze-30);
  }

  .md\\:gap-x-32 {
    -moz-column-gap: 8rem;
    column-gap: 8rem;
  }

  .md\\:gap-x-320px {
    -moz-column-gap: var(--coze-320);
    column-gap: var(--coze-320);
  }

  .md\\:gap-x-32px {
    -moz-column-gap: var(--coze-32);
    column-gap: var(--coze-32);
  }

  .md\\:gap-x-36 {
    -moz-column-gap: 9rem;
    column-gap: 9rem;
  }

  .md\\:gap-x-3px {
    -moz-column-gap: var(--coze-3);
    column-gap: var(--coze-3);
  }

  .md\\:gap-x-4 {
    -moz-column-gap: 1rem;
    column-gap: 1rem;
  }

  .md\\:gap-x-40 {
    -moz-column-gap: 10rem;
    column-gap: 10rem;
  }

  .md\\:gap-x-40px {
    -moz-column-gap: var(--coze-40);
    column-gap: var(--coze-40);
  }

  .md\\:gap-x-44 {
    -moz-column-gap: 11rem;
    column-gap: 11rem;
  }

  .md\\:gap-x-48 {
    -moz-column-gap: 12rem;
    column-gap: 12rem;
  }

  .md\\:gap-x-480px {
    -moz-column-gap: var(--coze-480);
    column-gap: var(--coze-480);
  }

  .md\\:gap-x-48px {
    -moz-column-gap: var(--coze-48);
    column-gap: var(--coze-48);
  }

  .md\\:gap-x-4px {
    -moz-column-gap: var(--coze-4);
    column-gap: var(--coze-4);
  }

  .md\\:gap-x-5 {
    -moz-column-gap: 1.25rem;
    column-gap: 1.25rem;
  }

  .md\\:gap-x-52 {
    -moz-column-gap: 13rem;
    column-gap: 13rem;
  }

  .md\\:gap-x-56 {
    -moz-column-gap: 14rem;
    column-gap: 14rem;
  }

  .md\\:gap-x-5px {
    -moz-column-gap: var(--coze-5);
    column-gap: var(--coze-5);
  }

  .md\\:gap-x-6 {
    -moz-column-gap: 1.5rem;
    column-gap: 1.5rem;
  }

  .md\\:gap-x-60 {
    -moz-column-gap: 15rem;
    column-gap: 15rem;
  }

  .md\\:gap-x-64 {
    -moz-column-gap: 16rem;
    column-gap: 16rem;
  }

  .md\\:gap-x-640px {
    -moz-column-gap: var(--coze-640);
    column-gap: var(--coze-640);
  }

  .md\\:gap-x-64px {
    -moz-column-gap: var(--coze-64);
    column-gap: var(--coze-64);
  }

  .md\\:gap-x-6px {
    -moz-column-gap: var(--coze-6);
    column-gap: var(--coze-6);
  }

  .md\\:gap-x-7 {
    -moz-column-gap: 1.75rem;
    column-gap: 1.75rem;
  }

  .md\\:gap-x-72 {
    -moz-column-gap: 18rem;
    column-gap: 18rem;
  }

  .md\\:gap-x-8 {
    -moz-column-gap: 2rem;
    column-gap: 2rem;
  }

  .md\\:gap-x-80 {
    -moz-column-gap: 20rem;
    column-gap: 20rem;
  }

  .md\\:gap-x-800px {
    -moz-column-gap: var(--coze-800);
    column-gap: var(--coze-800);
  }

  .md\\:gap-x-80px {
    -moz-column-gap: var(--coze-80);
    column-gap: var(--coze-80);
  }

  .md\\:gap-x-8px {
    -moz-column-gap: var(--coze-8);
    column-gap: var(--coze-8);
  }

  .md\\:gap-x-9 {
    -moz-column-gap: 2.25rem;
    column-gap: 2.25rem;
  }

  .md\\:gap-x-96 {
    -moz-column-gap: 24rem;
    column-gap: 24rem;
  }

  .md\\:gap-x-96px {
    -moz-column-gap: var(--coze-96);
    column-gap: var(--coze-96);
  }

  .md\\:gap-x-9px {
    -moz-column-gap: var(--coze-9);
    column-gap: var(--coze-9);
  }

  .md\\:gap-x-base {
    -moz-column-gap: 16px;
    column-gap: 16px;
  }

  .md\\:gap-x-base-loose {
    -moz-column-gap: 20px;
    column-gap: 20px;
  }

  .md\\:gap-x-base-tight {
    -moz-column-gap: 12px;
    column-gap: 12px;
  }

  .md\\:gap-x-extra-loose {
    -moz-column-gap: 32px;
    column-gap: 32px;
  }

  .md\\:gap-x-extra-tight {
    -moz-column-gap: 4px;
    column-gap: 4px;
  }

  .md\\:gap-x-large {
    -moz-column-gap: var(--coze-40);
    column-gap: var(--coze-40);
  }

  .md\\:gap-x-loose {
    -moz-column-gap: 24px;
    column-gap: 24px;
  }

  .md\\:gap-x-md {
    -moz-column-gap: var(--coze-64);
    column-gap: var(--coze-64);
  }

  .md\\:gap-x-mini {
    -moz-column-gap: var(--coze-16);
    column-gap: var(--coze-16);
  }

  .md\\:gap-x-mm {
    -moz-column-gap: var(--coze-48);
    column-gap: var(--coze-48);
  }

  .md\\:gap-x-none {
    -moz-column-gap: 0;
    column-gap: 0;
  }

  .md\\:gap-x-normal {
    -moz-column-gap: var(--coze-32);
    column-gap: var(--coze-32);
  }

  .md\\:gap-x-px {
    -moz-column-gap: 1px;
    column-gap: 1px;
  }

  .md\\:gap-x-small {
    -moz-column-gap: var(--coze-20);
    column-gap: var(--coze-20);
  }

  .md\\:gap-x-super-loose {
    -moz-column-gap: 40px;
    column-gap: 40px;
  }

  .md\\:gap-x-super-tight {
    -moz-column-gap: 2px;
    column-gap: 2px;
  }

  .md\\:gap-x-tight {
    -moz-column-gap: 8px;
    column-gap: 8px;
  }

  .md\\:gap-x-xl {
    -moz-column-gap: var(--coze-80);
    column-gap: var(--coze-80);
  }

  .md\\:gap-x-xxl {
    -moz-column-gap: var(--coze-96);
    column-gap: var(--coze-96);
  }

  .md\\:gap-y {
    row-gap: var(--coze-8);
  }

  .md\\:gap-y-0 {
    row-gap: 0;
  }

  .md\\:gap-y-0\\.5 {
    row-gap: .125rem;
  }

  .md\\:gap-y-1 {
    row-gap: .25rem;
  }

  .md\\:gap-y-1\\.5 {
    row-gap: .375rem;
  }

  .md\\:gap-y-10 {
    row-gap: 2.5rem;
  }

  .md\\:gap-y-1080px {
    row-gap: var(--coze-1080);
  }

  .md\\:gap-y-10px {
    row-gap: var(--coze-10);
  }

  .md\\:gap-y-11 {
    row-gap: 2.75rem;
  }

  .md\\:gap-y-12 {
    row-gap: 3rem;
  }

  .md\\:gap-y-120px {
    row-gap: var(--coze-120);
  }

  .md\\:gap-y-12px {
    row-gap: var(--coze-12);
  }

  .md\\:gap-y-14 {
    row-gap: 3.5rem;
  }

  .md\\:gap-y-14px {
    row-gap: var(--coze-14);
  }

  .md\\:gap-y-15px {
    row-gap: var(--coze-15);
  }

  .md\\:gap-y-16 {
    row-gap: 4rem;
  }

  .md\\:gap-y-160px {
    row-gap: var(--coze-160);
  }

  .md\\:gap-y-16px {
    row-gap: var(--coze-16);
  }

  .md\\:gap-y-18px {
    row-gap: var(--coze-18);
  }

  .md\\:gap-y-1px {
    row-gap: var(--coze-1);
  }

  .md\\:gap-y-2 {
    row-gap: .5rem;
  }

  .md\\:gap-y-2\\.5 {
    row-gap: .625rem;
  }

  .md\\:gap-y-20 {
    row-gap: 5rem;
  }

  .md\\:gap-y-200px {
    row-gap: var(--coze-200);
  }

  .md\\:gap-y-20px {
    row-gap: var(--coze-20);
  }

  .md\\:gap-y-22px {
    row-gap: var(--coze-22);
  }

  .md\\:gap-y-24 {
    row-gap: 6rem;
  }

  .md\\:gap-y-240px {
    row-gap: var(--coze-240);
  }

  .md\\:gap-y-24px {
    row-gap: var(--coze-24);
  }

  .md\\:gap-y-26px {
    row-gap: var(--coze-26);
  }

  .md\\:gap-y-28 {
    row-gap: 7rem;
  }

  .md\\:gap-y-28px {
    row-gap: var(--coze-28);
  }

  .md\\:gap-y-2px {
    row-gap: var(--coze-2);
  }

  .md\\:gap-y-3 {
    row-gap: .75rem;
  }

  .md\\:gap-y-3\\.5 {
    row-gap: .875rem;
  }

  .md\\:gap-y-30px {
    row-gap: var(--coze-30);
  }

  .md\\:gap-y-32 {
    row-gap: 8rem;
  }

  .md\\:gap-y-320px {
    row-gap: var(--coze-320);
  }

  .md\\:gap-y-32px {
    row-gap: var(--coze-32);
  }

  .md\\:gap-y-36 {
    row-gap: 9rem;
  }

  .md\\:gap-y-3px {
    row-gap: var(--coze-3);
  }

  .md\\:gap-y-4 {
    row-gap: 1rem;
  }

  .md\\:gap-y-40 {
    row-gap: 10rem;
  }

  .md\\:gap-y-40px {
    row-gap: var(--coze-40);
  }

  .md\\:gap-y-44 {
    row-gap: 11rem;
  }

  .md\\:gap-y-48 {
    row-gap: 12rem;
  }

  .md\\:gap-y-480px {
    row-gap: var(--coze-480);
  }

  .md\\:gap-y-48px {
    row-gap: var(--coze-48);
  }

  .md\\:gap-y-4px {
    row-gap: var(--coze-4);
  }

  .md\\:gap-y-5 {
    row-gap: 1.25rem;
  }

  .md\\:gap-y-52 {
    row-gap: 13rem;
  }

  .md\\:gap-y-56 {
    row-gap: 14rem;
  }

  .md\\:gap-y-5px {
    row-gap: var(--coze-5);
  }

  .md\\:gap-y-6 {
    row-gap: 1.5rem;
  }

  .md\\:gap-y-60 {
    row-gap: 15rem;
  }

  .md\\:gap-y-64 {
    row-gap: 16rem;
  }

  .md\\:gap-y-640px {
    row-gap: var(--coze-640);
  }

  .md\\:gap-y-64px {
    row-gap: var(--coze-64);
  }

  .md\\:gap-y-6px {
    row-gap: var(--coze-6);
  }

  .md\\:gap-y-7 {
    row-gap: 1.75rem;
  }

  .md\\:gap-y-72 {
    row-gap: 18rem;
  }

  .md\\:gap-y-8 {
    row-gap: 2rem;
  }

  .md\\:gap-y-80 {
    row-gap: 20rem;
  }

  .md\\:gap-y-800px {
    row-gap: var(--coze-800);
  }

  .md\\:gap-y-80px {
    row-gap: var(--coze-80);
  }

  .md\\:gap-y-8px {
    row-gap: var(--coze-8);
  }

  .md\\:gap-y-9 {
    row-gap: 2.25rem;
  }

  .md\\:gap-y-96 {
    row-gap: 24rem;
  }

  .md\\:gap-y-96px {
    row-gap: var(--coze-96);
  }

  .md\\:gap-y-9px {
    row-gap: var(--coze-9);
  }

  .md\\:gap-y-base {
    row-gap: 16px;
  }

  .md\\:gap-y-base-loose {
    row-gap: 20px;
  }

  .md\\:gap-y-base-tight {
    row-gap: 12px;
  }

  .md\\:gap-y-extra-loose {
    row-gap: 32px;
  }

  .md\\:gap-y-extra-tight {
    row-gap: 4px;
  }

  .md\\:gap-y-large {
    row-gap: var(--coze-40);
  }

  .md\\:gap-y-loose {
    row-gap: 24px;
  }

  .md\\:gap-y-md {
    row-gap: var(--coze-64);
  }

  .md\\:gap-y-mini {
    row-gap: var(--coze-16);
  }

  .md\\:gap-y-mm {
    row-gap: var(--coze-48);
  }

  .md\\:gap-y-none {
    row-gap: 0;
  }

  .md\\:gap-y-normal {
    row-gap: var(--coze-32);
  }

  .md\\:gap-y-px {
    row-gap: 1px;
  }

  .md\\:gap-y-small {
    row-gap: var(--coze-20);
  }

  .md\\:gap-y-super-loose {
    row-gap: 40px;
  }

  .md\\:gap-y-super-tight {
    row-gap: 2px;
  }

  .md\\:gap-y-tight {
    row-gap: 8px;
  }

  .md\\:gap-y-xl {
    row-gap: var(--coze-80);
  }

  .md\\:gap-y-xxl {
    row-gap: var(--coze-96);
  }
}

@media (min-width: 1200px) {
  .lg\\:grid-flow-row {
    grid-auto-flow: row;
  }

  .lg\\:grid-flow-col {
    grid-auto-flow: column;
  }

  .lg\\:grid-flow-dense {
    grid-auto-flow: dense;
  }

  .lg\\:grid-flow-row-dense {
    grid-auto-flow: row dense;
  }

  .lg\\:grid-flow-col-dense {
    grid-auto-flow: column dense;
  }

  .lg\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .lg\\:grid-cols-10 {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }

  .lg\\:grid-cols-11 {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }

  .lg\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .lg\\:grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .lg\\:grid-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }

  .lg\\:grid-cols-9 {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }

  .lg\\:grid-cols-none {
    grid-template-columns: none;
  }

  .lg\\:grid-rows-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }

  .lg\\:grid-rows-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-rows-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-rows-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-rows-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }

  .lg\\:grid-rows-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }

  .lg\\:grid-rows-none {
    grid-template-rows: none;
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:flex-row-reverse {
    flex-direction: row-reverse;
  }

  .lg\\:gap-0 {
    gap: 0;
  }

  .lg\\:gap-0\\.5 {
    gap: .125rem;
  }

  .lg\\:gap-1 {
    gap: .25rem;
  }

  .lg\\:gap-1\\.5 {
    gap: .375rem;
  }

  .lg\\:gap-10 {
    gap: 2.5rem;
  }

  .lg\\:gap-1080px {
    gap: var(--coze-1080);
  }

  .lg\\:gap-10px {
    gap: var(--coze-10);
  }

  .lg\\:gap-11 {
    gap: 2.75rem;
  }

  .lg\\:gap-12 {
    gap: 3rem;
  }

  .lg\\:gap-120px {
    gap: var(--coze-120);
  }

  .lg\\:gap-12px {
    gap: var(--coze-12);
  }

  .lg\\:gap-14 {
    gap: 3.5rem;
  }

  .lg\\:gap-14px {
    gap: var(--coze-14);
  }

  .lg\\:gap-15px {
    gap: var(--coze-15);
  }

  .lg\\:gap-16 {
    gap: 4rem;
  }

  .lg\\:gap-160px {
    gap: var(--coze-160);
  }

  .lg\\:gap-16px {
    gap: var(--coze-16);
  }

  .lg\\:gap-18px {
    gap: var(--coze-18);
  }

  .lg\\:gap-1px {
    gap: var(--coze-1);
  }

  .lg\\:gap-2 {
    gap: .5rem;
  }

  .lg\\:gap-2\\.5 {
    gap: .625rem;
  }

  .lg\\:gap-20 {
    gap: 5rem;
  }

  .lg\\:gap-200px {
    gap: var(--coze-200);
  }

  .lg\\:gap-20px {
    gap: var(--coze-20);
  }

  .lg\\:gap-22px {
    gap: var(--coze-22);
  }

  .lg\\:gap-24 {
    gap: 6rem;
  }

  .lg\\:gap-240px {
    gap: var(--coze-240);
  }

  .lg\\:gap-24px {
    gap: var(--coze-24);
  }

  .lg\\:gap-26px {
    gap: var(--coze-26);
  }

  .lg\\:gap-28 {
    gap: 7rem;
  }

  .lg\\:gap-28px {
    gap: var(--coze-28);
  }

  .lg\\:gap-2px {
    gap: var(--coze-2);
  }

  .lg\\:gap-3 {
    gap: .75rem;
  }

  .lg\\:gap-3\\.5 {
    gap: .875rem;
  }

  .lg\\:gap-30px {
    gap: var(--coze-30);
  }

  .lg\\:gap-32 {
    gap: 8rem;
  }

  .lg\\:gap-320px {
    gap: var(--coze-320);
  }

  .lg\\:gap-32px {
    gap: var(--coze-32);
  }

  .lg\\:gap-36 {
    gap: 9rem;
  }

  .lg\\:gap-3px {
    gap: var(--coze-3);
  }

  .lg\\:gap-4 {
    gap: 1rem;
  }

  .lg\\:gap-40 {
    gap: 10rem;
  }

  .lg\\:gap-40px {
    gap: var(--coze-40);
  }

  .lg\\:gap-44 {
    gap: 11rem;
  }

  .lg\\:gap-48 {
    gap: 12rem;
  }

  .lg\\:gap-480px {
    gap: var(--coze-480);
  }

  .lg\\:gap-48px {
    gap: var(--coze-48);
  }

  .lg\\:gap-4px {
    gap: var(--coze-4);
  }

  .lg\\:gap-5 {
    gap: 1.25rem;
  }

  .lg\\:gap-52 {
    gap: 13rem;
  }

  .lg\\:gap-56 {
    gap: 14rem;
  }

  .lg\\:gap-5px {
    gap: var(--coze-5);
  }

  .lg\\:gap-6 {
    gap: 1.5rem;
  }

  .lg\\:gap-60 {
    gap: 15rem;
  }

  .lg\\:gap-64 {
    gap: 16rem;
  }

  .lg\\:gap-640px {
    gap: var(--coze-640);
  }

  .lg\\:gap-64px {
    gap: var(--coze-64);
  }

  .lg\\:gap-6px {
    gap: var(--coze-6);
  }

  .lg\\:gap-7 {
    gap: 1.75rem;
  }

  .lg\\:gap-72 {
    gap: 18rem;
  }

  .lg\\:gap-8 {
    gap: 2rem;
  }

  .lg\\:gap-80 {
    gap: 20rem;
  }

  .lg\\:gap-800px {
    gap: var(--coze-800);
  }

  .lg\\:gap-80px {
    gap: var(--coze-80);
  }

  .lg\\:gap-8px {
    gap: var(--coze-8);
  }

  .lg\\:gap-9 {
    gap: 2.25rem;
  }

  .lg\\:gap-96 {
    gap: 24rem;
  }

  .lg\\:gap-96px {
    gap: var(--coze-96);
  }

  .lg\\:gap-9px {
    gap: var(--coze-9);
  }

  .lg\\:gap-base {
    gap: 16px;
  }

  .lg\\:gap-base-loose {
    gap: 20px;
  }

  .lg\\:gap-base-tight {
    gap: 12px;
  }

  .lg\\:gap-extra-loose {
    gap: 32px;
  }

  .lg\\:gap-extra-tight {
    gap: 4px;
  }

  .lg\\:gap-large {
    gap: var(--coze-40);
  }

  .lg\\:gap-loose {
    gap: 24px;
  }

  .lg\\:gap-md {
    gap: var(--coze-64);
  }

  .lg\\:gap-mini {
    gap: var(--coze-16);
  }

  .lg\\:gap-mm {
    gap: var(--coze-48);
  }

  .lg\\:gap-none {
    gap: 0;
  }

  .lg\\:gap-normal {
    gap: var(--coze-32);
  }

  .lg\\:gap-px {
    gap: 1px;
  }

  .lg\\:gap-small {
    gap: var(--coze-20);
  }

  .lg\\:gap-super-loose {
    gap: 40px;
  }

  .lg\\:gap-super-tight {
    gap: 2px;
  }

  .lg\\:gap-tight {
    gap: 8px;
  }

  .lg\\:gap-xl {
    gap: var(--coze-80);
  }

  .lg\\:gap-xxl {
    gap: var(--coze-96);
  }

  .lg\\:gap-x {
    -moz-column-gap: var(--coze-8);
    column-gap: var(--coze-8);
  }

  .lg\\:gap-x-0 {
    -moz-column-gap: 0px;
    column-gap: 0;
  }

  .lg\\:gap-x-0\\.5 {
    -moz-column-gap: .125rem;
    column-gap: .125rem;
  }

  .lg\\:gap-x-1 {
    -moz-column-gap: .25rem;
    column-gap: .25rem;
  }

  .lg\\:gap-x-1\\.5 {
    -moz-column-gap: .375rem;
    column-gap: .375rem;
  }

  .lg\\:gap-x-10 {
    -moz-column-gap: 2.5rem;
    column-gap: 2.5rem;
  }

  .lg\\:gap-x-1080px {
    -moz-column-gap: var(--coze-1080);
    column-gap: var(--coze-1080);
  }

  .lg\\:gap-x-10px {
    -moz-column-gap: var(--coze-10);
    column-gap: var(--coze-10);
  }

  .lg\\:gap-x-11 {
    -moz-column-gap: 2.75rem;
    column-gap: 2.75rem;
  }

  .lg\\:gap-x-12 {
    -moz-column-gap: 3rem;
    column-gap: 3rem;
  }

  .lg\\:gap-x-120px {
    -moz-column-gap: var(--coze-120);
    column-gap: var(--coze-120);
  }

  .lg\\:gap-x-12px {
    -moz-column-gap: var(--coze-12);
    column-gap: var(--coze-12);
  }

  .lg\\:gap-x-14 {
    -moz-column-gap: 3.5rem;
    column-gap: 3.5rem;
  }

  .lg\\:gap-x-14px {
    -moz-column-gap: var(--coze-14);
    column-gap: var(--coze-14);
  }

  .lg\\:gap-x-15px {
    -moz-column-gap: var(--coze-15);
    column-gap: var(--coze-15);
  }

  .lg\\:gap-x-16 {
    -moz-column-gap: 4rem;
    column-gap: 4rem;
  }

  .lg\\:gap-x-160px {
    -moz-column-gap: var(--coze-160);
    column-gap: var(--coze-160);
  }

  .lg\\:gap-x-16px {
    -moz-column-gap: var(--coze-16);
    column-gap: var(--coze-16);
  }

  .lg\\:gap-x-18px {
    -moz-column-gap: var(--coze-18);
    column-gap: var(--coze-18);
  }

  .lg\\:gap-x-1px {
    -moz-column-gap: var(--coze-1);
    column-gap: var(--coze-1);
  }

  .lg\\:gap-x-2 {
    -moz-column-gap: .5rem;
    column-gap: .5rem;
  }

  .lg\\:gap-x-2\\.5 {
    -moz-column-gap: .625rem;
    column-gap: .625rem;
  }

  .lg\\:gap-x-20 {
    -moz-column-gap: 5rem;
    column-gap: 5rem;
  }

  .lg\\:gap-x-200px {
    -moz-column-gap: var(--coze-200);
    column-gap: var(--coze-200);
  }

  .lg\\:gap-x-20px {
    -moz-column-gap: var(--coze-20);
    column-gap: var(--coze-20);
  }

  .lg\\:gap-x-22px {
    -moz-column-gap: var(--coze-22);
    column-gap: var(--coze-22);
  }

  .lg\\:gap-x-24 {
    -moz-column-gap: 6rem;
    column-gap: 6rem;
  }

  .lg\\:gap-x-240px {
    -moz-column-gap: var(--coze-240);
    column-gap: var(--coze-240);
  }

  .lg\\:gap-x-24px {
    -moz-column-gap: var(--coze-24);
    column-gap: var(--coze-24);
  }

  .lg\\:gap-x-26px {
    -moz-column-gap: var(--coze-26);
    column-gap: var(--coze-26);
  }

  .lg\\:gap-x-28 {
    -moz-column-gap: 7rem;
    column-gap: 7rem;
  }

  .lg\\:gap-x-28px {
    -moz-column-gap: var(--coze-28);
    column-gap: var(--coze-28);
  }

  .lg\\:gap-x-2px {
    -moz-column-gap: var(--coze-2);
    column-gap: var(--coze-2);
  }

  .lg\\:gap-x-3 {
    -moz-column-gap: .75rem;
    column-gap: .75rem;
  }

  .lg\\:gap-x-3\\.5 {
    -moz-column-gap: .875rem;
    column-gap: .875rem;
  }

  .lg\\:gap-x-30px {
    -moz-column-gap: var(--coze-30);
    column-gap: var(--coze-30);
  }

  .lg\\:gap-x-32 {
    -moz-column-gap: 8rem;
    column-gap: 8rem;
  }

  .lg\\:gap-x-320px {
    -moz-column-gap: var(--coze-320);
    column-gap: var(--coze-320);
  }

  .lg\\:gap-x-32px {
    -moz-column-gap: var(--coze-32);
    column-gap: var(--coze-32);
  }

  .lg\\:gap-x-36 {
    -moz-column-gap: 9rem;
    column-gap: 9rem;
  }

  .lg\\:gap-x-3px {
    -moz-column-gap: var(--coze-3);
    column-gap: var(--coze-3);
  }

  .lg\\:gap-x-4 {
    -moz-column-gap: 1rem;
    column-gap: 1rem;
  }

  .lg\\:gap-x-40 {
    -moz-column-gap: 10rem;
    column-gap: 10rem;
  }

  .lg\\:gap-x-40px {
    -moz-column-gap: var(--coze-40);
    column-gap: var(--coze-40);
  }

  .lg\\:gap-x-44 {
    -moz-column-gap: 11rem;
    column-gap: 11rem;
  }

  .lg\\:gap-x-48 {
    -moz-column-gap: 12rem;
    column-gap: 12rem;
  }

  .lg\\:gap-x-480px {
    -moz-column-gap: var(--coze-480);
    column-gap: var(--coze-480);
  }

  .lg\\:gap-x-48px {
    -moz-column-gap: var(--coze-48);
    column-gap: var(--coze-48);
  }

  .lg\\:gap-x-4px {
    -moz-column-gap: var(--coze-4);
    column-gap: var(--coze-4);
  }

  .lg\\:gap-x-5 {
    -moz-column-gap: 1.25rem;
    column-gap: 1.25rem;
  }

  .lg\\:gap-x-52 {
    -moz-column-gap: 13rem;
    column-gap: 13rem;
  }

  .lg\\:gap-x-56 {
    -moz-column-gap: 14rem;
    column-gap: 14rem;
  }

  .lg\\:gap-x-5px {
    -moz-column-gap: var(--coze-5);
    column-gap: var(--coze-5);
  }

  .lg\\:gap-x-6 {
    -moz-column-gap: 1.5rem;
    column-gap: 1.5rem;
  }

  .lg\\:gap-x-60 {
    -moz-column-gap: 15rem;
    column-gap: 15rem;
  }

  .lg\\:gap-x-64 {
    -moz-column-gap: 16rem;
    column-gap: 16rem;
  }

  .lg\\:gap-x-640px {
    -moz-column-gap: var(--coze-640);
    column-gap: var(--coze-640);
  }

  .lg\\:gap-x-64px {
    -moz-column-gap: var(--coze-64);
    column-gap: var(--coze-64);
  }

  .lg\\:gap-x-6px {
    -moz-column-gap: var(--coze-6);
    column-gap: var(--coze-6);
  }

  .lg\\:gap-x-7 {
    -moz-column-gap: 1.75rem;
    column-gap: 1.75rem;
  }

  .lg\\:gap-x-72 {
    -moz-column-gap: 18rem;
    column-gap: 18rem;
  }

  .lg\\:gap-x-8 {
    -moz-column-gap: 2rem;
    column-gap: 2rem;
  }

  .lg\\:gap-x-80 {
    -moz-column-gap: 20rem;
    column-gap: 20rem;
  }

  .lg\\:gap-x-800px {
    -moz-column-gap: var(--coze-800);
    column-gap: var(--coze-800);
  }

  .lg\\:gap-x-80px {
    -moz-column-gap: var(--coze-80);
    column-gap: var(--coze-80);
  }

  .lg\\:gap-x-8px {
    -moz-column-gap: var(--coze-8);
    column-gap: var(--coze-8);
  }

  .lg\\:gap-x-9 {
    -moz-column-gap: 2.25rem;
    column-gap: 2.25rem;
  }

  .lg\\:gap-x-96 {
    -moz-column-gap: 24rem;
    column-gap: 24rem;
  }

  .lg\\:gap-x-96px {
    -moz-column-gap: var(--coze-96);
    column-gap: var(--coze-96);
  }

  .lg\\:gap-x-9px {
    -moz-column-gap: var(--coze-9);
    column-gap: var(--coze-9);
  }

  .lg\\:gap-x-base {
    -moz-column-gap: 16px;
    column-gap: 16px;
  }

  .lg\\:gap-x-base-loose {
    -moz-column-gap: 20px;
    column-gap: 20px;
  }

  .lg\\:gap-x-base-tight {
    -moz-column-gap: 12px;
    column-gap: 12px;
  }

  .lg\\:gap-x-extra-loose {
    -moz-column-gap: 32px;
    column-gap: 32px;
  }

  .lg\\:gap-x-extra-tight {
    -moz-column-gap: 4px;
    column-gap: 4px;
  }

  .lg\\:gap-x-large {
    -moz-column-gap: var(--coze-40);
    column-gap: var(--coze-40);
  }

  .lg\\:gap-x-loose {
    -moz-column-gap: 24px;
    column-gap: 24px;
  }

  .lg\\:gap-x-md {
    -moz-column-gap: var(--coze-64);
    column-gap: var(--coze-64);
  }

  .lg\\:gap-x-mini {
    -moz-column-gap: var(--coze-16);
    column-gap: var(--coze-16);
  }

  .lg\\:gap-x-mm {
    -moz-column-gap: var(--coze-48);
    column-gap: var(--coze-48);
  }

  .lg\\:gap-x-none {
    -moz-column-gap: 0;
    column-gap: 0;
  }

  .lg\\:gap-x-normal {
    -moz-column-gap: var(--coze-32);
    column-gap: var(--coze-32);
  }

  .lg\\:gap-x-px {
    -moz-column-gap: 1px;
    column-gap: 1px;
  }

  .lg\\:gap-x-small {
    -moz-column-gap: var(--coze-20);
    column-gap: var(--coze-20);
  }

  .lg\\:gap-x-super-loose {
    -moz-column-gap: 40px;
    column-gap: 40px;
  }

  .lg\\:gap-x-super-tight {
    -moz-column-gap: 2px;
    column-gap: 2px;
  }

  .lg\\:gap-x-tight {
    -moz-column-gap: 8px;
    column-gap: 8px;
  }

  .lg\\:gap-x-xl {
    -moz-column-gap: var(--coze-80);
    column-gap: var(--coze-80);
  }

  .lg\\:gap-x-xxl {
    -moz-column-gap: var(--coze-96);
    column-gap: var(--coze-96);
  }

  .lg\\:gap-y {
    row-gap: var(--coze-8);
  }

  .lg\\:gap-y-0 {
    row-gap: 0;
  }

  .lg\\:gap-y-0\\.5 {
    row-gap: .125rem;
  }

  .lg\\:gap-y-1 {
    row-gap: .25rem;
  }

  .lg\\:gap-y-1\\.5 {
    row-gap: .375rem;
  }

  .lg\\:gap-y-10 {
    row-gap: 2.5rem;
  }

  .lg\\:gap-y-1080px {
    row-gap: var(--coze-1080);
  }

  .lg\\:gap-y-10px {
    row-gap: var(--coze-10);
  }

  .lg\\:gap-y-11 {
    row-gap: 2.75rem;
  }

  .lg\\:gap-y-12 {
    row-gap: 3rem;
  }

  .lg\\:gap-y-120px {
    row-gap: var(--coze-120);
  }

  .lg\\:gap-y-12px {
    row-gap: var(--coze-12);
  }

  .lg\\:gap-y-14 {
    row-gap: 3.5rem;
  }

  .lg\\:gap-y-14px {
    row-gap: var(--coze-14);
  }

  .lg\\:gap-y-15px {
    row-gap: var(--coze-15);
  }

  .lg\\:gap-y-16 {
    row-gap: 4rem;
  }

  .lg\\:gap-y-160px {
    row-gap: var(--coze-160);
  }

  .lg\\:gap-y-16px {
    row-gap: var(--coze-16);
  }

  .lg\\:gap-y-18px {
    row-gap: var(--coze-18);
  }

  .lg\\:gap-y-1px {
    row-gap: var(--coze-1);
  }

  .lg\\:gap-y-2 {
    row-gap: .5rem;
  }

  .lg\\:gap-y-2\\.5 {
    row-gap: .625rem;
  }

  .lg\\:gap-y-20 {
    row-gap: 5rem;
  }

  .lg\\:gap-y-200px {
    row-gap: var(--coze-200);
  }

  .lg\\:gap-y-20px {
    row-gap: var(--coze-20);
  }

  .lg\\:gap-y-22px {
    row-gap: var(--coze-22);
  }

  .lg\\:gap-y-24 {
    row-gap: 6rem;
  }

  .lg\\:gap-y-240px {
    row-gap: var(--coze-240);
  }

  .lg\\:gap-y-24px {
    row-gap: var(--coze-24);
  }

  .lg\\:gap-y-26px {
    row-gap: var(--coze-26);
  }

  .lg\\:gap-y-28 {
    row-gap: 7rem;
  }

  .lg\\:gap-y-28px {
    row-gap: var(--coze-28);
  }

  .lg\\:gap-y-2px {
    row-gap: var(--coze-2);
  }

  .lg\\:gap-y-3 {
    row-gap: .75rem;
  }

  .lg\\:gap-y-3\\.5 {
    row-gap: .875rem;
  }

  .lg\\:gap-y-30px {
    row-gap: var(--coze-30);
  }

  .lg\\:gap-y-32 {
    row-gap: 8rem;
  }

  .lg\\:gap-y-320px {
    row-gap: var(--coze-320);
  }

  .lg\\:gap-y-32px {
    row-gap: var(--coze-32);
  }

  .lg\\:gap-y-36 {
    row-gap: 9rem;
  }

  .lg\\:gap-y-3px {
    row-gap: var(--coze-3);
  }

  .lg\\:gap-y-4 {
    row-gap: 1rem;
  }

  .lg\\:gap-y-40 {
    row-gap: 10rem;
  }

  .lg\\:gap-y-40px {
    row-gap: var(--coze-40);
  }

  .lg\\:gap-y-44 {
    row-gap: 11rem;
  }

  .lg\\:gap-y-48 {
    row-gap: 12rem;
  }

  .lg\\:gap-y-480px {
    row-gap: var(--coze-480);
  }

  .lg\\:gap-y-48px {
    row-gap: var(--coze-48);
  }

  .lg\\:gap-y-4px {
    row-gap: var(--coze-4);
  }

  .lg\\:gap-y-5 {
    row-gap: 1.25rem;
  }

  .lg\\:gap-y-52 {
    row-gap: 13rem;
  }

  .lg\\:gap-y-56 {
    row-gap: 14rem;
  }

  .lg\\:gap-y-5px {
    row-gap: var(--coze-5);
  }

  .lg\\:gap-y-6 {
    row-gap: 1.5rem;
  }

  .lg\\:gap-y-60 {
    row-gap: 15rem;
  }

  .lg\\:gap-y-64 {
    row-gap: 16rem;
  }

  .lg\\:gap-y-640px {
    row-gap: var(--coze-640);
  }

  .lg\\:gap-y-64px {
    row-gap: var(--coze-64);
  }

  .lg\\:gap-y-6px {
    row-gap: var(--coze-6);
  }

  .lg\\:gap-y-7 {
    row-gap: 1.75rem;
  }

  .lg\\:gap-y-72 {
    row-gap: 18rem;
  }

  .lg\\:gap-y-8 {
    row-gap: 2rem;
  }

  .lg\\:gap-y-80 {
    row-gap: 20rem;
  }

  .lg\\:gap-y-800px {
    row-gap: var(--coze-800);
  }

  .lg\\:gap-y-80px {
    row-gap: var(--coze-80);
  }

  .lg\\:gap-y-8px {
    row-gap: var(--coze-8);
  }

  .lg\\:gap-y-9 {
    row-gap: 2.25rem;
  }

  .lg\\:gap-y-96 {
    row-gap: 24rem;
  }

  .lg\\:gap-y-96px {
    row-gap: var(--coze-96);
  }

  .lg\\:gap-y-9px {
    row-gap: var(--coze-9);
  }

  .lg\\:gap-y-base {
    row-gap: 16px;
  }

  .lg\\:gap-y-base-loose {
    row-gap: 20px;
  }

  .lg\\:gap-y-base-tight {
    row-gap: 12px;
  }

  .lg\\:gap-y-extra-loose {
    row-gap: 32px;
  }

  .lg\\:gap-y-extra-tight {
    row-gap: 4px;
  }

  .lg\\:gap-y-large {
    row-gap: var(--coze-40);
  }

  .lg\\:gap-y-loose {
    row-gap: 24px;
  }

  .lg\\:gap-y-md {
    row-gap: var(--coze-64);
  }

  .lg\\:gap-y-mini {
    row-gap: var(--coze-16);
  }

  .lg\\:gap-y-mm {
    row-gap: var(--coze-48);
  }

  .lg\\:gap-y-none {
    row-gap: 0;
  }

  .lg\\:gap-y-normal {
    row-gap: var(--coze-32);
  }

  .lg\\:gap-y-px {
    row-gap: 1px;
  }

  .lg\\:gap-y-small {
    row-gap: var(--coze-20);
  }

  .lg\\:gap-y-super-loose {
    row-gap: 40px;
  }

  .lg\\:gap-y-super-tight {
    row-gap: 2px;
  }

  .lg\\:gap-y-tight {
    row-gap: 8px;
  }

  .lg\\:gap-y-xl {
    row-gap: var(--coze-80);
  }

  .lg\\:gap-y-xxl {
    row-gap: var(--coze-96);
  }
}

@media (min-width: 1600px) {
  .xl\\:grid-flow-row {
    grid-auto-flow: row;
  }

  .xl\\:grid-flow-col {
    grid-auto-flow: column;
  }

  .xl\\:grid-flow-dense {
    grid-auto-flow: dense;
  }

  .xl\\:grid-flow-row-dense {
    grid-auto-flow: row dense;
  }

  .xl\\:grid-flow-col-dense {
    grid-auto-flow: column dense;
  }

  .xl\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .xl\\:grid-cols-10 {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }

  .xl\\:grid-cols-11 {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }

  .xl\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .xl\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .xl\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .xl\\:grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .xl\\:grid-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }

  .xl\\:grid-cols-9 {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }

  .xl\\:grid-cols-none {
    grid-template-columns: none;
  }

  .xl\\:grid-rows-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }

  .xl\\:grid-rows-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }

  .xl\\:grid-rows-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-rows-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-rows-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }

  .xl\\:grid-rows-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }

  .xl\\:grid-rows-none {
    grid-template-rows: none;
  }

  .xl\\:gap-0 {
    gap: 0;
  }

  .xl\\:gap-0\\.5 {
    gap: .125rem;
  }

  .xl\\:gap-1 {
    gap: .25rem;
  }

  .xl\\:gap-1\\.5 {
    gap: .375rem;
  }

  .xl\\:gap-10 {
    gap: 2.5rem;
  }

  .xl\\:gap-1080px {
    gap: var(--coze-1080);
  }

  .xl\\:gap-10px {
    gap: var(--coze-10);
  }

  .xl\\:gap-11 {
    gap: 2.75rem;
  }

  .xl\\:gap-12 {
    gap: 3rem;
  }

  .xl\\:gap-120px {
    gap: var(--coze-120);
  }

  .xl\\:gap-12px {
    gap: var(--coze-12);
  }

  .xl\\:gap-14 {
    gap: 3.5rem;
  }

  .xl\\:gap-14px {
    gap: var(--coze-14);
  }

  .xl\\:gap-15px {
    gap: var(--coze-15);
  }

  .xl\\:gap-16 {
    gap: 4rem;
  }

  .xl\\:gap-160px {
    gap: var(--coze-160);
  }

  .xl\\:gap-16px {
    gap: var(--coze-16);
  }

  .xl\\:gap-18px {
    gap: var(--coze-18);
  }

  .xl\\:gap-1px {
    gap: var(--coze-1);
  }

  .xl\\:gap-2 {
    gap: .5rem;
  }

  .xl\\:gap-2\\.5 {
    gap: .625rem;
  }

  .xl\\:gap-20 {
    gap: 5rem;
  }

  .xl\\:gap-200px {
    gap: var(--coze-200);
  }

  .xl\\:gap-20px {
    gap: var(--coze-20);
  }

  .xl\\:gap-22px {
    gap: var(--coze-22);
  }

  .xl\\:gap-24 {
    gap: 6rem;
  }

  .xl\\:gap-240px {
    gap: var(--coze-240);
  }

  .xl\\:gap-24px {
    gap: var(--coze-24);
  }

  .xl\\:gap-26px {
    gap: var(--coze-26);
  }

  .xl\\:gap-28 {
    gap: 7rem;
  }

  .xl\\:gap-28px {
    gap: var(--coze-28);
  }

  .xl\\:gap-2px {
    gap: var(--coze-2);
  }

  .xl\\:gap-3 {
    gap: .75rem;
  }

  .xl\\:gap-3\\.5 {
    gap: .875rem;
  }

  .xl\\:gap-30px {
    gap: var(--coze-30);
  }

  .xl\\:gap-32 {
    gap: 8rem;
  }

  .xl\\:gap-320px {
    gap: var(--coze-320);
  }

  .xl\\:gap-32px {
    gap: var(--coze-32);
  }

  .xl\\:gap-36 {
    gap: 9rem;
  }

  .xl\\:gap-3px {
    gap: var(--coze-3);
  }

  .xl\\:gap-4 {
    gap: 1rem;
  }

  .xl\\:gap-40 {
    gap: 10rem;
  }

  .xl\\:gap-40px {
    gap: var(--coze-40);
  }

  .xl\\:gap-44 {
    gap: 11rem;
  }

  .xl\\:gap-48 {
    gap: 12rem;
  }

  .xl\\:gap-480px {
    gap: var(--coze-480);
  }

  .xl\\:gap-48px {
    gap: var(--coze-48);
  }

  .xl\\:gap-4px {
    gap: var(--coze-4);
  }

  .xl\\:gap-5 {
    gap: 1.25rem;
  }

  .xl\\:gap-52 {
    gap: 13rem;
  }

  .xl\\:gap-56 {
    gap: 14rem;
  }

  .xl\\:gap-5px {
    gap: var(--coze-5);
  }

  .xl\\:gap-6 {
    gap: 1.5rem;
  }

  .xl\\:gap-60 {
    gap: 15rem;
  }

  .xl\\:gap-64 {
    gap: 16rem;
  }

  .xl\\:gap-640px {
    gap: var(--coze-640);
  }

  .xl\\:gap-64px {
    gap: var(--coze-64);
  }

  .xl\\:gap-6px {
    gap: var(--coze-6);
  }

  .xl\\:gap-7 {
    gap: 1.75rem;
  }

  .xl\\:gap-72 {
    gap: 18rem;
  }

  .xl\\:gap-8 {
    gap: 2rem;
  }

  .xl\\:gap-80 {
    gap: 20rem;
  }

  .xl\\:gap-800px {
    gap: var(--coze-800);
  }

  .xl\\:gap-80px {
    gap: var(--coze-80);
  }

  .xl\\:gap-8px {
    gap: var(--coze-8);
  }

  .xl\\:gap-9 {
    gap: 2.25rem;
  }

  .xl\\:gap-96 {
    gap: 24rem;
  }

  .xl\\:gap-96px {
    gap: var(--coze-96);
  }

  .xl\\:gap-9px {
    gap: var(--coze-9);
  }

  .xl\\:gap-base {
    gap: 16px;
  }

  .xl\\:gap-base-loose {
    gap: 20px;
  }

  .xl\\:gap-base-tight {
    gap: 12px;
  }

  .xl\\:gap-extra-loose {
    gap: 32px;
  }

  .xl\\:gap-extra-tight {
    gap: 4px;
  }

  .xl\\:gap-large {
    gap: var(--coze-40);
  }

  .xl\\:gap-loose {
    gap: 24px;
  }

  .xl\\:gap-md {
    gap: var(--coze-64);
  }

  .xl\\:gap-mini {
    gap: var(--coze-16);
  }

  .xl\\:gap-mm {
    gap: var(--coze-48);
  }

  .xl\\:gap-none {
    gap: 0;
  }

  .xl\\:gap-normal {
    gap: var(--coze-32);
  }

  .xl\\:gap-px {
    gap: 1px;
  }

  .xl\\:gap-small {
    gap: var(--coze-20);
  }

  .xl\\:gap-super-loose {
    gap: 40px;
  }

  .xl\\:gap-super-tight {
    gap: 2px;
  }

  .xl\\:gap-tight {
    gap: 8px;
  }

  .xl\\:gap-xl {
    gap: var(--coze-80);
  }

  .xl\\:gap-xxl {
    gap: var(--coze-96);
  }

  .xl\\:gap-x {
    -moz-column-gap: var(--coze-8);
    column-gap: var(--coze-8);
  }

  .xl\\:gap-x-0 {
    -moz-column-gap: 0px;
    column-gap: 0;
  }

  .xl\\:gap-x-0\\.5 {
    -moz-column-gap: .125rem;
    column-gap: .125rem;
  }

  .xl\\:gap-x-1 {
    -moz-column-gap: .25rem;
    column-gap: .25rem;
  }

  .xl\\:gap-x-1\\.5 {
    -moz-column-gap: .375rem;
    column-gap: .375rem;
  }

  .xl\\:gap-x-10 {
    -moz-column-gap: 2.5rem;
    column-gap: 2.5rem;
  }

  .xl\\:gap-x-1080px {
    -moz-column-gap: var(--coze-1080);
    column-gap: var(--coze-1080);
  }

  .xl\\:gap-x-10px {
    -moz-column-gap: var(--coze-10);
    column-gap: var(--coze-10);
  }

  .xl\\:gap-x-11 {
    -moz-column-gap: 2.75rem;
    column-gap: 2.75rem;
  }

  .xl\\:gap-x-12 {
    -moz-column-gap: 3rem;
    column-gap: 3rem;
  }

  .xl\\:gap-x-120px {
    -moz-column-gap: var(--coze-120);
    column-gap: var(--coze-120);
  }

  .xl\\:gap-x-12px {
    -moz-column-gap: var(--coze-12);
    column-gap: var(--coze-12);
  }

  .xl\\:gap-x-14 {
    -moz-column-gap: 3.5rem;
    column-gap: 3.5rem;
  }

  .xl\\:gap-x-14px {
    -moz-column-gap: var(--coze-14);
    column-gap: var(--coze-14);
  }

  .xl\\:gap-x-15px {
    -moz-column-gap: var(--coze-15);
    column-gap: var(--coze-15);
  }

  .xl\\:gap-x-16 {
    -moz-column-gap: 4rem;
    column-gap: 4rem;
  }

  .xl\\:gap-x-160px {
    -moz-column-gap: var(--coze-160);
    column-gap: var(--coze-160);
  }

  .xl\\:gap-x-16px {
    -moz-column-gap: var(--coze-16);
    column-gap: var(--coze-16);
  }

  .xl\\:gap-x-18px {
    -moz-column-gap: var(--coze-18);
    column-gap: var(--coze-18);
  }

  .xl\\:gap-x-1px {
    -moz-column-gap: var(--coze-1);
    column-gap: var(--coze-1);
  }

  .xl\\:gap-x-2 {
    -moz-column-gap: .5rem;
    column-gap: .5rem;
  }

  .xl\\:gap-x-2\\.5 {
    -moz-column-gap: .625rem;
    column-gap: .625rem;
  }

  .xl\\:gap-x-20 {
    -moz-column-gap: 5rem;
    column-gap: 5rem;
  }

  .xl\\:gap-x-200px {
    -moz-column-gap: var(--coze-200);
    column-gap: var(--coze-200);
  }

  .xl\\:gap-x-20px {
    -moz-column-gap: var(--coze-20);
    column-gap: var(--coze-20);
  }

  .xl\\:gap-x-22px {
    -moz-column-gap: var(--coze-22);
    column-gap: var(--coze-22);
  }

  .xl\\:gap-x-24 {
    -moz-column-gap: 6rem;
    column-gap: 6rem;
  }

  .xl\\:gap-x-240px {
    -moz-column-gap: var(--coze-240);
    column-gap: var(--coze-240);
  }

  .xl\\:gap-x-24px {
    -moz-column-gap: var(--coze-24);
    column-gap: var(--coze-24);
  }

  .xl\\:gap-x-26px {
    -moz-column-gap: var(--coze-26);
    column-gap: var(--coze-26);
  }

  .xl\\:gap-x-28 {
    -moz-column-gap: 7rem;
    column-gap: 7rem;
  }

  .xl\\:gap-x-28px {
    -moz-column-gap: var(--coze-28);
    column-gap: var(--coze-28);
  }

  .xl\\:gap-x-2px {
    -moz-column-gap: var(--coze-2);
    column-gap: var(--coze-2);
  }

  .xl\\:gap-x-3 {
    -moz-column-gap: .75rem;
    column-gap: .75rem;
  }

  .xl\\:gap-x-3\\.5 {
    -moz-column-gap: .875rem;
    column-gap: .875rem;
  }

  .xl\\:gap-x-30px {
    -moz-column-gap: var(--coze-30);
    column-gap: var(--coze-30);
  }

  .xl\\:gap-x-32 {
    -moz-column-gap: 8rem;
    column-gap: 8rem;
  }

  .xl\\:gap-x-320px {
    -moz-column-gap: var(--coze-320);
    column-gap: var(--coze-320);
  }

  .xl\\:gap-x-32px {
    -moz-column-gap: var(--coze-32);
    column-gap: var(--coze-32);
  }

  .xl\\:gap-x-36 {
    -moz-column-gap: 9rem;
    column-gap: 9rem;
  }

  .xl\\:gap-x-3px {
    -moz-column-gap: var(--coze-3);
    column-gap: var(--coze-3);
  }

  .xl\\:gap-x-4 {
    -moz-column-gap: 1rem;
    column-gap: 1rem;
  }

  .xl\\:gap-x-40 {
    -moz-column-gap: 10rem;
    column-gap: 10rem;
  }

  .xl\\:gap-x-40px {
    -moz-column-gap: var(--coze-40);
    column-gap: var(--coze-40);
  }

  .xl\\:gap-x-44 {
    -moz-column-gap: 11rem;
    column-gap: 11rem;
  }

  .xl\\:gap-x-48 {
    -moz-column-gap: 12rem;
    column-gap: 12rem;
  }

  .xl\\:gap-x-480px {
    -moz-column-gap: var(--coze-480);
    column-gap: var(--coze-480);
  }

  .xl\\:gap-x-48px {
    -moz-column-gap: var(--coze-48);
    column-gap: var(--coze-48);
  }

  .xl\\:gap-x-4px {
    -moz-column-gap: var(--coze-4);
    column-gap: var(--coze-4);
  }

  .xl\\:gap-x-5 {
    -moz-column-gap: 1.25rem;
    column-gap: 1.25rem;
  }

  .xl\\:gap-x-52 {
    -moz-column-gap: 13rem;
    column-gap: 13rem;
  }

  .xl\\:gap-x-56 {
    -moz-column-gap: 14rem;
    column-gap: 14rem;
  }

  .xl\\:gap-x-5px {
    -moz-column-gap: var(--coze-5);
    column-gap: var(--coze-5);
  }

  .xl\\:gap-x-6 {
    -moz-column-gap: 1.5rem;
    column-gap: 1.5rem;
  }

  .xl\\:gap-x-60 {
    -moz-column-gap: 15rem;
    column-gap: 15rem;
  }

  .xl\\:gap-x-64 {
    -moz-column-gap: 16rem;
    column-gap: 16rem;
  }

  .xl\\:gap-x-640px {
    -moz-column-gap: var(--coze-640);
    column-gap: var(--coze-640);
  }

  .xl\\:gap-x-64px {
    -moz-column-gap: var(--coze-64);
    column-gap: var(--coze-64);
  }

  .xl\\:gap-x-6px {
    -moz-column-gap: var(--coze-6);
    column-gap: var(--coze-6);
  }

  .xl\\:gap-x-7 {
    -moz-column-gap: 1.75rem;
    column-gap: 1.75rem;
  }

  .xl\\:gap-x-72 {
    -moz-column-gap: 18rem;
    column-gap: 18rem;
  }

  .xl\\:gap-x-8 {
    -moz-column-gap: 2rem;
    column-gap: 2rem;
  }

  .xl\\:gap-x-80 {
    -moz-column-gap: 20rem;
    column-gap: 20rem;
  }

  .xl\\:gap-x-800px {
    -moz-column-gap: var(--coze-800);
    column-gap: var(--coze-800);
  }

  .xl\\:gap-x-80px {
    -moz-column-gap: var(--coze-80);
    column-gap: var(--coze-80);
  }

  .xl\\:gap-x-8px {
    -moz-column-gap: var(--coze-8);
    column-gap: var(--coze-8);
  }

  .xl\\:gap-x-9 {
    -moz-column-gap: 2.25rem;
    column-gap: 2.25rem;
  }

  .xl\\:gap-x-96 {
    -moz-column-gap: 24rem;
    column-gap: 24rem;
  }

  .xl\\:gap-x-96px {
    -moz-column-gap: var(--coze-96);
    column-gap: var(--coze-96);
  }

  .xl\\:gap-x-9px {
    -moz-column-gap: var(--coze-9);
    column-gap: var(--coze-9);
  }

  .xl\\:gap-x-base {
    -moz-column-gap: 16px;
    column-gap: 16px;
  }

  .xl\\:gap-x-base-loose {
    -moz-column-gap: 20px;
    column-gap: 20px;
  }

  .xl\\:gap-x-base-tight {
    -moz-column-gap: 12px;
    column-gap: 12px;
  }

  .xl\\:gap-x-extra-loose {
    -moz-column-gap: 32px;
    column-gap: 32px;
  }

  .xl\\:gap-x-extra-tight {
    -moz-column-gap: 4px;
    column-gap: 4px;
  }

  .xl\\:gap-x-large {
    -moz-column-gap: var(--coze-40);
    column-gap: var(--coze-40);
  }

  .xl\\:gap-x-loose {
    -moz-column-gap: 24px;
    column-gap: 24px;
  }

  .xl\\:gap-x-md {
    -moz-column-gap: var(--coze-64);
    column-gap: var(--coze-64);
  }

  .xl\\:gap-x-mini {
    -moz-column-gap: var(--coze-16);
    column-gap: var(--coze-16);
  }

  .xl\\:gap-x-mm {
    -moz-column-gap: var(--coze-48);
    column-gap: var(--coze-48);
  }

  .xl\\:gap-x-none {
    -moz-column-gap: 0;
    column-gap: 0;
  }

  .xl\\:gap-x-normal {
    -moz-column-gap: var(--coze-32);
    column-gap: var(--coze-32);
  }

  .xl\\:gap-x-px {
    -moz-column-gap: 1px;
    column-gap: 1px;
  }

  .xl\\:gap-x-small {
    -moz-column-gap: var(--coze-20);
    column-gap: var(--coze-20);
  }

  .xl\\:gap-x-super-loose {
    -moz-column-gap: 40px;
    column-gap: 40px;
  }

  .xl\\:gap-x-super-tight {
    -moz-column-gap: 2px;
    column-gap: 2px;
  }

  .xl\\:gap-x-tight {
    -moz-column-gap: 8px;
    column-gap: 8px;
  }

  .xl\\:gap-x-xl {
    -moz-column-gap: var(--coze-80);
    column-gap: var(--coze-80);
  }

  .xl\\:gap-x-xxl {
    -moz-column-gap: var(--coze-96);
    column-gap: var(--coze-96);
  }

  .xl\\:gap-y {
    row-gap: var(--coze-8);
  }

  .xl\\:gap-y-0 {
    row-gap: 0;
  }

  .xl\\:gap-y-0\\.5 {
    row-gap: .125rem;
  }

  .xl\\:gap-y-1 {
    row-gap: .25rem;
  }

  .xl\\:gap-y-1\\.5 {
    row-gap: .375rem;
  }

  .xl\\:gap-y-10 {
    row-gap: 2.5rem;
  }

  .xl\\:gap-y-1080px {
    row-gap: var(--coze-1080);
  }

  .xl\\:gap-y-10px {
    row-gap: var(--coze-10);
  }

  .xl\\:gap-y-11 {
    row-gap: 2.75rem;
  }

  .xl\\:gap-y-12 {
    row-gap: 3rem;
  }

  .xl\\:gap-y-120px {
    row-gap: var(--coze-120);
  }

  .xl\\:gap-y-12px {
    row-gap: var(--coze-12);
  }

  .xl\\:gap-y-14 {
    row-gap: 3.5rem;
  }

  .xl\\:gap-y-14px {
    row-gap: var(--coze-14);
  }

  .xl\\:gap-y-15px {
    row-gap: var(--coze-15);
  }

  .xl\\:gap-y-16 {
    row-gap: 4rem;
  }

  .xl\\:gap-y-160px {
    row-gap: var(--coze-160);
  }

  .xl\\:gap-y-16px {
    row-gap: var(--coze-16);
  }

  .xl\\:gap-y-18px {
    row-gap: var(--coze-18);
  }

  .xl\\:gap-y-1px {
    row-gap: var(--coze-1);
  }

  .xl\\:gap-y-2 {
    row-gap: .5rem;
  }

  .xl\\:gap-y-2\\.5 {
    row-gap: .625rem;
  }

  .xl\\:gap-y-20 {
    row-gap: 5rem;
  }

  .xl\\:gap-y-200px {
    row-gap: var(--coze-200);
  }

  .xl\\:gap-y-20px {
    row-gap: var(--coze-20);
  }

  .xl\\:gap-y-22px {
    row-gap: var(--coze-22);
  }

  .xl\\:gap-y-24 {
    row-gap: 6rem;
  }

  .xl\\:gap-y-240px {
    row-gap: var(--coze-240);
  }

  .xl\\:gap-y-24px {
    row-gap: var(--coze-24);
  }

  .xl\\:gap-y-26px {
    row-gap: var(--coze-26);
  }

  .xl\\:gap-y-28 {
    row-gap: 7rem;
  }

  .xl\\:gap-y-28px {
    row-gap: var(--coze-28);
  }

  .xl\\:gap-y-2px {
    row-gap: var(--coze-2);
  }

  .xl\\:gap-y-3 {
    row-gap: .75rem;
  }

  .xl\\:gap-y-3\\.5 {
    row-gap: .875rem;
  }

  .xl\\:gap-y-30px {
    row-gap: var(--coze-30);
  }

  .xl\\:gap-y-32 {
    row-gap: 8rem;
  }

  .xl\\:gap-y-320px {
    row-gap: var(--coze-320);
  }

  .xl\\:gap-y-32px {
    row-gap: var(--coze-32);
  }

  .xl\\:gap-y-36 {
    row-gap: 9rem;
  }

  .xl\\:gap-y-3px {
    row-gap: var(--coze-3);
  }

  .xl\\:gap-y-4 {
    row-gap: 1rem;
  }

  .xl\\:gap-y-40 {
    row-gap: 10rem;
  }

  .xl\\:gap-y-40px {
    row-gap: var(--coze-40);
  }

  .xl\\:gap-y-44 {
    row-gap: 11rem;
  }

  .xl\\:gap-y-48 {
    row-gap: 12rem;
  }

  .xl\\:gap-y-480px {
    row-gap: var(--coze-480);
  }

  .xl\\:gap-y-48px {
    row-gap: var(--coze-48);
  }

  .xl\\:gap-y-4px {
    row-gap: var(--coze-4);
  }

  .xl\\:gap-y-5 {
    row-gap: 1.25rem;
  }

  .xl\\:gap-y-52 {
    row-gap: 13rem;
  }

  .xl\\:gap-y-56 {
    row-gap: 14rem;
  }

  .xl\\:gap-y-5px {
    row-gap: var(--coze-5);
  }

  .xl\\:gap-y-6 {
    row-gap: 1.5rem;
  }

  .xl\\:gap-y-60 {
    row-gap: 15rem;
  }

  .xl\\:gap-y-64 {
    row-gap: 16rem;
  }

  .xl\\:gap-y-640px {
    row-gap: var(--coze-640);
  }

  .xl\\:gap-y-64px {
    row-gap: var(--coze-64);
  }

  .xl\\:gap-y-6px {
    row-gap: var(--coze-6);
  }

  .xl\\:gap-y-7 {
    row-gap: 1.75rem;
  }

  .xl\\:gap-y-72 {
    row-gap: 18rem;
  }

  .xl\\:gap-y-8 {
    row-gap: 2rem;
  }

  .xl\\:gap-y-80 {
    row-gap: 20rem;
  }

  .xl\\:gap-y-800px {
    row-gap: var(--coze-800);
  }

  .xl\\:gap-y-80px {
    row-gap: var(--coze-80);
  }

  .xl\\:gap-y-8px {
    row-gap: var(--coze-8);
  }

  .xl\\:gap-y-9 {
    row-gap: 2.25rem;
  }

  .xl\\:gap-y-96 {
    row-gap: 24rem;
  }

  .xl\\:gap-y-96px {
    row-gap: var(--coze-96);
  }

  .xl\\:gap-y-9px {
    row-gap: var(--coze-9);
  }

  .xl\\:gap-y-base {
    row-gap: 16px;
  }

  .xl\\:gap-y-base-loose {
    row-gap: 20px;
  }

  .xl\\:gap-y-base-tight {
    row-gap: 12px;
  }

  .xl\\:gap-y-extra-loose {
    row-gap: 32px;
  }

  .xl\\:gap-y-extra-tight {
    row-gap: 4px;
  }

  .xl\\:gap-y-large {
    row-gap: var(--coze-40);
  }

  .xl\\:gap-y-loose {
    row-gap: 24px;
  }

  .xl\\:gap-y-md {
    row-gap: var(--coze-64);
  }

  .xl\\:gap-y-mini {
    row-gap: var(--coze-16);
  }

  .xl\\:gap-y-mm {
    row-gap: var(--coze-48);
  }

  .xl\\:gap-y-none {
    row-gap: 0;
  }

  .xl\\:gap-y-normal {
    row-gap: var(--coze-32);
  }

  .xl\\:gap-y-px {
    row-gap: 1px;
  }

  .xl\\:gap-y-small {
    row-gap: var(--coze-20);
  }

  .xl\\:gap-y-super-loose {
    row-gap: 40px;
  }

  .xl\\:gap-y-super-tight {
    row-gap: 2px;
  }

  .xl\\:gap-y-tight {
    row-gap: 8px;
  }

  .xl\\:gap-y-xl {
    row-gap: var(--coze-80);
  }

  .xl\\:gap-y-xxl {
    row-gap: var(--coze-96);
  }
}

@media (min-width: 1920px) {
  .\\32 xl\\:grid-flow-row {
    grid-auto-flow: row;
  }

  .\\32 xl\\:grid-flow-col {
    grid-auto-flow: column;
  }

  .\\32 xl\\:grid-flow-dense {
    grid-auto-flow: dense;
  }

  .\\32 xl\\:grid-flow-row-dense {
    grid-auto-flow: row dense;
  }

  .\\32 xl\\:grid-flow-col-dense {
    grid-auto-flow: column dense;
  }

  .\\32 xl\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .\\32 xl\\:grid-cols-10 {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }

  .\\32 xl\\:grid-cols-11 {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }

  .\\32 xl\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .\\32 xl\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .\\32 xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .\\32 xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .\\32 xl\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .\\32 xl\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .\\32 xl\\:grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .\\32 xl\\:grid-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }

  .\\32 xl\\:grid-cols-9 {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }

  .\\32 xl\\:grid-cols-none {
    grid-template-columns: none;
  }

  .\\32 xl\\:grid-rows-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }

  .\\32 xl\\:grid-rows-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }

  .\\32 xl\\:grid-rows-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }

  .\\32 xl\\:grid-rows-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }

  .\\32 xl\\:grid-rows-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }

  .\\32 xl\\:grid-rows-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }

  .\\32 xl\\:grid-rows-none {
    grid-template-rows: none;
  }

  .\\32 xl\\:gap-0 {
    gap: 0;
  }

  .\\32 xl\\:gap-0\\.5 {
    gap: .125rem;
  }

  .\\32 xl\\:gap-1 {
    gap: .25rem;
  }

  .\\32 xl\\:gap-1\\.5 {
    gap: .375rem;
  }

  .\\32 xl\\:gap-10 {
    gap: 2.5rem;
  }

  .\\32 xl\\:gap-1080px {
    gap: var(--coze-1080);
  }

  .\\32 xl\\:gap-10px {
    gap: var(--coze-10);
  }

  .\\32 xl\\:gap-11 {
    gap: 2.75rem;
  }

  .\\32 xl\\:gap-12 {
    gap: 3rem;
  }

  .\\32 xl\\:gap-120px {
    gap: var(--coze-120);
  }

  .\\32 xl\\:gap-12px {
    gap: var(--coze-12);
  }

  .\\32 xl\\:gap-14 {
    gap: 3.5rem;
  }

  .\\32 xl\\:gap-14px {
    gap: var(--coze-14);
  }

  .\\32 xl\\:gap-15px {
    gap: var(--coze-15);
  }

  .\\32 xl\\:gap-16 {
    gap: 4rem;
  }

  .\\32 xl\\:gap-160px {
    gap: var(--coze-160);
  }

  .\\32 xl\\:gap-16px {
    gap: var(--coze-16);
  }

  .\\32 xl\\:gap-18px {
    gap: var(--coze-18);
  }

  .\\32 xl\\:gap-1px {
    gap: var(--coze-1);
  }

  .\\32 xl\\:gap-2 {
    gap: .5rem;
  }

  .\\32 xl\\:gap-2\\.5 {
    gap: .625rem;
  }

  .\\32 xl\\:gap-20 {
    gap: 5rem;
  }

  .\\32 xl\\:gap-200px {
    gap: var(--coze-200);
  }

  .\\32 xl\\:gap-20px {
    gap: var(--coze-20);
  }

  .\\32 xl\\:gap-22px {
    gap: var(--coze-22);
  }

  .\\32 xl\\:gap-24 {
    gap: 6rem;
  }

  .\\32 xl\\:gap-240px {
    gap: var(--coze-240);
  }

  .\\32 xl\\:gap-24px {
    gap: var(--coze-24);
  }

  .\\32 xl\\:gap-26px {
    gap: var(--coze-26);
  }

  .\\32 xl\\:gap-28 {
    gap: 7rem;
  }

  .\\32 xl\\:gap-28px {
    gap: var(--coze-28);
  }

  .\\32 xl\\:gap-2px {
    gap: var(--coze-2);
  }

  .\\32 xl\\:gap-3 {
    gap: .75rem;
  }

  .\\32 xl\\:gap-3\\.5 {
    gap: .875rem;
  }

  .\\32 xl\\:gap-30px {
    gap: var(--coze-30);
  }

  .\\32 xl\\:gap-32 {
    gap: 8rem;
  }

  .\\32 xl\\:gap-320px {
    gap: var(--coze-320);
  }

  .\\32 xl\\:gap-32px {
    gap: var(--coze-32);
  }

  .\\32 xl\\:gap-36 {
    gap: 9rem;
  }

  .\\32 xl\\:gap-3px {
    gap: var(--coze-3);
  }

  .\\32 xl\\:gap-4 {
    gap: 1rem;
  }

  .\\32 xl\\:gap-40 {
    gap: 10rem;
  }

  .\\32 xl\\:gap-40px {
    gap: var(--coze-40);
  }

  .\\32 xl\\:gap-44 {
    gap: 11rem;
  }

  .\\32 xl\\:gap-48 {
    gap: 12rem;
  }

  .\\32 xl\\:gap-480px {
    gap: var(--coze-480);
  }

  .\\32 xl\\:gap-48px {
    gap: var(--coze-48);
  }

  .\\32 xl\\:gap-4px {
    gap: var(--coze-4);
  }

  .\\32 xl\\:gap-5 {
    gap: 1.25rem;
  }

  .\\32 xl\\:gap-52 {
    gap: 13rem;
  }

  .\\32 xl\\:gap-56 {
    gap: 14rem;
  }

  .\\32 xl\\:gap-5px {
    gap: var(--coze-5);
  }

  .\\32 xl\\:gap-6 {
    gap: 1.5rem;
  }

  .\\32 xl\\:gap-60 {
    gap: 15rem;
  }

  .\\32 xl\\:gap-64 {
    gap: 16rem;
  }

  .\\32 xl\\:gap-640px {
    gap: var(--coze-640);
  }

  .\\32 xl\\:gap-64px {
    gap: var(--coze-64);
  }

  .\\32 xl\\:gap-6px {
    gap: var(--coze-6);
  }

  .\\32 xl\\:gap-7 {
    gap: 1.75rem;
  }

  .\\32 xl\\:gap-72 {
    gap: 18rem;
  }

  .\\32 xl\\:gap-8 {
    gap: 2rem;
  }

  .\\32 xl\\:gap-80 {
    gap: 20rem;
  }

  .\\32 xl\\:gap-800px {
    gap: var(--coze-800);
  }

  .\\32 xl\\:gap-80px {
    gap: var(--coze-80);
  }

  .\\32 xl\\:gap-8px {
    gap: var(--coze-8);
  }

  .\\32 xl\\:gap-9 {
    gap: 2.25rem;
  }

  .\\32 xl\\:gap-96 {
    gap: 24rem;
  }

  .\\32 xl\\:gap-96px {
    gap: var(--coze-96);
  }

  .\\32 xl\\:gap-9px {
    gap: var(--coze-9);
  }

  .\\32 xl\\:gap-base {
    gap: 16px;
  }

  .\\32 xl\\:gap-base-loose {
    gap: 20px;
  }

  .\\32 xl\\:gap-base-tight {
    gap: 12px;
  }

  .\\32 xl\\:gap-extra-loose {
    gap: 32px;
  }

  .\\32 xl\\:gap-extra-tight {
    gap: 4px;
  }

  .\\32 xl\\:gap-large {
    gap: var(--coze-40);
  }

  .\\32 xl\\:gap-loose {
    gap: 24px;
  }

  .\\32 xl\\:gap-md {
    gap: var(--coze-64);
  }

  .\\32 xl\\:gap-mini {
    gap: var(--coze-16);
  }

  .\\32 xl\\:gap-mm {
    gap: var(--coze-48);
  }

  .\\32 xl\\:gap-none {
    gap: 0;
  }

  .\\32 xl\\:gap-normal {
    gap: var(--coze-32);
  }

  .\\32 xl\\:gap-px {
    gap: 1px;
  }

  .\\32 xl\\:gap-small {
    gap: var(--coze-20);
  }

  .\\32 xl\\:gap-super-loose {
    gap: 40px;
  }

  .\\32 xl\\:gap-super-tight {
    gap: 2px;
  }

  .\\32 xl\\:gap-tight {
    gap: 8px;
  }

  .\\32 xl\\:gap-xl {
    gap: var(--coze-80);
  }

  .\\32 xl\\:gap-xxl {
    gap: var(--coze-96);
  }

  .\\32 xl\\:gap-x {
    -moz-column-gap: var(--coze-8);
    column-gap: var(--coze-8);
  }

  .\\32 xl\\:gap-x-0 {
    -moz-column-gap: 0px;
    column-gap: 0;
  }

  .\\32 xl\\:gap-x-0\\.5 {
    -moz-column-gap: .125rem;
    column-gap: .125rem;
  }

  .\\32 xl\\:gap-x-1 {
    -moz-column-gap: .25rem;
    column-gap: .25rem;
  }

  .\\32 xl\\:gap-x-1\\.5 {
    -moz-column-gap: .375rem;
    column-gap: .375rem;
  }

  .\\32 xl\\:gap-x-10 {
    -moz-column-gap: 2.5rem;
    column-gap: 2.5rem;
  }

  .\\32 xl\\:gap-x-1080px {
    -moz-column-gap: var(--coze-1080);
    column-gap: var(--coze-1080);
  }

  .\\32 xl\\:gap-x-10px {
    -moz-column-gap: var(--coze-10);
    column-gap: var(--coze-10);
  }

  .\\32 xl\\:gap-x-11 {
    -moz-column-gap: 2.75rem;
    column-gap: 2.75rem;
  }

  .\\32 xl\\:gap-x-12 {
    -moz-column-gap: 3rem;
    column-gap: 3rem;
  }

  .\\32 xl\\:gap-x-120px {
    -moz-column-gap: var(--coze-120);
    column-gap: var(--coze-120);
  }

  .\\32 xl\\:gap-x-12px {
    -moz-column-gap: var(--coze-12);
    column-gap: var(--coze-12);
  }

  .\\32 xl\\:gap-x-14 {
    -moz-column-gap: 3.5rem;
    column-gap: 3.5rem;
  }

  .\\32 xl\\:gap-x-14px {
    -moz-column-gap: var(--coze-14);
    column-gap: var(--coze-14);
  }

  .\\32 xl\\:gap-x-15px {
    -moz-column-gap: var(--coze-15);
    column-gap: var(--coze-15);
  }

  .\\32 xl\\:gap-x-16 {
    -moz-column-gap: 4rem;
    column-gap: 4rem;
  }

  .\\32 xl\\:gap-x-160px {
    -moz-column-gap: var(--coze-160);
    column-gap: var(--coze-160);
  }

  .\\32 xl\\:gap-x-16px {
    -moz-column-gap: var(--coze-16);
    column-gap: var(--coze-16);
  }

  .\\32 xl\\:gap-x-18px {
    -moz-column-gap: var(--coze-18);
    column-gap: var(--coze-18);
  }

  .\\32 xl\\:gap-x-1px {
    -moz-column-gap: var(--coze-1);
    column-gap: var(--coze-1);
  }

  .\\32 xl\\:gap-x-2 {
    -moz-column-gap: .5rem;
    column-gap: .5rem;
  }

  .\\32 xl\\:gap-x-2\\.5 {
    -moz-column-gap: .625rem;
    column-gap: .625rem;
  }

  .\\32 xl\\:gap-x-20 {
    -moz-column-gap: 5rem;
    column-gap: 5rem;
  }

  .\\32 xl\\:gap-x-200px {
    -moz-column-gap: var(--coze-200);
    column-gap: var(--coze-200);
  }

  .\\32 xl\\:gap-x-20px {
    -moz-column-gap: var(--coze-20);
    column-gap: var(--coze-20);
  }

  .\\32 xl\\:gap-x-22px {
    -moz-column-gap: var(--coze-22);
    column-gap: var(--coze-22);
  }

  .\\32 xl\\:gap-x-24 {
    -moz-column-gap: 6rem;
    column-gap: 6rem;
  }

  .\\32 xl\\:gap-x-240px {
    -moz-column-gap: var(--coze-240);
    column-gap: var(--coze-240);
  }

  .\\32 xl\\:gap-x-24px {
    -moz-column-gap: var(--coze-24);
    column-gap: var(--coze-24);
  }

  .\\32 xl\\:gap-x-26px {
    -moz-column-gap: var(--coze-26);
    column-gap: var(--coze-26);
  }

  .\\32 xl\\:gap-x-28 {
    -moz-column-gap: 7rem;
    column-gap: 7rem;
  }

  .\\32 xl\\:gap-x-28px {
    -moz-column-gap: var(--coze-28);
    column-gap: var(--coze-28);
  }

  .\\32 xl\\:gap-x-2px {
    -moz-column-gap: var(--coze-2);
    column-gap: var(--coze-2);
  }

  .\\32 xl\\:gap-x-3 {
    -moz-column-gap: .75rem;
    column-gap: .75rem;
  }

  .\\32 xl\\:gap-x-3\\.5 {
    -moz-column-gap: .875rem;
    column-gap: .875rem;
  }

  .\\32 xl\\:gap-x-30px {
    -moz-column-gap: var(--coze-30);
    column-gap: var(--coze-30);
  }

  .\\32 xl\\:gap-x-32 {
    -moz-column-gap: 8rem;
    column-gap: 8rem;
  }

  .\\32 xl\\:gap-x-320px {
    -moz-column-gap: var(--coze-320);
    column-gap: var(--coze-320);
  }

  .\\32 xl\\:gap-x-32px {
    -moz-column-gap: var(--coze-32);
    column-gap: var(--coze-32);
  }

  .\\32 xl\\:gap-x-36 {
    -moz-column-gap: 9rem;
    column-gap: 9rem;
  }

  .\\32 xl\\:gap-x-3px {
    -moz-column-gap: var(--coze-3);
    column-gap: var(--coze-3);
  }

  .\\32 xl\\:gap-x-4 {
    -moz-column-gap: 1rem;
    column-gap: 1rem;
  }

  .\\32 xl\\:gap-x-40 {
    -moz-column-gap: 10rem;
    column-gap: 10rem;
  }

  .\\32 xl\\:gap-x-40px {
    -moz-column-gap: var(--coze-40);
    column-gap: var(--coze-40);
  }

  .\\32 xl\\:gap-x-44 {
    -moz-column-gap: 11rem;
    column-gap: 11rem;
  }

  .\\32 xl\\:gap-x-48 {
    -moz-column-gap: 12rem;
    column-gap: 12rem;
  }

  .\\32 xl\\:gap-x-480px {
    -moz-column-gap: var(--coze-480);
    column-gap: var(--coze-480);
  }

  .\\32 xl\\:gap-x-48px {
    -moz-column-gap: var(--coze-48);
    column-gap: var(--coze-48);
  }

  .\\32 xl\\:gap-x-4px {
    -moz-column-gap: var(--coze-4);
    column-gap: var(--coze-4);
  }

  .\\32 xl\\:gap-x-5 {
    -moz-column-gap: 1.25rem;
    column-gap: 1.25rem;
  }

  .\\32 xl\\:gap-x-52 {
    -moz-column-gap: 13rem;
    column-gap: 13rem;
  }

  .\\32 xl\\:gap-x-56 {
    -moz-column-gap: 14rem;
    column-gap: 14rem;
  }

  .\\32 xl\\:gap-x-5px {
    -moz-column-gap: var(--coze-5);
    column-gap: var(--coze-5);
  }

  .\\32 xl\\:gap-x-6 {
    -moz-column-gap: 1.5rem;
    column-gap: 1.5rem;
  }

  .\\32 xl\\:gap-x-60 {
    -moz-column-gap: 15rem;
    column-gap: 15rem;
  }

  .\\32 xl\\:gap-x-64 {
    -moz-column-gap: 16rem;
    column-gap: 16rem;
  }

  .\\32 xl\\:gap-x-640px {
    -moz-column-gap: var(--coze-640);
    column-gap: var(--coze-640);
  }

  .\\32 xl\\:gap-x-64px {
    -moz-column-gap: var(--coze-64);
    column-gap: var(--coze-64);
  }

  .\\32 xl\\:gap-x-6px {
    -moz-column-gap: var(--coze-6);
    column-gap: var(--coze-6);
  }

  .\\32 xl\\:gap-x-7 {
    -moz-column-gap: 1.75rem;
    column-gap: 1.75rem;
  }

  .\\32 xl\\:gap-x-72 {
    -moz-column-gap: 18rem;
    column-gap: 18rem;
  }

  .\\32 xl\\:gap-x-8 {
    -moz-column-gap: 2rem;
    column-gap: 2rem;
  }

  .\\32 xl\\:gap-x-80 {
    -moz-column-gap: 20rem;
    column-gap: 20rem;
  }

  .\\32 xl\\:gap-x-800px {
    -moz-column-gap: var(--coze-800);
    column-gap: var(--coze-800);
  }

  .\\32 xl\\:gap-x-80px {
    -moz-column-gap: var(--coze-80);
    column-gap: var(--coze-80);
  }

  .\\32 xl\\:gap-x-8px {
    -moz-column-gap: var(--coze-8);
    column-gap: var(--coze-8);
  }

  .\\32 xl\\:gap-x-9 {
    -moz-column-gap: 2.25rem;
    column-gap: 2.25rem;
  }

  .\\32 xl\\:gap-x-96 {
    -moz-column-gap: 24rem;
    column-gap: 24rem;
  }

  .\\32 xl\\:gap-x-96px {
    -moz-column-gap: var(--coze-96);
    column-gap: var(--coze-96);
  }

  .\\32 xl\\:gap-x-9px {
    -moz-column-gap: var(--coze-9);
    column-gap: var(--coze-9);
  }

  .\\32 xl\\:gap-x-base {
    -moz-column-gap: 16px;
    column-gap: 16px;
  }

  .\\32 xl\\:gap-x-base-loose {
    -moz-column-gap: 20px;
    column-gap: 20px;
  }

  .\\32 xl\\:gap-x-base-tight {
    -moz-column-gap: 12px;
    column-gap: 12px;
  }

  .\\32 xl\\:gap-x-extra-loose {
    -moz-column-gap: 32px;
    column-gap: 32px;
  }

  .\\32 xl\\:gap-x-extra-tight {
    -moz-column-gap: 4px;
    column-gap: 4px;
  }

  .\\32 xl\\:gap-x-large {
    -moz-column-gap: var(--coze-40);
    column-gap: var(--coze-40);
  }

  .\\32 xl\\:gap-x-loose {
    -moz-column-gap: 24px;
    column-gap: 24px;
  }

  .\\32 xl\\:gap-x-md {
    -moz-column-gap: var(--coze-64);
    column-gap: var(--coze-64);
  }

  .\\32 xl\\:gap-x-mini {
    -moz-column-gap: var(--coze-16);
    column-gap: var(--coze-16);
  }

  .\\32 xl\\:gap-x-mm {
    -moz-column-gap: var(--coze-48);
    column-gap: var(--coze-48);
  }

  .\\32 xl\\:gap-x-none {
    -moz-column-gap: 0;
    column-gap: 0;
  }

  .\\32 xl\\:gap-x-normal {
    -moz-column-gap: var(--coze-32);
    column-gap: var(--coze-32);
  }

  .\\32 xl\\:gap-x-px {
    -moz-column-gap: 1px;
    column-gap: 1px;
  }

  .\\32 xl\\:gap-x-small {
    -moz-column-gap: var(--coze-20);
    column-gap: var(--coze-20);
  }

  .\\32 xl\\:gap-x-super-loose {
    -moz-column-gap: 40px;
    column-gap: 40px;
  }

  .\\32 xl\\:gap-x-super-tight {
    -moz-column-gap: 2px;
    column-gap: 2px;
  }

  .\\32 xl\\:gap-x-tight {
    -moz-column-gap: 8px;
    column-gap: 8px;
  }

  .\\32 xl\\:gap-x-xl {
    -moz-column-gap: var(--coze-80);
    column-gap: var(--coze-80);
  }

  .\\32 xl\\:gap-x-xxl {
    -moz-column-gap: var(--coze-96);
    column-gap: var(--coze-96);
  }

  .\\32 xl\\:gap-y {
    row-gap: var(--coze-8);
  }

  .\\32 xl\\:gap-y-0 {
    row-gap: 0;
  }

  .\\32 xl\\:gap-y-0\\.5 {
    row-gap: .125rem;
  }

  .\\32 xl\\:gap-y-1 {
    row-gap: .25rem;
  }

  .\\32 xl\\:gap-y-1\\.5 {
    row-gap: .375rem;
  }

  .\\32 xl\\:gap-y-10 {
    row-gap: 2.5rem;
  }

  .\\32 xl\\:gap-y-1080px {
    row-gap: var(--coze-1080);
  }

  .\\32 xl\\:gap-y-10px {
    row-gap: var(--coze-10);
  }

  .\\32 xl\\:gap-y-11 {
    row-gap: 2.75rem;
  }

  .\\32 xl\\:gap-y-12 {
    row-gap: 3rem;
  }

  .\\32 xl\\:gap-y-120px {
    row-gap: var(--coze-120);
  }

  .\\32 xl\\:gap-y-12px {
    row-gap: var(--coze-12);
  }

  .\\32 xl\\:gap-y-14 {
    row-gap: 3.5rem;
  }

  .\\32 xl\\:gap-y-14px {
    row-gap: var(--coze-14);
  }

  .\\32 xl\\:gap-y-15px {
    row-gap: var(--coze-15);
  }

  .\\32 xl\\:gap-y-16 {
    row-gap: 4rem;
  }

  .\\32 xl\\:gap-y-160px {
    row-gap: var(--coze-160);
  }

  .\\32 xl\\:gap-y-16px {
    row-gap: var(--coze-16);
  }

  .\\32 xl\\:gap-y-18px {
    row-gap: var(--coze-18);
  }

  .\\32 xl\\:gap-y-1px {
    row-gap: var(--coze-1);
  }

  .\\32 xl\\:gap-y-2 {
    row-gap: .5rem;
  }

  .\\32 xl\\:gap-y-2\\.5 {
    row-gap: .625rem;
  }

  .\\32 xl\\:gap-y-20 {
    row-gap: 5rem;
  }

  .\\32 xl\\:gap-y-200px {
    row-gap: var(--coze-200);
  }

  .\\32 xl\\:gap-y-20px {
    row-gap: var(--coze-20);
  }

  .\\32 xl\\:gap-y-22px {
    row-gap: var(--coze-22);
  }

  .\\32 xl\\:gap-y-24 {
    row-gap: 6rem;
  }

  .\\32 xl\\:gap-y-240px {
    row-gap: var(--coze-240);
  }

  .\\32 xl\\:gap-y-24px {
    row-gap: var(--coze-24);
  }

  .\\32 xl\\:gap-y-26px {
    row-gap: var(--coze-26);
  }

  .\\32 xl\\:gap-y-28 {
    row-gap: 7rem;
  }

  .\\32 xl\\:gap-y-28px {
    row-gap: var(--coze-28);
  }

  .\\32 xl\\:gap-y-2px {
    row-gap: var(--coze-2);
  }

  .\\32 xl\\:gap-y-3 {
    row-gap: .75rem;
  }

  .\\32 xl\\:gap-y-3\\.5 {
    row-gap: .875rem;
  }

  .\\32 xl\\:gap-y-30px {
    row-gap: var(--coze-30);
  }

  .\\32 xl\\:gap-y-32 {
    row-gap: 8rem;
  }

  .\\32 xl\\:gap-y-320px {
    row-gap: var(--coze-320);
  }

  .\\32 xl\\:gap-y-32px {
    row-gap: var(--coze-32);
  }

  .\\32 xl\\:gap-y-36 {
    row-gap: 9rem;
  }

  .\\32 xl\\:gap-y-3px {
    row-gap: var(--coze-3);
  }

  .\\32 xl\\:gap-y-4 {
    row-gap: 1rem;
  }

  .\\32 xl\\:gap-y-40 {
    row-gap: 10rem;
  }

  .\\32 xl\\:gap-y-40px {
    row-gap: var(--coze-40);
  }

  .\\32 xl\\:gap-y-44 {
    row-gap: 11rem;
  }

  .\\32 xl\\:gap-y-48 {
    row-gap: 12rem;
  }

  .\\32 xl\\:gap-y-480px {
    row-gap: var(--coze-480);
  }

  .\\32 xl\\:gap-y-48px {
    row-gap: var(--coze-48);
  }

  .\\32 xl\\:gap-y-4px {
    row-gap: var(--coze-4);
  }

  .\\32 xl\\:gap-y-5 {
    row-gap: 1.25rem;
  }

  .\\32 xl\\:gap-y-52 {
    row-gap: 13rem;
  }

  .\\32 xl\\:gap-y-56 {
    row-gap: 14rem;
  }

  .\\32 xl\\:gap-y-5px {
    row-gap: var(--coze-5);
  }

  .\\32 xl\\:gap-y-6 {
    row-gap: 1.5rem;
  }

  .\\32 xl\\:gap-y-60 {
    row-gap: 15rem;
  }

  .\\32 xl\\:gap-y-64 {
    row-gap: 16rem;
  }

  .\\32 xl\\:gap-y-640px {
    row-gap: var(--coze-640);
  }

  .\\32 xl\\:gap-y-64px {
    row-gap: var(--coze-64);
  }

  .\\32 xl\\:gap-y-6px {
    row-gap: var(--coze-6);
  }

  .\\32 xl\\:gap-y-7 {
    row-gap: 1.75rem;
  }

  .\\32 xl\\:gap-y-72 {
    row-gap: 18rem;
  }

  .\\32 xl\\:gap-y-8 {
    row-gap: 2rem;
  }

  .\\32 xl\\:gap-y-80 {
    row-gap: 20rem;
  }

  .\\32 xl\\:gap-y-800px {
    row-gap: var(--coze-800);
  }

  .\\32 xl\\:gap-y-80px {
    row-gap: var(--coze-80);
  }

  .\\32 xl\\:gap-y-8px {
    row-gap: var(--coze-8);
  }

  .\\32 xl\\:gap-y-9 {
    row-gap: 2.25rem;
  }

  .\\32 xl\\:gap-y-96 {
    row-gap: 24rem;
  }

  .\\32 xl\\:gap-y-96px {
    row-gap: var(--coze-96);
  }

  .\\32 xl\\:gap-y-9px {
    row-gap: var(--coze-9);
  }

  .\\32 xl\\:gap-y-base {
    row-gap: 16px;
  }

  .\\32 xl\\:gap-y-base-loose {
    row-gap: 20px;
  }

  .\\32 xl\\:gap-y-base-tight {
    row-gap: 12px;
  }

  .\\32 xl\\:gap-y-extra-loose {
    row-gap: 32px;
  }

  .\\32 xl\\:gap-y-extra-tight {
    row-gap: 4px;
  }

  .\\32 xl\\:gap-y-large {
    row-gap: var(--coze-40);
  }

  .\\32 xl\\:gap-y-loose {
    row-gap: 24px;
  }

  .\\32 xl\\:gap-y-md {
    row-gap: var(--coze-64);
  }

  .\\32 xl\\:gap-y-mini {
    row-gap: var(--coze-16);
  }

  .\\32 xl\\:gap-y-mm {
    row-gap: var(--coze-48);
  }

  .\\32 xl\\:gap-y-none {
    row-gap: 0;
  }

  .\\32 xl\\:gap-y-normal {
    row-gap: var(--coze-32);
  }

  .\\32 xl\\:gap-y-px {
    row-gap: 1px;
  }

  .\\32 xl\\:gap-y-small {
    row-gap: var(--coze-20);
  }

  .\\32 xl\\:gap-y-super-loose {
    row-gap: 40px;
  }

  .\\32 xl\\:gap-y-super-tight {
    row-gap: 2px;
  }

  .\\32 xl\\:gap-y-tight {
    row-gap: 8px;
  }

  .\\32 xl\\:gap-y-xl {
    row-gap: var(--coze-80);
  }

  .\\32 xl\\:gap-y-xxl {
    row-gap: var(--coze-96);
  }
}

.\\[\\&\\>\\*\\]\\:h-full > * {
  height: 100%;
}

.\\[\\&\\>\\*\\]\\:w-full > * {
  width: 100%;
}

.\\[\\&\\>div\\]\\:pt-\\[4px\\] > div {
  padding-top: 4px;
}

.\\[\\&\\>path\\]\\:fill-current > path {
  fill: currentColor;
}

.\\[\\&\\[aria-invalid\\]_\\.coz-date-picker-select\\]\\:coz-stroke-hglt-red[aria-invalid] .coz-date-picker-select {
  border-color: rgba(var(--coze-red-5), 1);
}

.\\[\\&_\\.ProseMirror_\\*\\]\\:whitespace-pre-wrap .ProseMirror * {
  white-space: pre-wrap;
}

.\\[\\&_\\.ProseMirror_\\*\\]\\:break-words .ProseMirror * {
  overflow-wrap: break-word;
}

.\\[\\&_\\.coz-date-picker-select\\]\\:w-full .coz-date-picker-select, .\\[\\&_\\.coz-item-text\\]\\:w-full .coz-item-text {
  width: 100%;
}

.\\[\\&_\\.editor-paragraph\\:empty\\]\\:block .editor-paragraph:empty {
  display: block;
}

.\\[\\&_\\.editor-paragraph\\:empty\\]\\:min-h-\\[1\\.5em\\] .editor-paragraph:empty, .\\[\\&_\\.editor-paragraph\\]\\:min-h-\\[1\\.5em\\] .editor-paragraph {
  min-height: 1.5em;
}

.\\[\\&_\\.editor-paragraph\\]\\:leading-normal .editor-paragraph {
  line-height: 1.5;
}

.\\[\\&_\\.option-text-wrapper\\]\\:overflow-hidden .option-text-wrapper {
  overflow: hidden;
}

.\\[\\&_\\.process-progress-item-actions\\]\\:\\!block .process-progress-item-actions {
  display: block !important;
}

.\\[\\&_\\.semi-datepicker-input\\]\\:w-full .semi-datepicker-input {
  width: 100%;
}

.\\[\\&_\\.semi-form-field-error-message\\]\\:absolute .semi-form-field-error-message {
  position: absolute;
}

.\\[\\&_\\.semi-form-field-error-message\\]\\:text-\\[12px\\] .semi-form-field-error-message {
  font-size: 12px;
}

.\\[\\&_\\.semi-form-field-error-message\\]\\:font-\\[400\\] .semi-form-field-error-message {
  font-weight: 400;
}

.\\[\\&_\\.semi-form-field-error-message\\]\\:leading-\\[16px\\] .semi-form-field-error-message {
  line-height: 16px;
}

.\\[\\&_\\.semi-form-field\\]\\:p-0 .semi-form-field {
  padding: 0;
}

.\\[\\&_\\.semi-icon-default\\]\\:h-full .semi-icon-default {
  height: 100%;
}

.\\[\\&_\\.semi-icon-default\\]\\:w-full .semi-icon-default {
  width: 100%;
}

.\\[\\&_\\.semi-input-number-suffix-btns\\]\\:\\!h-auto .semi-input-number-suffix-btns {
  height: auto !important;
}

.\\[\\&_\\.semi-input-wrapper\\.semi-input-wrapper-error\\]\\:coz-stroke-hglt-red .semi-input-wrapper.semi-input-wrapper-error {
  border-color: rgba(var(--coze-red-5), 1);
}

.\\[\\&_\\.semi-input-wrapper\\]\\:overflow-hidden .semi-input-wrapper {
  overflow: hidden;
}

.\\[\\&_\\.semi-input-wrapper\\]\\:\\!coz-stroke-plus .semi-input-wrapper {
  border-color: rgba(var(--coze-stroke-6), var(--coze-stroke-6-alpha)) !important;
}

.\\[\\&_\\.semi-input-wrapper\\]\\:coz-stroke-plus .semi-input-wrapper {
  border-color: rgba(var(--coze-stroke-6), var(--coze-stroke-6-alpha));
}

.focus-within\\:\\[\\&_\\.semi-input-wrapper\\]\\:coz-stroke-hglt .semi-input-wrapper:focus-within {
  border-color: rgba(var(--coze-up-brand-5), 1);
  border-color: rgba(var(--coze-up-brand-9), 1);
}

.\\[\\&_\\.semi-modal-content\\]\\:min-h-\\[520px\\] .semi-modal-content {
  min-height: 520px;
}

.\\[\\&_\\.semi-modal-content\\]\\:\\!px-3 .semi-modal-content {
  padding-left: .75rem !important;
  padding-right: .75rem !important;
}

.\\[\\&_\\.semi-modal-content\\]\\:\\!coz-bg-max .semi-modal-content {
  background-color: rgba(var(--coze-bg-3), var(--coze-bg-3-alpha)) !important;
}

.\\[\\&_\\.semi-modal-footer\\]\\:hidden .semi-modal-footer {
  display: none;
}

.\\[\\&_\\.semi-modal-header\\]\\:flex .semi-modal-header {
  display: flex;
}

.\\[\\&_\\.semi-modal-header\\]\\:items-center .semi-modal-header {
  align-items: center;
}

.\\[\\&_\\.semi-modal-header\\]\\:px-3 .semi-modal-header {
  padding-left: .75rem;
  padding-right: .75rem;
}

.\\[\\&_\\.semi-select-content-wrapper\\]\\:w-full .semi-select-content-wrapper {
  width: 100%;
}

.\\[\\&_\\.semi-select-loading-wrapper\\]\\:text-center .semi-select-loading-wrapper {
  text-align: center;
}

.\\[\\&_\\.semi-select\\]\\:\\!bg-transparent .semi-select {
  background-color: rgba(0, 0, 0, 0) !important;
}

.\\[\\&_\\.semi-steps-item-title\\]\\:\\!max-w-\\[unset\\] .semi-steps-item-title {
  max-width: unset !important;
}

.\\[\\&_\\.semi-steps-item\\]\\:flex-none .semi-steps-item {
  flex: none;
}

.\\[\\&_\\.semi-table-row-cell\\]\\:\\!h-\\[56px\\] .semi-table-row-cell {
  height: 56px !important;
}

.\\[\\&_\\.semi-table-row-cell\\]\\:\\!border-b-0 .semi-table-row-cell {
  border-bottom-width: 0 !important;
  border-bottom-color: rgba(var(--coze-up-stroke-primary), .12) !important;
}

.\\[\\&_\\.semi-table-row-cell\\]\\:\\!bg-transparent .semi-table-row-cell {
  background-color: rgba(0, 0, 0, 0) !important;
}

.\\[\\&_\\.semi-table-row-cell\\]\\:\\!bg-none .semi-table-row-cell {
  background-image: none !important;
}

.\\[\\&_\\.semi-table-row-cell\\]\\:text-\\[14px\\] .semi-table-row-cell {
  font-size: 14px;
}

.\\[\\&_\\.semi-table-row-head\\]\\:\\!border-b-\\[1px\\] .semi-table-row-head {
  border-bottom-width: 1px !important;
}

.\\[\\&_\\.semi-table-row-head\\]\\:\\!bg-transparent .semi-table-row-head, .\\[\\&_\\.semi-table-row\\]\\:\\!bg-transparent .semi-table-row {
  background-color: rgba(0, 0, 0, 0) !important;
}

.\\[\\&_\\.semi-tabs-content\\]\\:grow .semi-tabs-content {
  flex-grow: 1;
}

.\\[\\&_\\.semi-tabs-content\\]\\:overflow-hidden .semi-tabs-content {
  overflow: hidden;
}

.\\[\\&_\\.semi-tabs-content\\]\\:p-0 .semi-tabs-content {
  padding: 0;
}

.\\[\\&_\\.semi-tabs-pane-active\\]\\:h-full .semi-tabs-pane-active, .\\[\\&_\\.semi-tabs-pane-motion-overlay\\]\\:h-full .semi-tabs-pane-motion-overlay {
  height: 100%;
}

.\\[\\&_\\.semi-tabs-pane-motion-overlay\\]\\:overflow-auto .semi-tabs-pane-motion-overlay {
  overflow: auto;
}

.\\[\\&_\\.semi-tag-content\\]\\:font-medium .semi-tag-content {
  font-weight: 500;
}

.\\[\\&_\\.semi-tooltip-content\\]\\:line-clamp-5 .semi-tooltip-content {
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
}

.\\[\\&_\\.semi-tooltip-content\\]\\:max-h-\\[110px\\] .semi-tooltip-content {
  max-height: 110px;
}

.\\[\\&_\\.semi-tree-option-list-block_\\.semi-tree-option\\:active\\]\\:bg-transparent .semi-tree-option-list-block .semi-tree-option:active {
  background-color: rgba(0, 0, 0, 0);
}

.\\[\\&_\\.semi-tree-option-list-block_\\.semi-tree-option\\:hover\\]\\:bg-inherit .semi-tree-option-list-block .semi-tree-option:hover {
  background-color: inherit;
}

.\\[\\&_\\.semi-tree-option-list-block_\\.semi-tree-option\\:hover\\]\\:bg-transparent .semi-tree-option-list-block .semi-tree-option:hover {
  background-color: rgba(0, 0, 0, 0);
}

.\\[\\&_\\.semi-tree-option-list\\>div\\:first-child\\]\\:mt-0 .semi-tree-option-list > div:first-child {
  margin-top: 0;
}

.\\[\\&_\\.semi-tree-option-list\\]\\:overflow-visible .semi-tree-option-list {
  overflow: visible;
}

.\\[\\&_\\.semi-tree-option-list\\]\\:p-0 .semi-tree-option-list {
  padding: 0;
}

.\\[\\&_\\.semi-tree-option\\]\\:\\!pl-2 .semi-tree-option {
  padding-left: .5rem !important;
}

.\\[\\&_\\.semi-upload-drag-area\\]\\:\\!h-\\[290px\\] .semi-upload-drag-area {
  height: 290px !important;
}

.\\[\\&_img\\.ProseMirror-selectednode\\]\\:shadow-md img.ProseMirror-selectednode {
  --tw-shadow: 0 4px 6px -1px rgba(0, 0, 0, .1), 0 2px 4px -2px rgba(0, 0, 0, .1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}

.\\[\\&_img\\.ProseMirror-selectednode\\]\\:outline img.ProseMirror-selectednode {
  outline-style: solid;
}

.\\[\\&_img\\.ProseMirror-selectednode\\]\\:outline-2 img.ProseMirror-selectednode {
  outline-width: 2px;
}

.\\[\\&_img\\.ProseMirror-selectednode\\]\\:outline-blue-500 img.ProseMirror-selectednode {
  outline-color: #3b82f6;
}

.\\[\\&_img\\]\\:relative img {
  position: relative;
}

.\\[\\&_img\\]\\:my-3 img {
  margin-top: .75rem;
  margin-bottom: .75rem;
}

.\\[\\&_img\\]\\:block img {
  display: block;
}

.\\[\\&_img\\]\\:max-h-\\[367px\\] img {
  max-height: 367px;
}

.\\[\\&_img\\]\\:w-auto img {
  width: auto;
}

.\\[\\&_img\\]\\:max-w-\\[610px\\] img {
  max-width: 610px;
}

.\\[\\&_img\\]\\:rounded-md img {
  border-radius: var(--coze-12);
}

.\\[\\&_img\\]\\:bg-white img {
  background-color: rgb(var(--white-1));
}

.\\[\\&_p\\]\\:whitespace-pre-wrap p {
  white-space: pre-wrap;
}

.\\[\\&_p\\]\\:break-words p {
  overflow-wrap: break-word;
}

.\\[\\&_svg\\]\\:h-full svg {
  height: 100%;
}

.\\[\\&_svg\\]\\:w-full svg {
  width: 100%;
}

.\\[\\&_table\\]\\:m-0 table {
  margin: 0;
}

.\\[\\&_table\\]\\:w-full table {
  width: 100%;
}

.\\[\\&_table\\]\\:table-fixed table {
  table-layout: fixed;
}

.\\[\\&_table\\]\\:border-collapse table {
  border-collapse: collapse;
}

.\\[\\&_table\\]\\:overflow-hidden table {
  overflow: hidden;
}

.\\[\\&_table\\]\\:text-\\[0\\.9em\\] table {
  font-size: .9em;
}

.\\[\\&_table_td\\]\\:relative table td {
  position: relative;
}

.\\[\\&_table_td\\]\\:box-border table td {
  box-sizing: border-box;
}

.\\[\\&_table_td\\]\\:min-w-\\[100px\\] table td {
  min-width: 100px;
}

.\\[\\&_table_td\\]\\:border table td {
  border-width: var(--coze-1);
}

.\\[\\&_table_td\\]\\:border-solid table td {
  border-style: solid;
}

.\\[\\&_table_td\\]\\:border-\\[\\#ddd\\] table td {
  --tw-border-opacity: 1;
  border-color: rgba(221, 221, 221, var(--tw-border-opacity));
}

.\\[\\&_table_td\\]\\:p-2 table td {
  padding: .5rem;
}

.\\[\\&_table_td\\]\\:align-top table td {
  vertical-align: top;
}

.\\[\\&_table_th\\]\\:relative table th {
  position: relative;
}

.\\[\\&_table_th\\]\\:box-border table th {
  box-sizing: border-box;
}

.\\[\\&_table_th\\]\\:min-w-\\[100px\\] table th {
  min-width: 100px;
}

.\\[\\&_table_th\\]\\:border table th {
  border-width: var(--coze-1);
}

.\\[\\&_table_th\\]\\:border-solid table th {
  border-style: solid;
}

.\\[\\&_table_th\\]\\:border-\\[\\#ddd\\] table th {
  --tw-border-opacity: 1;
  border-color: rgba(221, 221, 221, var(--tw-border-opacity));
}

.\\[\\&_table_th\\]\\:p-2 table th {
  padding: .5rem;
}

.\\[\\&_table_th\\]\\:align-top table th {
  vertical-align: top;
}

@media (min-width: 1600px) {
  .\\[\\@media\\(min-width\\:1600px\\)\\]\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
